(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb877"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb877"] = parcelRequire;
}
parcelRequire.register("jIgWH", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $e59f457751cca0bb$export$ffb0004e005737fa; }, function (v) { return $e59f457751cca0bb$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $e59f457751cca0bb$export$34b9dba7ce09269b; }, function (v) { return $e59f457751cca0bb$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $e59f457751cca0bb$export$25062201e9e25d76; }, function (v) { return $e59f457751cca0bb$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e59f457751cca0bb$export$ffb0004e005737fa;
var $e59f457751cca0bb$export$34b9dba7ce09269b;
var $e59f457751cca0bb$export$25062201e9e25d76;
"use strict";

var $dQFEZ = parcelRequire("dQFEZ");
var $e59f457751cca0bb$var$k = Symbol.for("react.element"), $e59f457751cca0bb$var$l = Symbol.for("react.fragment"), $e59f457751cca0bb$var$m = Object.prototype.hasOwnProperty, $e59f457751cca0bb$var$n = $dQFEZ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $e59f457751cca0bb$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $e59f457751cca0bb$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$e59f457751cca0bb$var$m.call(a, b) && !$e59f457751cca0bb$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $e59f457751cca0bb$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $e59f457751cca0bb$var$n.current
    };
}
$e59f457751cca0bb$export$ffb0004e005737fa = $e59f457751cca0bb$var$l;
$e59f457751cca0bb$export$34b9dba7ce09269b = $e59f457751cca0bb$var$q;
$e59f457751cca0bb$export$25062201e9e25d76 = $e59f457751cca0bb$var$q;

});
parcelRequire.register("dQFEZ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4SjaJ"));

});
parcelRequire.register("4SjaJ", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $38cb13c5a0250553$export$dca3b0875bd9a954; }, function (v) { return $38cb13c5a0250553$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $38cb13c5a0250553$export$16fa2f45be04daa8; }, function (v) { return $38cb13c5a0250553$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $38cb13c5a0250553$export$ffb0004e005737fa; }, function (v) { return $38cb13c5a0250553$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $38cb13c5a0250553$export$e2c29f18771995cb; }, function (v) { return $38cb13c5a0250553$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $38cb13c5a0250553$export$221d75b3f55bb0bd; }, function (v) { return $38cb13c5a0250553$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $38cb13c5a0250553$export$5f8d39834fd61797; }, function (v) { return $38cb13c5a0250553$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $38cb13c5a0250553$export$74bf444e3cd11ea5; }, function (v) { return $38cb13c5a0250553$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $38cb13c5a0250553$export$ae55be85d98224ed; }, function (v) { return $38cb13c5a0250553$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $38cb13c5a0250553$export$e530037191fcd5d7; }, function (v) { return $38cb13c5a0250553$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $38cb13c5a0250553$export$fd42f52fd3ae1109; }, function (v) { return $38cb13c5a0250553$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $38cb13c5a0250553$export$c8a8987d4410bf2d; }, function (v) { return $38cb13c5a0250553$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $38cb13c5a0250553$export$d38cd72104c1f0e9; }, function (v) { return $38cb13c5a0250553$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $38cb13c5a0250553$export$7d1e3a5e95ceca43; }, function (v) { return $38cb13c5a0250553$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $38cb13c5a0250553$export$257a8862b851cb5b; }, function (v) { return $38cb13c5a0250553$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $38cb13c5a0250553$export$a8257692ac88316c; }, function (v) { return $38cb13c5a0250553$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $38cb13c5a0250553$export$488013bae63b21da; }, function (v) { return $38cb13c5a0250553$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $38cb13c5a0250553$export$7c73462e0d25e514; }, function (v) { return $38cb13c5a0250553$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $38cb13c5a0250553$export$7568632d0d33d16d; }, function (v) { return $38cb13c5a0250553$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $38cb13c5a0250553$export$88948ce120ea2619; }, function (v) { return $38cb13c5a0250553$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $38cb13c5a0250553$export$35808ee640e87ca7; }, function (v) { return $38cb13c5a0250553$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $38cb13c5a0250553$export$fae74005e78b1a27; }, function (v) { return $38cb13c5a0250553$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $38cb13c5a0250553$export$dc8fbce3eb94dc1e; }, function (v) { return $38cb13c5a0250553$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $38cb13c5a0250553$export$6a7bc4e911dc01cf; }, function (v) { return $38cb13c5a0250553$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $38cb13c5a0250553$export$6d9c69b0de29b591; }, function (v) { return $38cb13c5a0250553$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $38cb13c5a0250553$export$f680877a34711e37; }, function (v) { return $38cb13c5a0250553$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $38cb13c5a0250553$export$d5a552a76deda3c2; }, function (v) { return $38cb13c5a0250553$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $38cb13c5a0250553$export$aaabe4eda9ed9969; }, function (v) { return $38cb13c5a0250553$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $38cb13c5a0250553$export$e5c5a5f917a5871c; }, function (v) { return $38cb13c5a0250553$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $38cb13c5a0250553$export$1538c33de8887b59; }, function (v) { return $38cb13c5a0250553$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $38cb13c5a0250553$export$13e3392192263954; }, function (v) { return $38cb13c5a0250553$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $38cb13c5a0250553$export$b8f5890fc79d6aca; }, function (v) { return $38cb13c5a0250553$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $38cb13c5a0250553$export$60241385465d0a34; }, function (v) { return $38cb13c5a0250553$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $38cb13c5a0250553$export$306c0aa65ff9ec16; }, function (v) { return $38cb13c5a0250553$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $38cb13c5a0250553$export$7b286972b8d8ccbf; }, function (v) { return $38cb13c5a0250553$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $38cb13c5a0250553$export$83d89fbfd8236492; }, function (v) { return $38cb13c5a0250553$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $bJtXW = parcelRequire("bJtXW");
var $38cb13c5a0250553$export$dca3b0875bd9a954;
var $38cb13c5a0250553$export$16fa2f45be04daa8;
var $38cb13c5a0250553$export$ffb0004e005737fa;
var $38cb13c5a0250553$export$e2c29f18771995cb;
var $38cb13c5a0250553$export$221d75b3f55bb0bd;
var $38cb13c5a0250553$export$5f8d39834fd61797;
var $38cb13c5a0250553$export$74bf444e3cd11ea5;
var $38cb13c5a0250553$export$ae55be85d98224ed;
var $38cb13c5a0250553$export$e530037191fcd5d7;
var $38cb13c5a0250553$export$fd42f52fd3ae1109;
var $38cb13c5a0250553$export$c8a8987d4410bf2d;
var $38cb13c5a0250553$export$d38cd72104c1f0e9;
var $38cb13c5a0250553$export$7d1e3a5e95ceca43;
var $38cb13c5a0250553$export$257a8862b851cb5b;
var $38cb13c5a0250553$export$a8257692ac88316c;
var $38cb13c5a0250553$export$488013bae63b21da;
var $38cb13c5a0250553$export$7c73462e0d25e514;
var $38cb13c5a0250553$export$7568632d0d33d16d;
var $38cb13c5a0250553$export$88948ce120ea2619;
var $38cb13c5a0250553$export$35808ee640e87ca7;
var $38cb13c5a0250553$export$fae74005e78b1a27;
var $38cb13c5a0250553$export$dc8fbce3eb94dc1e;
var $38cb13c5a0250553$export$6a7bc4e911dc01cf;
var $38cb13c5a0250553$export$6d9c69b0de29b591;
var $38cb13c5a0250553$export$f680877a34711e37;
var $38cb13c5a0250553$export$d5a552a76deda3c2;
var $38cb13c5a0250553$export$aaabe4eda9ed9969;
var $38cb13c5a0250553$export$e5c5a5f917a5871c;
var $38cb13c5a0250553$export$1538c33de8887b59;
var $38cb13c5a0250553$export$13e3392192263954;
var $38cb13c5a0250553$export$b8f5890fc79d6aca;
var $38cb13c5a0250553$export$60241385465d0a34;
var $38cb13c5a0250553$export$306c0aa65ff9ec16;
var $38cb13c5a0250553$export$7b286972b8d8ccbf;
var $38cb13c5a0250553$export$83d89fbfd8236492;
"use strict";
var $38cb13c5a0250553$var$l = Symbol.for("react.element"), $38cb13c5a0250553$var$n = Symbol.for("react.portal"), $38cb13c5a0250553$var$p = Symbol.for("react.fragment"), $38cb13c5a0250553$var$q = Symbol.for("react.strict_mode"), $38cb13c5a0250553$var$r = Symbol.for("react.profiler"), $38cb13c5a0250553$var$t = Symbol.for("react.provider"), $38cb13c5a0250553$var$u = Symbol.for("react.context"), $38cb13c5a0250553$var$v = Symbol.for("react.forward_ref"), $38cb13c5a0250553$var$w = Symbol.for("react.suspense"), $38cb13c5a0250553$var$x = Symbol.for("react.memo"), $38cb13c5a0250553$var$y = Symbol.for("react.lazy"), $38cb13c5a0250553$var$z = Symbol.iterator;
function $38cb13c5a0250553$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $38cb13c5a0250553$var$z && a[$38cb13c5a0250553$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $38cb13c5a0250553$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $38cb13c5a0250553$var$C = Object.assign, $38cb13c5a0250553$var$D = {};
function $38cb13c5a0250553$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $38cb13c5a0250553$var$D;
    this.updater = e || $38cb13c5a0250553$var$B;
}
$38cb13c5a0250553$var$E.prototype.isReactComponent = {};
$38cb13c5a0250553$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$38cb13c5a0250553$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $38cb13c5a0250553$var$F() {}
$38cb13c5a0250553$var$F.prototype = $38cb13c5a0250553$var$E.prototype;
function $38cb13c5a0250553$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $38cb13c5a0250553$var$D;
    this.updater = e || $38cb13c5a0250553$var$B;
}
var $38cb13c5a0250553$var$H = $38cb13c5a0250553$var$G.prototype = new $38cb13c5a0250553$var$F;
$38cb13c5a0250553$var$H.constructor = $38cb13c5a0250553$var$G;
$38cb13c5a0250553$var$C($38cb13c5a0250553$var$H, $38cb13c5a0250553$var$E.prototype);
$38cb13c5a0250553$var$H.isPureReactComponent = !0;
var $38cb13c5a0250553$var$I = Array.isArray, $38cb13c5a0250553$var$J = Object.prototype.hasOwnProperty, $38cb13c5a0250553$var$K = {
    current: null
}, $38cb13c5a0250553$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $38cb13c5a0250553$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$38cb13c5a0250553$var$J.call(b, d) && !$38cb13c5a0250553$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $38cb13c5a0250553$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $38cb13c5a0250553$var$K.current
    };
}
function $38cb13c5a0250553$var$N(a, b) {
    return {
        $$typeof: $38cb13c5a0250553$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $38cb13c5a0250553$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $38cb13c5a0250553$var$l;
}
function $38cb13c5a0250553$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $38cb13c5a0250553$var$P = /\/+/g;
function $38cb13c5a0250553$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $38cb13c5a0250553$var$escape("" + a.key) : b.toString(36);
}
function $38cb13c5a0250553$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $38cb13c5a0250553$var$l:
                case $38cb13c5a0250553$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $38cb13c5a0250553$var$Q(h, 0) : d, $38cb13c5a0250553$var$I(c) ? (e = "", null != a && (e = a.replace($38cb13c5a0250553$var$P, "$&/") + "/"), $38cb13c5a0250553$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($38cb13c5a0250553$var$O(c) && (c = $38cb13c5a0250553$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($38cb13c5a0250553$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($38cb13c5a0250553$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $38cb13c5a0250553$var$Q(k, g);
        h += $38cb13c5a0250553$var$R(k, b, e, f, c);
    }
    else if (f = $38cb13c5a0250553$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $38cb13c5a0250553$var$Q(k, g++), h += $38cb13c5a0250553$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $38cb13c5a0250553$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $38cb13c5a0250553$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $38cb13c5a0250553$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $38cb13c5a0250553$var$U = {
    current: null
}, $38cb13c5a0250553$var$V = {
    transition: null
}, $38cb13c5a0250553$var$W = {
    ReactCurrentDispatcher: $38cb13c5a0250553$var$U,
    ReactCurrentBatchConfig: $38cb13c5a0250553$var$V,
    ReactCurrentOwner: $38cb13c5a0250553$var$K
};
$38cb13c5a0250553$export$dca3b0875bd9a954 = {
    map: $38cb13c5a0250553$var$S,
    forEach: function forEach(a, b, e) {
        $38cb13c5a0250553$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $38cb13c5a0250553$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $38cb13c5a0250553$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$38cb13c5a0250553$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$38cb13c5a0250553$export$16fa2f45be04daa8 = $38cb13c5a0250553$var$E;
$38cb13c5a0250553$export$ffb0004e005737fa = $38cb13c5a0250553$var$p;
$38cb13c5a0250553$export$e2c29f18771995cb = $38cb13c5a0250553$var$r;
$38cb13c5a0250553$export$221d75b3f55bb0bd = $38cb13c5a0250553$var$G;
$38cb13c5a0250553$export$5f8d39834fd61797 = $38cb13c5a0250553$var$q;
$38cb13c5a0250553$export$74bf444e3cd11ea5 = $38cb13c5a0250553$var$w;
$38cb13c5a0250553$export$ae55be85d98224ed = $38cb13c5a0250553$var$W;
$38cb13c5a0250553$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $38cb13c5a0250553$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $38cb13c5a0250553$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$38cb13c5a0250553$var$J.call(b, f) && !$38cb13c5a0250553$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $38cb13c5a0250553$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$38cb13c5a0250553$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $38cb13c5a0250553$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $38cb13c5a0250553$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$38cb13c5a0250553$export$c8a8987d4410bf2d = $38cb13c5a0250553$var$M;
$38cb13c5a0250553$export$d38cd72104c1f0e9 = function(a) {
    var b = $38cb13c5a0250553$var$M.bind(null, a);
    b.type = a;
    return b;
};
$38cb13c5a0250553$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$38cb13c5a0250553$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $38cb13c5a0250553$var$v,
        render: a
    };
};
$38cb13c5a0250553$export$a8257692ac88316c = $38cb13c5a0250553$var$O;
$38cb13c5a0250553$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $38cb13c5a0250553$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $38cb13c5a0250553$var$T
    };
};
$38cb13c5a0250553$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $38cb13c5a0250553$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$38cb13c5a0250553$export$7568632d0d33d16d = function(a) {
    var b = $38cb13c5a0250553$var$V.transition;
    $38cb13c5a0250553$var$V.transition = {};
    try {
        a();
    } finally{
        $38cb13c5a0250553$var$V.transition = b;
    }
};
$38cb13c5a0250553$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$38cb13c5a0250553$export$35808ee640e87ca7 = function(a, b) {
    return $38cb13c5a0250553$var$U.current.useCallback(a, b);
};
$38cb13c5a0250553$export$fae74005e78b1a27 = function(a) {
    return $38cb13c5a0250553$var$U.current.useContext(a);
};
$38cb13c5a0250553$export$dc8fbce3eb94dc1e = function() {};
$38cb13c5a0250553$export$6a7bc4e911dc01cf = function(a) {
    return $38cb13c5a0250553$var$U.current.useDeferredValue(a);
};
$38cb13c5a0250553$export$6d9c69b0de29b591 = function(a, b) {
    return $38cb13c5a0250553$var$U.current.useEffect(a, b);
};
$38cb13c5a0250553$export$f680877a34711e37 = function() {
    return $38cb13c5a0250553$var$U.current.useId();
};
$38cb13c5a0250553$export$d5a552a76deda3c2 = function(a, b, e) {
    return $38cb13c5a0250553$var$U.current.useImperativeHandle(a, b, e);
};
$38cb13c5a0250553$export$aaabe4eda9ed9969 = function(a, b) {
    return $38cb13c5a0250553$var$U.current.useInsertionEffect(a, b);
};
$38cb13c5a0250553$export$e5c5a5f917a5871c = function(a, b) {
    return $38cb13c5a0250553$var$U.current.useLayoutEffect(a, b);
};
$38cb13c5a0250553$export$1538c33de8887b59 = function(a, b) {
    return $38cb13c5a0250553$var$U.current.useMemo(a, b);
};
$38cb13c5a0250553$export$13e3392192263954 = function(a, b, e) {
    return $38cb13c5a0250553$var$U.current.useReducer(a, b, e);
};
$38cb13c5a0250553$export$b8f5890fc79d6aca = function(a) {
    return $38cb13c5a0250553$var$U.current.useRef(a);
};
$38cb13c5a0250553$export$60241385465d0a34 = function(a) {
    return $38cb13c5a0250553$var$U.current.useState(a);
};
$38cb13c5a0250553$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $38cb13c5a0250553$var$U.current.useSyncExternalStore(a, b, e);
};
$38cb13c5a0250553$export$7b286972b8d8ccbf = function() {
    return $38cb13c5a0250553$var$U.current.useTransition();
};
$38cb13c5a0250553$export$83d89fbfd8236492 = "18.2.0";

});
parcelRequire.register("bJtXW", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $88ab244363eded38$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $88ab244363eded38$export$5f0017c582d45a2d; });
function $88ab244363eded38$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});




parcelRequire.register("gZreO", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $0331271bace68e97$export$ae55be85d98224ed; }, function (v) { return $0331271bace68e97$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $0331271bace68e97$export$d39a5bbd09211389; }, function (v) { return $0331271bace68e97$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $0331271bace68e97$export$882461b6382ed46c; }, function (v) { return $0331271bace68e97$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $0331271bace68e97$export$466bfc07425424d5; }, function (v) { return $0331271bace68e97$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $0331271bace68e97$export$cd75ccfd720a3cd4; }, function (v) { return $0331271bace68e97$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $0331271bace68e97$export$fa8d919ba61d84db; }, function (v) { return $0331271bace68e97$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $0331271bace68e97$export$757ceba2d55c277e; }, function (v) { return $0331271bace68e97$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $0331271bace68e97$export$b3890eb0ae9dca99; }, function (v) { return $0331271bace68e97$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $0331271bace68e97$export$502457920280e6be; }, function (v) { return $0331271bace68e97$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $0331271bace68e97$export$c78a37762a8d58e1; }, function (v) { return $0331271bace68e97$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $0331271bace68e97$export$dc54d992c10e8a18; }, function (v) { return $0331271bace68e97$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $0331271bace68e97$export$83d89fbfd8236492; }, function (v) { return $0331271bace68e97$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $bJtXW = parcelRequire("bJtXW");
var $0331271bace68e97$export$ae55be85d98224ed;
var $0331271bace68e97$export$d39a5bbd09211389;
var $0331271bace68e97$export$882461b6382ed46c;
var $0331271bace68e97$export$466bfc07425424d5;
var $0331271bace68e97$export$cd75ccfd720a3cd4;
var $0331271bace68e97$export$fa8d919ba61d84db;
var $0331271bace68e97$export$757ceba2d55c277e;
var $0331271bace68e97$export$b3890eb0ae9dca99;
var $0331271bace68e97$export$502457920280e6be;
var $0331271bace68e97$export$c78a37762a8d58e1;
var $0331271bace68e97$export$dc54d992c10e8a18;
var $0331271bace68e97$export$83d89fbfd8236492;
"use strict";

var $dQFEZ = parcelRequire("dQFEZ");

var $1iyD5 = parcelRequire("1iyD5");
function $0331271bace68e97$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0331271bace68e97$var$da = new Set, $0331271bace68e97$var$ea = {};
function $0331271bace68e97$var$fa(a, b) {
    $0331271bace68e97$var$ha(a, b);
    $0331271bace68e97$var$ha(a + "Capture", b);
}
function $0331271bace68e97$var$ha(a, b) {
    $0331271bace68e97$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0331271bace68e97$var$da.add(b[a]);
}
var $0331271bace68e97$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0331271bace68e97$var$ja = Object.prototype.hasOwnProperty, $0331271bace68e97$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0331271bace68e97$var$la = {}, $0331271bace68e97$var$ma = {};
function $0331271bace68e97$var$oa(a) {
    if ($0331271bace68e97$var$ja.call($0331271bace68e97$var$ma, a)) return !0;
    if ($0331271bace68e97$var$ja.call($0331271bace68e97$var$la, a)) return !1;
    if ($0331271bace68e97$var$ka.test(a)) return $0331271bace68e97$var$ma[a] = !0;
    $0331271bace68e97$var$la[a] = !0;
    return !1;
}
function $0331271bace68e97$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $bJtXW._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0331271bace68e97$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0331271bace68e97$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0331271bace68e97$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0331271bace68e97$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0331271bace68e97$var$z[b] = new $0331271bace68e97$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0331271bace68e97$var$ra = /[\-:]([a-z])/g;
function $0331271bace68e97$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0331271bace68e97$var$ra, $0331271bace68e97$var$sa);
    $0331271bace68e97$var$z[b] = new $0331271bace68e97$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0331271bace68e97$var$ra, $0331271bace68e97$var$sa);
    $0331271bace68e97$var$z[b] = new $0331271bace68e97$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0331271bace68e97$var$ra, $0331271bace68e97$var$sa);
    $0331271bace68e97$var$z[b] = new $0331271bace68e97$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0331271bace68e97$var$z.xlinkHref = new $0331271bace68e97$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0331271bace68e97$var$ta(a, b, c, d) {
    var e = $0331271bace68e97$var$z.hasOwnProperty(b) ? $0331271bace68e97$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0331271bace68e97$var$qa(b, c, e, d) && (c = null), d || null === e ? $0331271bace68e97$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0331271bace68e97$var$ua = $dQFEZ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0331271bace68e97$var$va = Symbol.for("react.element"), $0331271bace68e97$var$wa = Symbol.for("react.portal"), $0331271bace68e97$var$ya = Symbol.for("react.fragment"), $0331271bace68e97$var$za = Symbol.for("react.strict_mode"), $0331271bace68e97$var$Aa = Symbol.for("react.profiler"), $0331271bace68e97$var$Ba = Symbol.for("react.provider"), $0331271bace68e97$var$Ca = Symbol.for("react.context"), $0331271bace68e97$var$Da = Symbol.for("react.forward_ref"), $0331271bace68e97$var$Ea = Symbol.for("react.suspense"), $0331271bace68e97$var$Fa = Symbol.for("react.suspense_list"), $0331271bace68e97$var$Ga = Symbol.for("react.memo"), $0331271bace68e97$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0331271bace68e97$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0331271bace68e97$var$Ja = Symbol.iterator;
function $0331271bace68e97$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0331271bace68e97$var$Ja && a[$0331271bace68e97$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0331271bace68e97$var$A = Object.assign, $0331271bace68e97$var$La;
function $0331271bace68e97$var$Ma(a) {
    if (void 0 === $0331271bace68e97$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0331271bace68e97$var$La = b && b[1] || "";
    }
    return "\n" + $0331271bace68e97$var$La + a;
}
var $0331271bace68e97$var$Na = !1;
function $0331271bace68e97$var$Oa(a, b) {
    if (!a || $0331271bace68e97$var$Na) return "";
    $0331271bace68e97$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0331271bace68e97$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0331271bace68e97$var$Ma(a) : "";
}
function $0331271bace68e97$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0331271bace68e97$var$Ma(a.type);
        case 16:
            return $0331271bace68e97$var$Ma("Lazy");
        case 13:
            return $0331271bace68e97$var$Ma("Suspense");
        case 19:
            return $0331271bace68e97$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0331271bace68e97$var$Oa(a.type, !1), a;
        case 11:
            return a = $0331271bace68e97$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0331271bace68e97$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0331271bace68e97$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0331271bace68e97$var$ya:
            return "Fragment";
        case $0331271bace68e97$var$wa:
            return "Portal";
        case $0331271bace68e97$var$Aa:
            return "Profiler";
        case $0331271bace68e97$var$za:
            return "StrictMode";
        case $0331271bace68e97$var$Ea:
            return "Suspense";
        case $0331271bace68e97$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0331271bace68e97$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0331271bace68e97$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0331271bace68e97$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0331271bace68e97$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0331271bace68e97$var$Qa(a.type) || "Memo";
        case $0331271bace68e97$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0331271bace68e97$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0331271bace68e97$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0331271bace68e97$var$Qa(b);
        case 8:
            return b === $0331271bace68e97$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0331271bace68e97$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0331271bace68e97$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0331271bace68e97$var$Ua(a) {
    var b = $0331271bace68e97$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0331271bace68e97$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0331271bace68e97$var$Ua(a));
}
function $0331271bace68e97$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0331271bace68e97$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0331271bace68e97$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0331271bace68e97$var$Ya(a, b) {
    var c = b.checked;
    return $0331271bace68e97$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0331271bace68e97$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0331271bace68e97$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0331271bace68e97$var$ab(a, b) {
    b = b.checked;
    null != b && $0331271bace68e97$var$ta(a, "checked", b, !1);
}
function $0331271bace68e97$var$bb(a, b) {
    $0331271bace68e97$var$ab(a, b);
    var c = $0331271bace68e97$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0331271bace68e97$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0331271bace68e97$var$cb(a, b.type, $0331271bace68e97$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0331271bace68e97$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0331271bace68e97$var$cb(a, b, c) {
    if ("number" !== b || $0331271bace68e97$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0331271bace68e97$var$eb = Array.isArray;
function $0331271bace68e97$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0331271bace68e97$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0331271bace68e97$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0331271bace68e97$var$p(91));
    return $0331271bace68e97$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0331271bace68e97$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0331271bace68e97$var$p(92));
            if ($0331271bace68e97$var$eb(c)) {
                if (1 < c.length) throw Error($0331271bace68e97$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0331271bace68e97$var$Sa(c)
    };
}
function $0331271bace68e97$var$ib(a, b) {
    var c = $0331271bace68e97$var$Sa(b.value), d = $0331271bace68e97$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0331271bace68e97$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0331271bace68e97$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0331271bace68e97$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0331271bace68e97$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0331271bace68e97$var$mb, $0331271bace68e97$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0331271bace68e97$var$mb = $0331271bace68e97$var$mb || document.createElement("div");
        $0331271bace68e97$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0331271bace68e97$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0331271bace68e97$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0331271bace68e97$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0331271bace68e97$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0331271bace68e97$var$pb).forEach(function(a) {
    $0331271bace68e97$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0331271bace68e97$var$pb[b] = $0331271bace68e97$var$pb[a];
    });
});
function $0331271bace68e97$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0331271bace68e97$var$pb.hasOwnProperty(a) && $0331271bace68e97$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0331271bace68e97$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0331271bace68e97$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0331271bace68e97$var$tb = $0331271bace68e97$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0331271bace68e97$var$ub(a, b) {
    if (b) {
        if ($0331271bace68e97$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0331271bace68e97$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0331271bace68e97$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0331271bace68e97$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0331271bace68e97$var$p(62));
    }
}
function $0331271bace68e97$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0331271bace68e97$var$wb = null;
function $0331271bace68e97$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0331271bace68e97$var$yb = null, $0331271bace68e97$var$zb = null, $0331271bace68e97$var$Ab = null;
function $0331271bace68e97$var$Bb(a) {
    if (a = $0331271bace68e97$var$Cb(a)) {
        if ("function" !== typeof $0331271bace68e97$var$yb) throw Error($0331271bace68e97$var$p(280));
        var b = a.stateNode;
        b && (b = $0331271bace68e97$var$Db(b), $0331271bace68e97$var$yb(a.stateNode, a.type, b));
    }
}
function $0331271bace68e97$var$Eb(a) {
    $0331271bace68e97$var$zb ? $0331271bace68e97$var$Ab ? $0331271bace68e97$var$Ab.push(a) : $0331271bace68e97$var$Ab = [
        a
    ] : $0331271bace68e97$var$zb = a;
}
function $0331271bace68e97$var$Fb() {
    if ($0331271bace68e97$var$zb) {
        var a = $0331271bace68e97$var$zb, b = $0331271bace68e97$var$Ab;
        $0331271bace68e97$var$Ab = $0331271bace68e97$var$zb = null;
        $0331271bace68e97$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0331271bace68e97$var$Bb(b[a]);
    }
}
function $0331271bace68e97$var$Gb(a, b) {
    return a(b);
}
function $0331271bace68e97$var$Hb() {}
var $0331271bace68e97$var$Ib = !1;
function $0331271bace68e97$var$Jb(a, b, c) {
    if ($0331271bace68e97$var$Ib) return a(b, c);
    $0331271bace68e97$var$Ib = !0;
    try {
        return $0331271bace68e97$var$Gb(a, b, c);
    } finally{
        if ($0331271bace68e97$var$Ib = !1, null !== $0331271bace68e97$var$zb || null !== $0331271bace68e97$var$Ab) $0331271bace68e97$var$Hb(), $0331271bace68e97$var$Fb();
    }
}
function $0331271bace68e97$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0331271bace68e97$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0331271bace68e97$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $bJtXW._)(c)));
    return c;
}
var $0331271bace68e97$var$Lb = !1;
if ($0331271bace68e97$var$ia) try {
    var $0331271bace68e97$var$Mb = {};
    Object.defineProperty($0331271bace68e97$var$Mb, "passive", {
        get: function get() {
            $0331271bace68e97$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0331271bace68e97$var$Mb, $0331271bace68e97$var$Mb);
    window.removeEventListener("test", $0331271bace68e97$var$Mb, $0331271bace68e97$var$Mb);
} catch (a) {
    $0331271bace68e97$var$Lb = !1;
}
function $0331271bace68e97$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0331271bace68e97$var$Ob = !1, $0331271bace68e97$var$Pb = null, $0331271bace68e97$var$Qb = !1, $0331271bace68e97$var$Rb = null, $0331271bace68e97$var$Sb = {
    onError: function onError(a) {
        $0331271bace68e97$var$Ob = !0;
        $0331271bace68e97$var$Pb = a;
    }
};
function $0331271bace68e97$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0331271bace68e97$var$Ob = !1;
    $0331271bace68e97$var$Pb = null;
    $0331271bace68e97$var$Nb.apply($0331271bace68e97$var$Sb, arguments);
}
function $0331271bace68e97$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0331271bace68e97$var$Tb.apply(this, arguments);
    if ($0331271bace68e97$var$Ob) {
        if ($0331271bace68e97$var$Ob) {
            var l = $0331271bace68e97$var$Pb;
            $0331271bace68e97$var$Ob = !1;
            $0331271bace68e97$var$Pb = null;
        } else throw Error($0331271bace68e97$var$p(198));
        $0331271bace68e97$var$Qb || ($0331271bace68e97$var$Qb = !0, $0331271bace68e97$var$Rb = l);
    }
}
function $0331271bace68e97$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0331271bace68e97$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0331271bace68e97$var$Xb(a) {
    if ($0331271bace68e97$var$Vb(a) !== a) throw Error($0331271bace68e97$var$p(188));
}
function $0331271bace68e97$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0331271bace68e97$var$Vb(a);
        if (null === b) throw Error($0331271bace68e97$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0331271bace68e97$var$Xb(e), a;
                if (f === d) return $0331271bace68e97$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0331271bace68e97$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0331271bace68e97$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0331271bace68e97$var$p(190));
    }
    if (3 !== c.tag) throw Error($0331271bace68e97$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0331271bace68e97$var$Zb(a) {
    a = $0331271bace68e97$var$Yb(a);
    return null !== a ? $0331271bace68e97$var$$b(a) : null;
}
function $0331271bace68e97$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0331271bace68e97$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0331271bace68e97$var$ac = $1iyD5.unstable_scheduleCallback, $0331271bace68e97$var$bc = $1iyD5.unstable_cancelCallback, $0331271bace68e97$var$cc = $1iyD5.unstable_shouldYield, $0331271bace68e97$var$dc = $1iyD5.unstable_requestPaint, $0331271bace68e97$var$B = $1iyD5.unstable_now, $0331271bace68e97$var$ec = $1iyD5.unstable_getCurrentPriorityLevel, $0331271bace68e97$var$fc = $1iyD5.unstable_ImmediatePriority, $0331271bace68e97$var$gc = $1iyD5.unstable_UserBlockingPriority, $0331271bace68e97$var$hc = $1iyD5.unstable_NormalPriority, $0331271bace68e97$var$ic = $1iyD5.unstable_LowPriority, $0331271bace68e97$var$jc = $1iyD5.unstable_IdlePriority, $0331271bace68e97$var$kc = null, $0331271bace68e97$var$lc = null;
function $0331271bace68e97$var$mc(a) {
    if ($0331271bace68e97$var$lc && "function" === typeof $0331271bace68e97$var$lc.onCommitFiberRoot) try {
        $0331271bace68e97$var$lc.onCommitFiberRoot($0331271bace68e97$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0331271bace68e97$var$oc = Math.clz32 ? Math.clz32 : $0331271bace68e97$var$nc, $0331271bace68e97$var$pc = Math.log, $0331271bace68e97$var$qc = Math.LN2;
function $0331271bace68e97$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0331271bace68e97$var$pc(a) / $0331271bace68e97$var$qc | 0) | 0;
}
var $0331271bace68e97$var$rc = 64, $0331271bace68e97$var$sc = 4194304;
function $0331271bace68e97$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0331271bace68e97$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0331271bace68e97$var$tc(h) : (f &= g, 0 !== f && (d = $0331271bace68e97$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0331271bace68e97$var$tc(g) : 0 !== f && (d = $0331271bace68e97$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0331271bace68e97$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0331271bace68e97$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0331271bace68e97$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0331271bace68e97$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0331271bace68e97$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0331271bace68e97$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0331271bace68e97$var$yc() {
    var a = $0331271bace68e97$var$rc;
    $0331271bace68e97$var$rc <<= 1;
    0 === ($0331271bace68e97$var$rc & 4194240) && ($0331271bace68e97$var$rc = 64);
    return a;
}
function $0331271bace68e97$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0331271bace68e97$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0331271bace68e97$var$oc(b);
    a[b] = c;
}
function $0331271bace68e97$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0331271bace68e97$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0331271bace68e97$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0331271bace68e97$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0331271bace68e97$var$C = 0;
function $0331271bace68e97$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0331271bace68e97$var$Ec, $0331271bace68e97$var$Fc, $0331271bace68e97$var$Gc, $0331271bace68e97$var$Hc, $0331271bace68e97$var$Ic, $0331271bace68e97$var$Jc = !1, $0331271bace68e97$var$Kc = [], $0331271bace68e97$var$Lc = null, $0331271bace68e97$var$Mc = null, $0331271bace68e97$var$Nc = null, $0331271bace68e97$var$Oc = new Map, $0331271bace68e97$var$Pc = new Map, $0331271bace68e97$var$Qc = [], $0331271bace68e97$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0331271bace68e97$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0331271bace68e97$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0331271bace68e97$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0331271bace68e97$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0331271bace68e97$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0331271bace68e97$var$Pc.delete(b.pointerId);
    }
}
function $0331271bace68e97$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0331271bace68e97$var$Cb(b), null !== b && $0331271bace68e97$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0331271bace68e97$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0331271bace68e97$var$Lc = $0331271bace68e97$var$Tc($0331271bace68e97$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0331271bace68e97$var$Mc = $0331271bace68e97$var$Tc($0331271bace68e97$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0331271bace68e97$var$Nc = $0331271bace68e97$var$Tc($0331271bace68e97$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0331271bace68e97$var$Oc.set(f, $0331271bace68e97$var$Tc($0331271bace68e97$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0331271bace68e97$var$Pc.set(f, $0331271bace68e97$var$Tc($0331271bace68e97$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0331271bace68e97$var$Vc(a) {
    var b = $0331271bace68e97$var$Wc(a.target);
    if (null !== b) {
        var c = $0331271bace68e97$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0331271bace68e97$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0331271bace68e97$var$Ic(a.priority, function() {
                        $0331271bace68e97$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0331271bace68e97$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0331271bace68e97$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0331271bace68e97$var$wb = d;
            c.target.dispatchEvent(d);
            $0331271bace68e97$var$wb = null;
        } else return b = $0331271bace68e97$var$Cb(c), null !== b && $0331271bace68e97$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0331271bace68e97$var$Zc(a, b, c) {
    $0331271bace68e97$var$Xc(a) && c.delete(b);
}
function $0331271bace68e97$var$$c() {
    $0331271bace68e97$var$Jc = !1;
    null !== $0331271bace68e97$var$Lc && $0331271bace68e97$var$Xc($0331271bace68e97$var$Lc) && ($0331271bace68e97$var$Lc = null);
    null !== $0331271bace68e97$var$Mc && $0331271bace68e97$var$Xc($0331271bace68e97$var$Mc) && ($0331271bace68e97$var$Mc = null);
    null !== $0331271bace68e97$var$Nc && $0331271bace68e97$var$Xc($0331271bace68e97$var$Nc) && ($0331271bace68e97$var$Nc = null);
    $0331271bace68e97$var$Oc.forEach($0331271bace68e97$var$Zc);
    $0331271bace68e97$var$Pc.forEach($0331271bace68e97$var$Zc);
}
function $0331271bace68e97$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0331271bace68e97$var$Jc || ($0331271bace68e97$var$Jc = !0, $1iyD5.unstable_scheduleCallback($1iyD5.unstable_NormalPriority, $0331271bace68e97$var$$c)));
}
function $0331271bace68e97$var$bd(a) {
    var b = function b(_b) {
        return $0331271bace68e97$var$ad(_b, a);
    };
    if (0 < $0331271bace68e97$var$Kc.length) {
        $0331271bace68e97$var$ad($0331271bace68e97$var$Kc[0], a);
        for(var c = 1; c < $0331271bace68e97$var$Kc.length; c++){
            var d = $0331271bace68e97$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0331271bace68e97$var$Lc && $0331271bace68e97$var$ad($0331271bace68e97$var$Lc, a);
    null !== $0331271bace68e97$var$Mc && $0331271bace68e97$var$ad($0331271bace68e97$var$Mc, a);
    null !== $0331271bace68e97$var$Nc && $0331271bace68e97$var$ad($0331271bace68e97$var$Nc, a);
    $0331271bace68e97$var$Oc.forEach(b);
    $0331271bace68e97$var$Pc.forEach(b);
    for(c = 0; c < $0331271bace68e97$var$Qc.length; c++)d = $0331271bace68e97$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0331271bace68e97$var$Qc.length && (c = $0331271bace68e97$var$Qc[0], null === c.blockedOn);)$0331271bace68e97$var$Vc(c), null === c.blockedOn && $0331271bace68e97$var$Qc.shift();
}
var $0331271bace68e97$var$cd = $0331271bace68e97$var$ua.ReactCurrentBatchConfig, $0331271bace68e97$var$dd = !0;
function $0331271bace68e97$var$ed(a, b, c, d) {
    var e = $0331271bace68e97$var$C, f = $0331271bace68e97$var$cd.transition;
    $0331271bace68e97$var$cd.transition = null;
    try {
        $0331271bace68e97$var$C = 1, $0331271bace68e97$var$fd(a, b, c, d);
    } finally{
        $0331271bace68e97$var$C = e, $0331271bace68e97$var$cd.transition = f;
    }
}
function $0331271bace68e97$var$gd(a, b, c, d) {
    var e = $0331271bace68e97$var$C, f = $0331271bace68e97$var$cd.transition;
    $0331271bace68e97$var$cd.transition = null;
    try {
        $0331271bace68e97$var$C = 4, $0331271bace68e97$var$fd(a, b, c, d);
    } finally{
        $0331271bace68e97$var$C = e, $0331271bace68e97$var$cd.transition = f;
    }
}
function $0331271bace68e97$var$fd(a, b, c, d) {
    if ($0331271bace68e97$var$dd) {
        var e = $0331271bace68e97$var$Yc(a, b, c, d);
        if (null === e) $0331271bace68e97$var$hd(a, b, d, $0331271bace68e97$var$id, c), $0331271bace68e97$var$Sc(a, d);
        else if ($0331271bace68e97$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0331271bace68e97$var$Sc(a, d), b & 4 && -1 < $0331271bace68e97$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0331271bace68e97$var$Cb(e);
                null !== f && $0331271bace68e97$var$Ec(f);
                f = $0331271bace68e97$var$Yc(a, b, c, d);
                null === f && $0331271bace68e97$var$hd(a, b, d, $0331271bace68e97$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0331271bace68e97$var$hd(a, b, d, null, c);
    }
}
var $0331271bace68e97$var$id = null;
function $0331271bace68e97$var$Yc(a, b, c, d) {
    $0331271bace68e97$var$id = null;
    a = $0331271bace68e97$var$xb(d);
    a = $0331271bace68e97$var$Wc(a);
    if (null !== a) {
        if (b = $0331271bace68e97$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0331271bace68e97$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0331271bace68e97$var$id = a;
    return null;
}
function $0331271bace68e97$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0331271bace68e97$var$ec()){
                case $0331271bace68e97$var$fc:
                    return 1;
                case $0331271bace68e97$var$gc:
                    return 4;
                case $0331271bace68e97$var$hc:
                case $0331271bace68e97$var$ic:
                    return 16;
                case $0331271bace68e97$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0331271bace68e97$var$kd = null, $0331271bace68e97$var$ld = null, $0331271bace68e97$var$md = null;
function $0331271bace68e97$var$nd() {
    if ($0331271bace68e97$var$md) return $0331271bace68e97$var$md;
    var a, b = $0331271bace68e97$var$ld, c = b.length, d, e = "value" in $0331271bace68e97$var$kd ? $0331271bace68e97$var$kd.value : $0331271bace68e97$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0331271bace68e97$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0331271bace68e97$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0331271bace68e97$var$pd() {
    return !0;
}
function $0331271bace68e97$var$qd() {
    return !1;
}
function $0331271bace68e97$var$rd(a) {
    var b = function b(_b, d, e, f, g) {
        this._reactName = _b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (_b = a[c], this[c] = _b ? _b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0331271bace68e97$var$pd : $0331271bace68e97$var$qd;
        this.isPropagationStopped = $0331271bace68e97$var$qd;
        return this;
    };
    $0331271bace68e97$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $bJtXW._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $0331271bace68e97$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $bJtXW._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $0331271bace68e97$var$pd);
        },
        persist: function persist() {},
        isPersistent: $0331271bace68e97$var$pd
    });
    return b;
}
var $0331271bace68e97$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0331271bace68e97$var$td = $0331271bace68e97$var$rd($0331271bace68e97$var$sd), $0331271bace68e97$var$ud = $0331271bace68e97$var$A({}, $0331271bace68e97$var$sd, {
    view: 0,
    detail: 0
}), $0331271bace68e97$var$vd = $0331271bace68e97$var$rd($0331271bace68e97$var$ud), $0331271bace68e97$var$wd, $0331271bace68e97$var$xd, $0331271bace68e97$var$yd, $0331271bace68e97$var$Ad = $0331271bace68e97$var$A({}, $0331271bace68e97$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0331271bace68e97$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0331271bace68e97$var$yd && ($0331271bace68e97$var$yd && "mousemove" === a.type ? ($0331271bace68e97$var$wd = a.screenX - $0331271bace68e97$var$yd.screenX, $0331271bace68e97$var$xd = a.screenY - $0331271bace68e97$var$yd.screenY) : $0331271bace68e97$var$xd = $0331271bace68e97$var$wd = 0, $0331271bace68e97$var$yd = a);
        return $0331271bace68e97$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $0331271bace68e97$var$xd;
    }
}), $0331271bace68e97$var$Bd = $0331271bace68e97$var$rd($0331271bace68e97$var$Ad), $0331271bace68e97$var$Cd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$Ad, {
    dataTransfer: 0
}), $0331271bace68e97$var$Dd = $0331271bace68e97$var$rd($0331271bace68e97$var$Cd), $0331271bace68e97$var$Ed = $0331271bace68e97$var$A({}, $0331271bace68e97$var$ud, {
    relatedTarget: 0
}), $0331271bace68e97$var$Fd = $0331271bace68e97$var$rd($0331271bace68e97$var$Ed), $0331271bace68e97$var$Gd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0331271bace68e97$var$Hd = $0331271bace68e97$var$rd($0331271bace68e97$var$Gd), $0331271bace68e97$var$Id = $0331271bace68e97$var$A({}, $0331271bace68e97$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0331271bace68e97$var$Jd = $0331271bace68e97$var$rd($0331271bace68e97$var$Id), $0331271bace68e97$var$Kd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$sd, {
    data: 0
}), $0331271bace68e97$var$Ld = $0331271bace68e97$var$rd($0331271bace68e97$var$Kd), $0331271bace68e97$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0331271bace68e97$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0331271bace68e97$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0331271bace68e97$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0331271bace68e97$var$Od[a]) ? !!b[a] : !1;
}
function $0331271bace68e97$var$zd() {
    return $0331271bace68e97$var$Pd;
}
var $0331271bace68e97$var$Qd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $0331271bace68e97$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0331271bace68e97$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0331271bace68e97$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0331271bace68e97$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $0331271bace68e97$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $0331271bace68e97$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0331271bace68e97$var$Rd = $0331271bace68e97$var$rd($0331271bace68e97$var$Qd), $0331271bace68e97$var$Sd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0331271bace68e97$var$Td = $0331271bace68e97$var$rd($0331271bace68e97$var$Sd), $0331271bace68e97$var$Ud = $0331271bace68e97$var$A({}, $0331271bace68e97$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0331271bace68e97$var$zd
}), $0331271bace68e97$var$Vd = $0331271bace68e97$var$rd($0331271bace68e97$var$Ud), $0331271bace68e97$var$Wd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0331271bace68e97$var$Xd = $0331271bace68e97$var$rd($0331271bace68e97$var$Wd), $0331271bace68e97$var$Yd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0331271bace68e97$var$Zd = $0331271bace68e97$var$rd($0331271bace68e97$var$Yd), $0331271bace68e97$var$$d = [
    9,
    13,
    27,
    32
], $0331271bace68e97$var$ae = $0331271bace68e97$var$ia && "CompositionEvent" in window, $0331271bace68e97$var$be = null;
$0331271bace68e97$var$ia && "documentMode" in document && ($0331271bace68e97$var$be = document.documentMode);
var $0331271bace68e97$var$ce = $0331271bace68e97$var$ia && "TextEvent" in window && !$0331271bace68e97$var$be, $0331271bace68e97$var$de = $0331271bace68e97$var$ia && (!$0331271bace68e97$var$ae || $0331271bace68e97$var$be && 8 < $0331271bace68e97$var$be && 11 >= $0331271bace68e97$var$be), $0331271bace68e97$var$ee = String.fromCharCode(32), $0331271bace68e97$var$fe = !1;
function $0331271bace68e97$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0331271bace68e97$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0331271bace68e97$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0331271bace68e97$var$ie = !1;
function $0331271bace68e97$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0331271bace68e97$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0331271bace68e97$var$fe = !0;
            return $0331271bace68e97$var$ee;
        case "textInput":
            return a = b.data, a === $0331271bace68e97$var$ee && $0331271bace68e97$var$fe ? null : a;
        default:
            return null;
    }
}
function $0331271bace68e97$var$ke(a, b) {
    if ($0331271bace68e97$var$ie) return "compositionend" === a || !$0331271bace68e97$var$ae && $0331271bace68e97$var$ge(a, b) ? (a = $0331271bace68e97$var$nd(), $0331271bace68e97$var$md = $0331271bace68e97$var$ld = $0331271bace68e97$var$kd = null, $0331271bace68e97$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0331271bace68e97$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0331271bace68e97$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0331271bace68e97$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0331271bace68e97$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0331271bace68e97$var$ne(a, b, c, d) {
    $0331271bace68e97$var$Eb(d);
    b = $0331271bace68e97$var$oe(b, "onChange");
    0 < b.length && (c = new $0331271bace68e97$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0331271bace68e97$var$pe = null, $0331271bace68e97$var$qe = null;
function $0331271bace68e97$var$re(a) {
    $0331271bace68e97$var$se(a, 0);
}
function $0331271bace68e97$var$te(a) {
    var b = $0331271bace68e97$var$ue(a);
    if ($0331271bace68e97$var$Wa(b)) return a;
}
function $0331271bace68e97$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0331271bace68e97$var$we = !1;
if ($0331271bace68e97$var$ia) {
    var $0331271bace68e97$var$xe;
    if ($0331271bace68e97$var$ia) {
        var $0331271bace68e97$var$ye = "oninput" in document;
        if (!$0331271bace68e97$var$ye) {
            var $0331271bace68e97$var$ze = document.createElement("div");
            $0331271bace68e97$var$ze.setAttribute("oninput", "return;");
            $0331271bace68e97$var$ye = "function" === typeof $0331271bace68e97$var$ze.oninput;
        }
        $0331271bace68e97$var$xe = $0331271bace68e97$var$ye;
    } else $0331271bace68e97$var$xe = !1;
    $0331271bace68e97$var$we = $0331271bace68e97$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0331271bace68e97$var$Ae() {
    $0331271bace68e97$var$pe && ($0331271bace68e97$var$pe.detachEvent("onpropertychange", $0331271bace68e97$var$Be), $0331271bace68e97$var$qe = $0331271bace68e97$var$pe = null);
}
function $0331271bace68e97$var$Be(a) {
    if ("value" === a.propertyName && $0331271bace68e97$var$te($0331271bace68e97$var$qe)) {
        var b = [];
        $0331271bace68e97$var$ne(b, $0331271bace68e97$var$qe, a, $0331271bace68e97$var$xb(a));
        $0331271bace68e97$var$Jb($0331271bace68e97$var$re, b);
    }
}
function $0331271bace68e97$var$Ce(a, b, c) {
    "focusin" === a ? ($0331271bace68e97$var$Ae(), $0331271bace68e97$var$pe = b, $0331271bace68e97$var$qe = c, $0331271bace68e97$var$pe.attachEvent("onpropertychange", $0331271bace68e97$var$Be)) : "focusout" === a && $0331271bace68e97$var$Ae();
}
function $0331271bace68e97$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0331271bace68e97$var$te($0331271bace68e97$var$qe);
}
function $0331271bace68e97$var$Ee(a, b) {
    if ("click" === a) return $0331271bace68e97$var$te(b);
}
function $0331271bace68e97$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0331271bace68e97$var$te(b);
}
function $0331271bace68e97$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0331271bace68e97$var$He = "function" === typeof Object.is ? Object.is : $0331271bace68e97$var$Ge;
function $0331271bace68e97$var$Ie(a, b) {
    if ($0331271bace68e97$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0331271bace68e97$var$ja.call(b, e) || !$0331271bace68e97$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0331271bace68e97$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0331271bace68e97$var$Ke(a, b) {
    var c = $0331271bace68e97$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0331271bace68e97$var$Je(c);
    }
}
function $0331271bace68e97$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0331271bace68e97$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0331271bace68e97$var$Me() {
    for(var a = window, b = $0331271bace68e97$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0331271bace68e97$var$Xa(a.document);
    }
    return b;
}
function $0331271bace68e97$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0331271bace68e97$var$Oe(a) {
    var b = $0331271bace68e97$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0331271bace68e97$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0331271bace68e97$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0331271bace68e97$var$Ke(c, f);
                var g = $0331271bace68e97$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0331271bace68e97$var$Pe = $0331271bace68e97$var$ia && "documentMode" in document && 11 >= document.documentMode, $0331271bace68e97$var$Qe = null, $0331271bace68e97$var$Re = null, $0331271bace68e97$var$Se = null, $0331271bace68e97$var$Te = !1;
function $0331271bace68e97$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0331271bace68e97$var$Te || null == $0331271bace68e97$var$Qe || $0331271bace68e97$var$Qe !== $0331271bace68e97$var$Xa(d) || (d = $0331271bace68e97$var$Qe, "selectionStart" in d && $0331271bace68e97$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0331271bace68e97$var$Se && $0331271bace68e97$var$Ie($0331271bace68e97$var$Se, d) || ($0331271bace68e97$var$Se = d, d = $0331271bace68e97$var$oe($0331271bace68e97$var$Re, "onSelect"), 0 < d.length && (b = new $0331271bace68e97$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0331271bace68e97$var$Qe)));
}
function $0331271bace68e97$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0331271bace68e97$var$We = {
    animationend: $0331271bace68e97$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0331271bace68e97$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0331271bace68e97$var$Ve("Animation", "AnimationStart"),
    transitionend: $0331271bace68e97$var$Ve("Transition", "TransitionEnd")
}, $0331271bace68e97$var$Xe = {}, $0331271bace68e97$var$Ye = {};
$0331271bace68e97$var$ia && ($0331271bace68e97$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0331271bace68e97$var$We.animationend.animation, delete $0331271bace68e97$var$We.animationiteration.animation, delete $0331271bace68e97$var$We.animationstart.animation), "TransitionEvent" in window || delete $0331271bace68e97$var$We.transitionend.transition);
function $0331271bace68e97$var$Ze(a) {
    if ($0331271bace68e97$var$Xe[a]) return $0331271bace68e97$var$Xe[a];
    if (!$0331271bace68e97$var$We[a]) return a;
    var b = $0331271bace68e97$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0331271bace68e97$var$Ye) return $0331271bace68e97$var$Xe[a] = b[c];
    return a;
}
var $0331271bace68e97$var$$e = $0331271bace68e97$var$Ze("animationend"), $0331271bace68e97$var$af = $0331271bace68e97$var$Ze("animationiteration"), $0331271bace68e97$var$bf = $0331271bace68e97$var$Ze("animationstart"), $0331271bace68e97$var$cf = $0331271bace68e97$var$Ze("transitionend"), $0331271bace68e97$var$df = new Map, $0331271bace68e97$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0331271bace68e97$var$ff(a, b) {
    $0331271bace68e97$var$df.set(a, b);
    $0331271bace68e97$var$fa(b, [
        a
    ]);
}
for(var $0331271bace68e97$var$gf = 0; $0331271bace68e97$var$gf < $0331271bace68e97$var$ef.length; $0331271bace68e97$var$gf++){
    var $0331271bace68e97$var$hf = $0331271bace68e97$var$ef[$0331271bace68e97$var$gf], $0331271bace68e97$var$jf = $0331271bace68e97$var$hf.toLowerCase(), $0331271bace68e97$var$kf = $0331271bace68e97$var$hf[0].toUpperCase() + $0331271bace68e97$var$hf.slice(1);
    $0331271bace68e97$var$ff($0331271bace68e97$var$jf, "on" + $0331271bace68e97$var$kf);
}
$0331271bace68e97$var$ff($0331271bace68e97$var$$e, "onAnimationEnd");
$0331271bace68e97$var$ff($0331271bace68e97$var$af, "onAnimationIteration");
$0331271bace68e97$var$ff($0331271bace68e97$var$bf, "onAnimationStart");
$0331271bace68e97$var$ff("dblclick", "onDoubleClick");
$0331271bace68e97$var$ff("focusin", "onFocus");
$0331271bace68e97$var$ff("focusout", "onBlur");
$0331271bace68e97$var$ff($0331271bace68e97$var$cf, "onTransitionEnd");
$0331271bace68e97$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0331271bace68e97$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0331271bace68e97$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0331271bace68e97$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0331271bace68e97$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0331271bace68e97$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0331271bace68e97$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0331271bace68e97$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0331271bace68e97$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0331271bace68e97$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0331271bace68e97$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0331271bace68e97$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0331271bace68e97$var$lf));
function $0331271bace68e97$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0331271bace68e97$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0331271bace68e97$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0331271bace68e97$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0331271bace68e97$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0331271bace68e97$var$Qb) throw a = $0331271bace68e97$var$Rb, $0331271bace68e97$var$Qb = !1, $0331271bace68e97$var$Rb = null, a;
}
function $0331271bace68e97$var$D(a, b) {
    var c = b[$0331271bace68e97$var$of];
    void 0 === c && (c = b[$0331271bace68e97$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0331271bace68e97$var$pf(b, a, 2, !1), c.add(d));
}
function $0331271bace68e97$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0331271bace68e97$var$pf(c, a, d, b);
}
var $0331271bace68e97$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0331271bace68e97$var$sf(a) {
    if (!a[$0331271bace68e97$var$rf]) {
        a[$0331271bace68e97$var$rf] = !0;
        $0331271bace68e97$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0331271bace68e97$var$mf.has(b) || $0331271bace68e97$var$qf(b, !1, a), $0331271bace68e97$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0331271bace68e97$var$rf] || (b[$0331271bace68e97$var$rf] = !0, $0331271bace68e97$var$qf("selectionchange", !1, b));
    }
}
function $0331271bace68e97$var$pf(a, b, c, d) {
    switch($0331271bace68e97$var$jd(b)){
        case 1:
            var e = $0331271bace68e97$var$ed;
            break;
        case 4:
            e = $0331271bace68e97$var$gd;
            break;
        default:
            e = $0331271bace68e97$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0331271bace68e97$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0331271bace68e97$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0331271bace68e97$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0331271bace68e97$var$Jb(function() {
        var _$d = f, _$e = $0331271bace68e97$var$xb(c), g = [];
        a: {
            var h = $0331271bace68e97$var$df.get(a);
            if (void 0 !== h) {
                var k = $0331271bace68e97$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0331271bace68e97$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0331271bace68e97$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0331271bace68e97$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0331271bace68e97$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0331271bace68e97$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0331271bace68e97$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0331271bace68e97$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0331271bace68e97$var$Vd;
                        break;
                    case $0331271bace68e97$var$$e:
                    case $0331271bace68e97$var$af:
                    case $0331271bace68e97$var$bf:
                        k = $0331271bace68e97$var$Hd;
                        break;
                    case $0331271bace68e97$var$cf:
                        k = $0331271bace68e97$var$Xd;
                        break;
                    case "scroll":
                        k = $0331271bace68e97$var$vd;
                        break;
                    case "wheel":
                        k = $0331271bace68e97$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0331271bace68e97$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0331271bace68e97$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0331271bace68e97$var$Kb(w, x), null != F && t.push($0331271bace68e97$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0331271bace68e97$var$wb && (n = c.relatedTarget || c.fromElement) && ($0331271bace68e97$var$Wc(n) || n[$0331271bace68e97$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $0331271bace68e97$var$Wc(n) : null, null !== n && (J = $0331271bace68e97$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $0331271bace68e97$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0331271bace68e97$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0331271bace68e97$var$ue(k);
                        u = null == n ? h : $0331271bace68e97$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0331271bace68e97$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0331271bace68e97$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0331271bace68e97$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0331271bace68e97$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0331271bace68e97$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0331271bace68e97$var$vf(t);
                                x = $0331271bace68e97$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0331271bace68e97$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0331271bace68e97$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $0331271bace68e97$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0331271bace68e97$var$ve;
                else if ($0331271bace68e97$var$me(h)) {
                    if ($0331271bace68e97$var$we) na = $0331271bace68e97$var$Fe;
                    else {
                        na = $0331271bace68e97$var$De;
                        var xa = $0331271bace68e97$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0331271bace68e97$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $0331271bace68e97$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0331271bace68e97$var$cb(h, "number", h.value);
            }
            xa = _$d ? $0331271bace68e97$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($0331271bace68e97$var$me(xa) || "true" === xa.contentEditable) $0331271bace68e97$var$Qe = xa, $0331271bace68e97$var$Re = _$d, $0331271bace68e97$var$Se = null;
                    break;
                case "focusout":
                    $0331271bace68e97$var$Se = $0331271bace68e97$var$Re = $0331271bace68e97$var$Qe = null;
                    break;
                case "mousedown":
                    $0331271bace68e97$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0331271bace68e97$var$Te = !1;
                    $0331271bace68e97$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($0331271bace68e97$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0331271bace68e97$var$Ue(g, c, _$e);
            }
            var $a;
            if ($0331271bace68e97$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0331271bace68e97$var$ie ? $0331271bace68e97$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0331271bace68e97$var$de && "ko" !== c.locale && ($0331271bace68e97$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0331271bace68e97$var$ie && ($a = $0331271bace68e97$var$nd()) : ($0331271bace68e97$var$kd = _$e, $0331271bace68e97$var$ld = "value" in $0331271bace68e97$var$kd ? $0331271bace68e97$var$kd.value : $0331271bace68e97$var$kd.textContent, $0331271bace68e97$var$ie = !0)), xa = $0331271bace68e97$var$oe(_$d, ba), 0 < xa.length && (ba = new $0331271bace68e97$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0331271bace68e97$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0331271bace68e97$var$ce ? $0331271bace68e97$var$je(a, c) : $0331271bace68e97$var$ke(a, c)) _$d = $0331271bace68e97$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $0331271bace68e97$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $0331271bace68e97$var$se(g, b);
    });
}
function $0331271bace68e97$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0331271bace68e97$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0331271bace68e97$var$Kb(a, c), null != f && d.unshift($0331271bace68e97$var$tf(a, f, e)), f = $0331271bace68e97$var$Kb(a, b), null != f && d.push($0331271bace68e97$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0331271bace68e97$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0331271bace68e97$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0331271bace68e97$var$Kb(c, f), null != k && g.unshift($0331271bace68e97$var$tf(c, k, h))) : e || (k = $0331271bace68e97$var$Kb(c, f), null != k && g.push($0331271bace68e97$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0331271bace68e97$var$xf = /\r\n?/g, $0331271bace68e97$var$yf = /\u0000|\uFFFD/g;
function $0331271bace68e97$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0331271bace68e97$var$xf, "\n").replace($0331271bace68e97$var$yf, "");
}
function $0331271bace68e97$var$Af(a, b, c) {
    b = $0331271bace68e97$var$zf(b);
    if ($0331271bace68e97$var$zf(a) !== b && c) throw Error($0331271bace68e97$var$p(425));
}
function $0331271bace68e97$var$Bf() {}
var $0331271bace68e97$var$Cf = null, $0331271bace68e97$var$Df = null;
function $0331271bace68e97$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0331271bace68e97$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0331271bace68e97$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0331271bace68e97$var$Hf = "function" === typeof Promise ? Promise : void 0, $0331271bace68e97$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0331271bace68e97$var$Hf ? function Jf(a) {
    return $0331271bace68e97$var$Hf.resolve(null).then(a).catch($0331271bace68e97$var$If);
} : $0331271bace68e97$var$Ff;
function $0331271bace68e97$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0331271bace68e97$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0331271bace68e97$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0331271bace68e97$var$bd(b);
}
function $0331271bace68e97$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0331271bace68e97$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0331271bace68e97$var$Nf = Math.random().toString(36).slice(2), $0331271bace68e97$var$Of = "__reactFiber$" + $0331271bace68e97$var$Nf, $0331271bace68e97$var$Pf = "__reactProps$" + $0331271bace68e97$var$Nf, $0331271bace68e97$var$uf = "__reactContainer$" + $0331271bace68e97$var$Nf, $0331271bace68e97$var$of = "__reactEvents$" + $0331271bace68e97$var$Nf, $0331271bace68e97$var$Qf = "__reactListeners$" + $0331271bace68e97$var$Nf, $0331271bace68e97$var$Rf = "__reactHandles$" + $0331271bace68e97$var$Nf;
function $0331271bace68e97$var$Wc(a) {
    var b = a[$0331271bace68e97$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0331271bace68e97$var$uf] || c[$0331271bace68e97$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0331271bace68e97$var$Mf(a); null !== a;){
                if (c = a[$0331271bace68e97$var$Of]) return c;
                a = $0331271bace68e97$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0331271bace68e97$var$Cb(a) {
    a = a[$0331271bace68e97$var$Of] || a[$0331271bace68e97$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0331271bace68e97$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0331271bace68e97$var$p(33));
}
function $0331271bace68e97$var$Db(a) {
    return a[$0331271bace68e97$var$Pf] || null;
}
var $0331271bace68e97$var$Sf = [], $0331271bace68e97$var$Tf = -1;
function $0331271bace68e97$var$Uf(a) {
    return {
        current: a
    };
}
function $0331271bace68e97$var$E(a) {
    0 > $0331271bace68e97$var$Tf || (a.current = $0331271bace68e97$var$Sf[$0331271bace68e97$var$Tf], $0331271bace68e97$var$Sf[$0331271bace68e97$var$Tf] = null, $0331271bace68e97$var$Tf--);
}
function $0331271bace68e97$var$G(a, b) {
    $0331271bace68e97$var$Tf++;
    $0331271bace68e97$var$Sf[$0331271bace68e97$var$Tf] = a.current;
    a.current = b;
}
var $0331271bace68e97$var$Vf = {}, $0331271bace68e97$var$H = $0331271bace68e97$var$Uf($0331271bace68e97$var$Vf), $0331271bace68e97$var$Wf = $0331271bace68e97$var$Uf(!1), $0331271bace68e97$var$Xf = $0331271bace68e97$var$Vf;
function $0331271bace68e97$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0331271bace68e97$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0331271bace68e97$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0331271bace68e97$var$$f() {
    $0331271bace68e97$var$E($0331271bace68e97$var$Wf);
    $0331271bace68e97$var$E($0331271bace68e97$var$H);
}
function $0331271bace68e97$var$ag(a, b, c) {
    if ($0331271bace68e97$var$H.current !== $0331271bace68e97$var$Vf) throw Error($0331271bace68e97$var$p(168));
    $0331271bace68e97$var$G($0331271bace68e97$var$H, b);
    $0331271bace68e97$var$G($0331271bace68e97$var$Wf, c);
}
function $0331271bace68e97$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0331271bace68e97$var$p(108, $0331271bace68e97$var$Ra(a) || "Unknown", e));
    return $0331271bace68e97$var$A({}, c, d);
}
function $0331271bace68e97$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0331271bace68e97$var$Vf;
    $0331271bace68e97$var$Xf = $0331271bace68e97$var$H.current;
    $0331271bace68e97$var$G($0331271bace68e97$var$H, a);
    $0331271bace68e97$var$G($0331271bace68e97$var$Wf, $0331271bace68e97$var$Wf.current);
    return !0;
}
function $0331271bace68e97$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0331271bace68e97$var$p(169));
    c ? (a = $0331271bace68e97$var$bg(a, b, $0331271bace68e97$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0331271bace68e97$var$E($0331271bace68e97$var$Wf), $0331271bace68e97$var$E($0331271bace68e97$var$H), $0331271bace68e97$var$G($0331271bace68e97$var$H, a)) : $0331271bace68e97$var$E($0331271bace68e97$var$Wf);
    $0331271bace68e97$var$G($0331271bace68e97$var$Wf, c);
}
var $0331271bace68e97$var$eg = null, $0331271bace68e97$var$fg = !1, $0331271bace68e97$var$gg = !1;
function $0331271bace68e97$var$hg(a) {
    null === $0331271bace68e97$var$eg ? $0331271bace68e97$var$eg = [
        a
    ] : $0331271bace68e97$var$eg.push(a);
}
function $0331271bace68e97$var$ig(a) {
    $0331271bace68e97$var$fg = !0;
    $0331271bace68e97$var$hg(a);
}
function $0331271bace68e97$var$jg() {
    if (!$0331271bace68e97$var$gg && null !== $0331271bace68e97$var$eg) {
        $0331271bace68e97$var$gg = !0;
        var a = 0, b = $0331271bace68e97$var$C;
        try {
            var c = $0331271bace68e97$var$eg;
            for($0331271bace68e97$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0331271bace68e97$var$eg = null;
            $0331271bace68e97$var$fg = !1;
        } catch (e) {
            throw null !== $0331271bace68e97$var$eg && ($0331271bace68e97$var$eg = $0331271bace68e97$var$eg.slice(a + 1)), $0331271bace68e97$var$ac($0331271bace68e97$var$fc, $0331271bace68e97$var$jg), e;
        } finally{
            $0331271bace68e97$var$C = b, $0331271bace68e97$var$gg = !1;
        }
    }
    return null;
}
var $0331271bace68e97$var$kg = [], $0331271bace68e97$var$lg = 0, $0331271bace68e97$var$mg = null, $0331271bace68e97$var$ng = 0, $0331271bace68e97$var$og = [], $0331271bace68e97$var$pg = 0, $0331271bace68e97$var$qg = null, $0331271bace68e97$var$rg = 1, $0331271bace68e97$var$sg = "";
function $0331271bace68e97$var$tg(a, b) {
    $0331271bace68e97$var$kg[$0331271bace68e97$var$lg++] = $0331271bace68e97$var$ng;
    $0331271bace68e97$var$kg[$0331271bace68e97$var$lg++] = $0331271bace68e97$var$mg;
    $0331271bace68e97$var$mg = a;
    $0331271bace68e97$var$ng = b;
}
function $0331271bace68e97$var$ug(a, b, c) {
    $0331271bace68e97$var$og[$0331271bace68e97$var$pg++] = $0331271bace68e97$var$rg;
    $0331271bace68e97$var$og[$0331271bace68e97$var$pg++] = $0331271bace68e97$var$sg;
    $0331271bace68e97$var$og[$0331271bace68e97$var$pg++] = $0331271bace68e97$var$qg;
    $0331271bace68e97$var$qg = a;
    var d = $0331271bace68e97$var$rg;
    a = $0331271bace68e97$var$sg;
    var e = 32 - $0331271bace68e97$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0331271bace68e97$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0331271bace68e97$var$rg = 1 << 32 - $0331271bace68e97$var$oc(b) + e | c << e | d;
        $0331271bace68e97$var$sg = f + a;
    } else $0331271bace68e97$var$rg = 1 << f | c << e | d, $0331271bace68e97$var$sg = a;
}
function $0331271bace68e97$var$vg(a) {
    null !== a.return && ($0331271bace68e97$var$tg(a, 1), $0331271bace68e97$var$ug(a, 1, 0));
}
function $0331271bace68e97$var$wg(a) {
    for(; a === $0331271bace68e97$var$mg;)$0331271bace68e97$var$mg = $0331271bace68e97$var$kg[--$0331271bace68e97$var$lg], $0331271bace68e97$var$kg[$0331271bace68e97$var$lg] = null, $0331271bace68e97$var$ng = $0331271bace68e97$var$kg[--$0331271bace68e97$var$lg], $0331271bace68e97$var$kg[$0331271bace68e97$var$lg] = null;
    for(; a === $0331271bace68e97$var$qg;)$0331271bace68e97$var$qg = $0331271bace68e97$var$og[--$0331271bace68e97$var$pg], $0331271bace68e97$var$og[$0331271bace68e97$var$pg] = null, $0331271bace68e97$var$sg = $0331271bace68e97$var$og[--$0331271bace68e97$var$pg], $0331271bace68e97$var$og[$0331271bace68e97$var$pg] = null, $0331271bace68e97$var$rg = $0331271bace68e97$var$og[--$0331271bace68e97$var$pg], $0331271bace68e97$var$og[$0331271bace68e97$var$pg] = null;
}
var $0331271bace68e97$var$xg = null, $0331271bace68e97$var$yg = null, $0331271bace68e97$var$I = !1, $0331271bace68e97$var$zg = null;
function $0331271bace68e97$var$Ag(a, b) {
    var c = $0331271bace68e97$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0331271bace68e97$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0331271bace68e97$var$xg = a, $0331271bace68e97$var$yg = $0331271bace68e97$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0331271bace68e97$var$xg = a, $0331271bace68e97$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0331271bace68e97$var$qg ? {
                id: $0331271bace68e97$var$rg,
                overflow: $0331271bace68e97$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0331271bace68e97$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0331271bace68e97$var$xg = a, $0331271bace68e97$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0331271bace68e97$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0331271bace68e97$var$Eg(a) {
    if ($0331271bace68e97$var$I) {
        var b = $0331271bace68e97$var$yg;
        if (b) {
            var c = b;
            if (!$0331271bace68e97$var$Cg(a, b)) {
                if ($0331271bace68e97$var$Dg(a)) throw Error($0331271bace68e97$var$p(418));
                b = $0331271bace68e97$var$Lf(c.nextSibling);
                var d = $0331271bace68e97$var$xg;
                b && $0331271bace68e97$var$Cg(a, b) ? $0331271bace68e97$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0331271bace68e97$var$I = !1, $0331271bace68e97$var$xg = a);
            }
        } else {
            if ($0331271bace68e97$var$Dg(a)) throw Error($0331271bace68e97$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0331271bace68e97$var$I = !1;
            $0331271bace68e97$var$xg = a;
        }
    }
}
function $0331271bace68e97$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0331271bace68e97$var$xg = a;
}
function $0331271bace68e97$var$Gg(a) {
    if (a !== $0331271bace68e97$var$xg) return !1;
    if (!$0331271bace68e97$var$I) return $0331271bace68e97$var$Fg(a), $0331271bace68e97$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0331271bace68e97$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0331271bace68e97$var$yg)) {
        if ($0331271bace68e97$var$Dg(a)) throw $0331271bace68e97$var$Hg(), Error($0331271bace68e97$var$p(418));
        for(; b;)$0331271bace68e97$var$Ag(a, b), b = $0331271bace68e97$var$Lf(b.nextSibling);
    }
    $0331271bace68e97$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0331271bace68e97$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0331271bace68e97$var$yg = $0331271bace68e97$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0331271bace68e97$var$yg = null;
        }
    } else $0331271bace68e97$var$yg = $0331271bace68e97$var$xg ? $0331271bace68e97$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0331271bace68e97$var$Hg() {
    for(var a = $0331271bace68e97$var$yg; a;)a = $0331271bace68e97$var$Lf(a.nextSibling);
}
function $0331271bace68e97$var$Ig() {
    $0331271bace68e97$var$yg = $0331271bace68e97$var$xg = null;
    $0331271bace68e97$var$I = !1;
}
function $0331271bace68e97$var$Jg(a) {
    null === $0331271bace68e97$var$zg ? $0331271bace68e97$var$zg = [
        a
    ] : $0331271bace68e97$var$zg.push(a);
}
var $0331271bace68e97$var$Kg = $0331271bace68e97$var$ua.ReactCurrentBatchConfig;
function $0331271bace68e97$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0331271bace68e97$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0331271bace68e97$var$Mg = $0331271bace68e97$var$Uf(null), $0331271bace68e97$var$Ng = null, $0331271bace68e97$var$Og = null, $0331271bace68e97$var$Pg = null;
function $0331271bace68e97$var$Qg() {
    $0331271bace68e97$var$Pg = $0331271bace68e97$var$Og = $0331271bace68e97$var$Ng = null;
}
function $0331271bace68e97$var$Rg(a) {
    var b = $0331271bace68e97$var$Mg.current;
    $0331271bace68e97$var$E($0331271bace68e97$var$Mg);
    a._currentValue = b;
}
function $0331271bace68e97$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0331271bace68e97$var$Tg(a, b) {
    $0331271bace68e97$var$Ng = a;
    $0331271bace68e97$var$Pg = $0331271bace68e97$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0331271bace68e97$var$Ug = !0), a.firstContext = null);
}
function $0331271bace68e97$var$Vg(a) {
    var b = a._currentValue;
    if ($0331271bace68e97$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0331271bace68e97$var$Og) {
            if (null === $0331271bace68e97$var$Ng) throw Error($0331271bace68e97$var$p(308));
            $0331271bace68e97$var$Og = a;
            $0331271bace68e97$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0331271bace68e97$var$Og = $0331271bace68e97$var$Og.next = a;
    }
    return b;
}
var $0331271bace68e97$var$Wg = null;
function $0331271bace68e97$var$Xg(a) {
    null === $0331271bace68e97$var$Wg ? $0331271bace68e97$var$Wg = [
        a
    ] : $0331271bace68e97$var$Wg.push(a);
}
function $0331271bace68e97$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0331271bace68e97$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0331271bace68e97$var$Zg(a, d);
}
function $0331271bace68e97$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0331271bace68e97$var$$g = !1;
function $0331271bace68e97$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0331271bace68e97$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0331271bace68e97$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0331271bace68e97$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0331271bace68e97$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0331271bace68e97$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0331271bace68e97$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0331271bace68e97$var$Zg(a, c);
}
function $0331271bace68e97$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0331271bace68e97$var$Cc(a, c);
    }
}
function $0331271bace68e97$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0331271bace68e97$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0331271bace68e97$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0331271bace68e97$var$A({}, q, r);
                            break a;
                        case 2:
                            $0331271bace68e97$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0331271bace68e97$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0331271bace68e97$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0331271bace68e97$var$p(191, e));
            e.call(d);
        }
    }
}
var $0331271bace68e97$var$jh = (new $dQFEZ.Component).refs;
function $0331271bace68e97$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0331271bace68e97$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0331271bace68e97$var$nh = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $0331271bace68e97$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $0331271bace68e97$var$L(), e = $0331271bace68e97$var$lh(a), f = $0331271bace68e97$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0331271bace68e97$var$dh(a, f, e);
        null !== b && ($0331271bace68e97$var$mh(b, a, e, d), $0331271bace68e97$var$eh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $0331271bace68e97$var$L(), e = $0331271bace68e97$var$lh(a), f = $0331271bace68e97$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0331271bace68e97$var$dh(a, f, e);
        null !== b && ($0331271bace68e97$var$mh(b, a, e, d), $0331271bace68e97$var$eh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $0331271bace68e97$var$L(), d = $0331271bace68e97$var$lh(a), e = $0331271bace68e97$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0331271bace68e97$var$dh(a, e, d);
        null !== b && ($0331271bace68e97$var$mh(b, a, d, c), $0331271bace68e97$var$eh(b, a, d));
    }
};
function $0331271bace68e97$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0331271bace68e97$var$Ie(c, d) || !$0331271bace68e97$var$Ie(e, f) : !0;
}
function $0331271bace68e97$var$ph(a, b, c) {
    var d = !1, e = $0331271bace68e97$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0331271bace68e97$var$Vg(f) : (e = $0331271bace68e97$var$Zf(b) ? $0331271bace68e97$var$Xf : $0331271bace68e97$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0331271bace68e97$var$Yf(a, e) : $0331271bace68e97$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0331271bace68e97$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0331271bace68e97$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0331271bace68e97$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0331271bace68e97$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0331271bace68e97$var$jh;
    $0331271bace68e97$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0331271bace68e97$var$Vg(f) : (f = $0331271bace68e97$var$Zf(b) ? $0331271bace68e97$var$Xf : $0331271bace68e97$var$H.current, e.context = $0331271bace68e97$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0331271bace68e97$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0331271bace68e97$var$nh.enqueueReplaceState(e, e.state, null), $0331271bace68e97$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0331271bace68e97$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0331271bace68e97$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0331271bace68e97$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                _$b === $0331271bace68e97$var$jh && (_$b = e.refs = {});
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0331271bace68e97$var$p(284));
        if (!c._owner) throw Error($0331271bace68e97$var$p(290, a));
    }
    return a;
}
function $0331271bace68e97$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0331271bace68e97$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0331271bace68e97$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0331271bace68e97$var$vh(a) {
    var b = function b(_b, c) {
        if (a) {
            var d = _b.deletions;
            null === d ? (_b.deletions = [
                c
            ], _b.flags |= 16) : d.push(c);
        }
    };
    var c = function c(_c, d) {
        if (!a) return null;
        for(; null !== d;)b(_c, d), d = d.sibling;
        return null;
    };
    var d = function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    };
    var e = function e(a, b) {
        a = $0331271bace68e97$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    };
    var f = function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    };
    var g = function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    };
    var h = function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0331271bace68e97$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    };
    var k = function k(a, b, c, d) {
        var f = c.type;
        if (f === $0331271bace68e97$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0331271bace68e97$var$Ha && $0331271bace68e97$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0331271bace68e97$var$sh(a, b, c), d.return = a, d;
        d = $0331271bace68e97$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0331271bace68e97$var$sh(a, b, c);
        d.return = a;
        return d;
    };
    var l = function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0331271bace68e97$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    };
    var m = function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0331271bace68e97$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    };
    var n = function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0331271bace68e97$var$I && $0331271bace68e97$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0331271bace68e97$var$I && $0331271bace68e97$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0331271bace68e97$var$I && $0331271bace68e97$var$tg(e, w);
        return l;
    };
    var t = function t(e, g, h, k) {
        var l = $0331271bace68e97$var$Ka(h);
        if ("function" !== typeof l) throw Error($0331271bace68e97$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0331271bace68e97$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0331271bace68e97$var$I && $0331271bace68e97$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0331271bace68e97$var$I && $0331271bace68e97$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0331271bace68e97$var$I && $0331271bace68e97$var$tg(e, w);
        return l;
    };
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0331271bace68e97$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0331271bace68e97$var$va:
                    return c = $0331271bace68e97$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0331271bace68e97$var$sh(a, null, b), c.return = a, c;
                case $0331271bace68e97$var$wa:
                    return b = $0331271bace68e97$var$zh(b, a.mode, c), b.return = a, b;
                case $0331271bace68e97$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0331271bace68e97$var$eb(b) || $0331271bace68e97$var$Ka(b)) return b = $0331271bace68e97$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0331271bace68e97$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0331271bace68e97$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0331271bace68e97$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0331271bace68e97$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0331271bace68e97$var$eb(c) || $0331271bace68e97$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0331271bace68e97$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0331271bace68e97$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0331271bace68e97$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0331271bace68e97$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0331271bace68e97$var$eb(d) || $0331271bace68e97$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0331271bace68e97$var$th(b, d);
        }
        return null;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0331271bace68e97$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0331271bace68e97$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0331271bace68e97$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0331271bace68e97$var$Ha && $0331271bace68e97$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0331271bace68e97$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0331271bace68e97$var$ya ? (d = $0331271bace68e97$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0331271bace68e97$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0331271bace68e97$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0331271bace68e97$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0331271bace68e97$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0331271bace68e97$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0331271bace68e97$var$eb(f)) return n(a, d, f, h);
            if ($0331271bace68e97$var$Ka(f)) return t(a, d, f, h);
            $0331271bace68e97$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0331271bace68e97$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0331271bace68e97$var$Bh = $0331271bace68e97$var$vh(!0), $0331271bace68e97$var$Ch = $0331271bace68e97$var$vh(!1), $0331271bace68e97$var$Dh = {}, $0331271bace68e97$var$Eh = $0331271bace68e97$var$Uf($0331271bace68e97$var$Dh), $0331271bace68e97$var$Fh = $0331271bace68e97$var$Uf($0331271bace68e97$var$Dh), $0331271bace68e97$var$Gh = $0331271bace68e97$var$Uf($0331271bace68e97$var$Dh);
function $0331271bace68e97$var$Hh(a) {
    if (a === $0331271bace68e97$var$Dh) throw Error($0331271bace68e97$var$p(174));
    return a;
}
function $0331271bace68e97$var$Ih(a, b) {
    $0331271bace68e97$var$G($0331271bace68e97$var$Gh, b);
    $0331271bace68e97$var$G($0331271bace68e97$var$Fh, a);
    $0331271bace68e97$var$G($0331271bace68e97$var$Eh, $0331271bace68e97$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0331271bace68e97$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0331271bace68e97$var$lb(b, a);
    }
    $0331271bace68e97$var$E($0331271bace68e97$var$Eh);
    $0331271bace68e97$var$G($0331271bace68e97$var$Eh, b);
}
function $0331271bace68e97$var$Jh() {
    $0331271bace68e97$var$E($0331271bace68e97$var$Eh);
    $0331271bace68e97$var$E($0331271bace68e97$var$Fh);
    $0331271bace68e97$var$E($0331271bace68e97$var$Gh);
}
function $0331271bace68e97$var$Kh(a) {
    $0331271bace68e97$var$Hh($0331271bace68e97$var$Gh.current);
    var b = $0331271bace68e97$var$Hh($0331271bace68e97$var$Eh.current);
    var c = $0331271bace68e97$var$lb(b, a.type);
    b !== c && ($0331271bace68e97$var$G($0331271bace68e97$var$Fh, a), $0331271bace68e97$var$G($0331271bace68e97$var$Eh, c));
}
function $0331271bace68e97$var$Lh(a) {
    $0331271bace68e97$var$Fh.current === a && ($0331271bace68e97$var$E($0331271bace68e97$var$Eh), $0331271bace68e97$var$E($0331271bace68e97$var$Fh));
}
var $0331271bace68e97$var$M = $0331271bace68e97$var$Uf(0);
function $0331271bace68e97$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0331271bace68e97$var$Nh = [];
function $0331271bace68e97$var$Oh() {
    for(var a = 0; a < $0331271bace68e97$var$Nh.length; a++)$0331271bace68e97$var$Nh[a]._workInProgressVersionPrimary = null;
    $0331271bace68e97$var$Nh.length = 0;
}
var $0331271bace68e97$var$Ph = $0331271bace68e97$var$ua.ReactCurrentDispatcher, $0331271bace68e97$var$Qh = $0331271bace68e97$var$ua.ReactCurrentBatchConfig, $0331271bace68e97$var$Rh = 0, $0331271bace68e97$var$N = null, $0331271bace68e97$var$O = null, $0331271bace68e97$var$P = null, $0331271bace68e97$var$Sh = !1, $0331271bace68e97$var$Th = !1, $0331271bace68e97$var$Uh = 0, $0331271bace68e97$var$Vh = 0;
function $0331271bace68e97$var$Q() {
    throw Error($0331271bace68e97$var$p(321));
}
function $0331271bace68e97$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0331271bace68e97$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0331271bace68e97$var$Xh(a, b, c, d, e, f) {
    $0331271bace68e97$var$Rh = f;
    $0331271bace68e97$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0331271bace68e97$var$Ph.current = null === a || null === a.memoizedState ? $0331271bace68e97$var$Yh : $0331271bace68e97$var$Zh;
    a = c(d, e);
    if ($0331271bace68e97$var$Th) {
        f = 0;
        do {
            $0331271bace68e97$var$Th = !1;
            $0331271bace68e97$var$Uh = 0;
            if (25 <= f) throw Error($0331271bace68e97$var$p(301));
            f += 1;
            $0331271bace68e97$var$P = $0331271bace68e97$var$O = null;
            b.updateQueue = null;
            $0331271bace68e97$var$Ph.current = $0331271bace68e97$var$$h;
            a = c(d, e);
        }while ($0331271bace68e97$var$Th);
    }
    $0331271bace68e97$var$Ph.current = $0331271bace68e97$var$ai;
    b = null !== $0331271bace68e97$var$O && null !== $0331271bace68e97$var$O.next;
    $0331271bace68e97$var$Rh = 0;
    $0331271bace68e97$var$P = $0331271bace68e97$var$O = $0331271bace68e97$var$N = null;
    $0331271bace68e97$var$Sh = !1;
    if (b) throw Error($0331271bace68e97$var$p(300));
    return a;
}
function $0331271bace68e97$var$bi() {
    var a = 0 !== $0331271bace68e97$var$Uh;
    $0331271bace68e97$var$Uh = 0;
    return a;
}
function $0331271bace68e97$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0331271bace68e97$var$P ? $0331271bace68e97$var$N.memoizedState = $0331271bace68e97$var$P = a : $0331271bace68e97$var$P = $0331271bace68e97$var$P.next = a;
    return $0331271bace68e97$var$P;
}
function $0331271bace68e97$var$di() {
    if (null === $0331271bace68e97$var$O) {
        var a = $0331271bace68e97$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0331271bace68e97$var$O.next;
    var b = null === $0331271bace68e97$var$P ? $0331271bace68e97$var$N.memoizedState : $0331271bace68e97$var$P.next;
    if (null !== b) $0331271bace68e97$var$P = b, $0331271bace68e97$var$O = a;
    else {
        if (null === a) throw Error($0331271bace68e97$var$p(310));
        $0331271bace68e97$var$O = a;
        a = {
            memoizedState: $0331271bace68e97$var$O.memoizedState,
            baseState: $0331271bace68e97$var$O.baseState,
            baseQueue: $0331271bace68e97$var$O.baseQueue,
            queue: $0331271bace68e97$var$O.queue,
            next: null
        };
        null === $0331271bace68e97$var$P ? $0331271bace68e97$var$N.memoizedState = $0331271bace68e97$var$P = a : $0331271bace68e97$var$P = $0331271bace68e97$var$P.next = a;
    }
    return $0331271bace68e97$var$P;
}
function $0331271bace68e97$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0331271bace68e97$var$fi(a) {
    var b = $0331271bace68e97$var$di(), c = b.queue;
    if (null === c) throw Error($0331271bace68e97$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0331271bace68e97$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0331271bace68e97$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0331271bace68e97$var$N.lanes |= m;
                $0331271bace68e97$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0331271bace68e97$var$He(d, b.memoizedState) || ($0331271bace68e97$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0331271bace68e97$var$N.lanes |= f, $0331271bace68e97$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0331271bace68e97$var$gi(a) {
    var b = $0331271bace68e97$var$di(), c = b.queue;
    if (null === c) throw Error($0331271bace68e97$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0331271bace68e97$var$He(f, b.memoizedState) || ($0331271bace68e97$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0331271bace68e97$var$hi() {}
function $0331271bace68e97$var$ii(a, b) {
    var c = $0331271bace68e97$var$N, d = $0331271bace68e97$var$di(), e = b(), f = !$0331271bace68e97$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0331271bace68e97$var$Ug = !0);
    d = d.queue;
    $0331271bace68e97$var$ji($0331271bace68e97$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0331271bace68e97$var$P && $0331271bace68e97$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0331271bace68e97$var$li(9, $0331271bace68e97$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0331271bace68e97$var$R) throw Error($0331271bace68e97$var$p(349));
        0 !== ($0331271bace68e97$var$Rh & 30) || $0331271bace68e97$var$ni(c, b, e);
    }
    return e;
}
function $0331271bace68e97$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0331271bace68e97$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0331271bace68e97$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0331271bace68e97$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0331271bace68e97$var$oi(b) && $0331271bace68e97$var$pi(a);
}
function $0331271bace68e97$var$ki(a, b, c) {
    return c(function() {
        $0331271bace68e97$var$oi(b) && $0331271bace68e97$var$pi(a);
    });
}
function $0331271bace68e97$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0331271bace68e97$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0331271bace68e97$var$pi(a) {
    var b = $0331271bace68e97$var$Zg(a, 1);
    null !== b && $0331271bace68e97$var$mh(b, a, 1, -1);
}
function $0331271bace68e97$var$qi(a) {
    var b = $0331271bace68e97$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0331271bace68e97$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0331271bace68e97$var$ri.bind(null, $0331271bace68e97$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0331271bace68e97$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0331271bace68e97$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0331271bace68e97$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0331271bace68e97$var$si() {
    return $0331271bace68e97$var$di().memoizedState;
}
function $0331271bace68e97$var$ti(a, b, c, d) {
    var e = $0331271bace68e97$var$ci();
    $0331271bace68e97$var$N.flags |= a;
    e.memoizedState = $0331271bace68e97$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0331271bace68e97$var$ui(a, b, c, d) {
    var e = $0331271bace68e97$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0331271bace68e97$var$O) {
        var g = $0331271bace68e97$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0331271bace68e97$var$Wh(d, g.deps)) {
            e.memoizedState = $0331271bace68e97$var$li(b, c, f, d);
            return;
        }
    }
    $0331271bace68e97$var$N.flags |= a;
    e.memoizedState = $0331271bace68e97$var$li(1 | b, c, f, d);
}
function $0331271bace68e97$var$vi(a, b) {
    return $0331271bace68e97$var$ti(8390656, 8, a, b);
}
function $0331271bace68e97$var$ji(a, b) {
    return $0331271bace68e97$var$ui(2048, 8, a, b);
}
function $0331271bace68e97$var$wi(a, b) {
    return $0331271bace68e97$var$ui(4, 2, a, b);
}
function $0331271bace68e97$var$xi(a, b) {
    return $0331271bace68e97$var$ui(4, 4, a, b);
}
function $0331271bace68e97$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0331271bace68e97$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0331271bace68e97$var$ui(4, 4, $0331271bace68e97$var$yi.bind(null, b, a), c);
}
function $0331271bace68e97$var$Ai() {}
function $0331271bace68e97$var$Bi(a, b) {
    var c = $0331271bace68e97$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0331271bace68e97$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0331271bace68e97$var$Ci(a, b) {
    var c = $0331271bace68e97$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0331271bace68e97$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0331271bace68e97$var$Di(a, b, c) {
    if (0 === ($0331271bace68e97$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0331271bace68e97$var$Ug = !0), a.memoizedState = c;
    $0331271bace68e97$var$He(c, b) || (c = $0331271bace68e97$var$yc(), $0331271bace68e97$var$N.lanes |= c, $0331271bace68e97$var$hh |= c, a.baseState = !0);
    return b;
}
function $0331271bace68e97$var$Ei(a, b) {
    var c = $0331271bace68e97$var$C;
    $0331271bace68e97$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0331271bace68e97$var$Qh.transition;
    $0331271bace68e97$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0331271bace68e97$var$C = c, $0331271bace68e97$var$Qh.transition = d;
    }
}
function $0331271bace68e97$var$Fi() {
    return $0331271bace68e97$var$di().memoizedState;
}
function $0331271bace68e97$var$Gi(a, b, c) {
    var d = $0331271bace68e97$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0331271bace68e97$var$Hi(a)) $0331271bace68e97$var$Ii(b, c);
    else if (c = $0331271bace68e97$var$Yg(a, b, c, d), null !== c) {
        var e = $0331271bace68e97$var$L();
        $0331271bace68e97$var$mh(c, a, d, e);
        $0331271bace68e97$var$Ji(c, b, d);
    }
}
function $0331271bace68e97$var$ri(a, b, c) {
    var d = $0331271bace68e97$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0331271bace68e97$var$Hi(a)) $0331271bace68e97$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0331271bace68e97$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0331271bace68e97$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0331271bace68e97$var$Yg(a, b, e, d);
        null !== c && (e = $0331271bace68e97$var$L(), $0331271bace68e97$var$mh(c, a, d, e), $0331271bace68e97$var$Ji(c, b, d));
    }
}
function $0331271bace68e97$var$Hi(a) {
    var b = a.alternate;
    return a === $0331271bace68e97$var$N || null !== b && b === $0331271bace68e97$var$N;
}
function $0331271bace68e97$var$Ii(a, b) {
    $0331271bace68e97$var$Th = $0331271bace68e97$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0331271bace68e97$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0331271bace68e97$var$Cc(a, c);
    }
}
var $0331271bace68e97$var$ai = {
    readContext: $0331271bace68e97$var$Vg,
    useCallback: $0331271bace68e97$var$Q,
    useContext: $0331271bace68e97$var$Q,
    useEffect: $0331271bace68e97$var$Q,
    useImperativeHandle: $0331271bace68e97$var$Q,
    useInsertionEffect: $0331271bace68e97$var$Q,
    useLayoutEffect: $0331271bace68e97$var$Q,
    useMemo: $0331271bace68e97$var$Q,
    useReducer: $0331271bace68e97$var$Q,
    useRef: $0331271bace68e97$var$Q,
    useState: $0331271bace68e97$var$Q,
    useDebugValue: $0331271bace68e97$var$Q,
    useDeferredValue: $0331271bace68e97$var$Q,
    useTransition: $0331271bace68e97$var$Q,
    useMutableSource: $0331271bace68e97$var$Q,
    useSyncExternalStore: $0331271bace68e97$var$Q,
    useId: $0331271bace68e97$var$Q,
    unstable_isNewReconciler: !1
}, $0331271bace68e97$var$Yh = {
    readContext: $0331271bace68e97$var$Vg,
    useCallback: function useCallback(a, b) {
        $0331271bace68e97$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0331271bace68e97$var$Vg,
    useEffect: $0331271bace68e97$var$vi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0331271bace68e97$var$ti(4194308, 4, $0331271bace68e97$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $0331271bace68e97$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $0331271bace68e97$var$ti(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $0331271bace68e97$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $0331271bace68e97$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0331271bace68e97$var$Gi.bind(null, $0331271bace68e97$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $0331271bace68e97$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0331271bace68e97$var$qi,
    useDebugValue: $0331271bace68e97$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        return $0331271bace68e97$var$ci().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $0331271bace68e97$var$qi(!1), b = a[0];
        a = $0331271bace68e97$var$Ei.bind(null, a[1]);
        $0331271bace68e97$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $0331271bace68e97$var$N, e = $0331271bace68e97$var$ci();
        if ($0331271bace68e97$var$I) {
            if (void 0 === c) throw Error($0331271bace68e97$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0331271bace68e97$var$R) throw Error($0331271bace68e97$var$p(349));
            0 !== ($0331271bace68e97$var$Rh & 30) || $0331271bace68e97$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0331271bace68e97$var$vi($0331271bace68e97$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0331271bace68e97$var$li(9, $0331271bace68e97$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $0331271bace68e97$var$ci(), b = $0331271bace68e97$var$R.identifierPrefix;
        if ($0331271bace68e97$var$I) {
            var c = $0331271bace68e97$var$sg;
            var d = $0331271bace68e97$var$rg;
            c = (d & ~(1 << 32 - $0331271bace68e97$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0331271bace68e97$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0331271bace68e97$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0331271bace68e97$var$Zh = {
    readContext: $0331271bace68e97$var$Vg,
    useCallback: $0331271bace68e97$var$Bi,
    useContext: $0331271bace68e97$var$Vg,
    useEffect: $0331271bace68e97$var$ji,
    useImperativeHandle: $0331271bace68e97$var$zi,
    useInsertionEffect: $0331271bace68e97$var$wi,
    useLayoutEffect: $0331271bace68e97$var$xi,
    useMemo: $0331271bace68e97$var$Ci,
    useReducer: $0331271bace68e97$var$fi,
    useRef: $0331271bace68e97$var$si,
    useState: function useState() {
        return $0331271bace68e97$var$fi($0331271bace68e97$var$ei);
    },
    useDebugValue: $0331271bace68e97$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $0331271bace68e97$var$di();
        return $0331271bace68e97$var$Di(b, $0331271bace68e97$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $0331271bace68e97$var$fi($0331271bace68e97$var$ei)[0], b = $0331271bace68e97$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0331271bace68e97$var$hi,
    useSyncExternalStore: $0331271bace68e97$var$ii,
    useId: $0331271bace68e97$var$Fi,
    unstable_isNewReconciler: !1
}, $0331271bace68e97$var$$h = {
    readContext: $0331271bace68e97$var$Vg,
    useCallback: $0331271bace68e97$var$Bi,
    useContext: $0331271bace68e97$var$Vg,
    useEffect: $0331271bace68e97$var$ji,
    useImperativeHandle: $0331271bace68e97$var$zi,
    useInsertionEffect: $0331271bace68e97$var$wi,
    useLayoutEffect: $0331271bace68e97$var$xi,
    useMemo: $0331271bace68e97$var$Ci,
    useReducer: $0331271bace68e97$var$gi,
    useRef: $0331271bace68e97$var$si,
    useState: function useState() {
        return $0331271bace68e97$var$gi($0331271bace68e97$var$ei);
    },
    useDebugValue: $0331271bace68e97$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $0331271bace68e97$var$di();
        return null === $0331271bace68e97$var$O ? b.memoizedState = a : $0331271bace68e97$var$Di(b, $0331271bace68e97$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $0331271bace68e97$var$gi($0331271bace68e97$var$ei)[0], b = $0331271bace68e97$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0331271bace68e97$var$hi,
    useSyncExternalStore: $0331271bace68e97$var$ii,
    useId: $0331271bace68e97$var$Fi,
    unstable_isNewReconciler: !1
};
function $0331271bace68e97$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0331271bace68e97$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0331271bace68e97$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0331271bace68e97$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0331271bace68e97$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0331271bace68e97$var$Oi(a, b, c) {
    c = $0331271bace68e97$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0331271bace68e97$var$Pi || ($0331271bace68e97$var$Pi = !0, $0331271bace68e97$var$Qi = d);
        $0331271bace68e97$var$Mi(a, b);
    };
    return c;
}
function $0331271bace68e97$var$Ri(a, b, c) {
    c = $0331271bace68e97$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0331271bace68e97$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0331271bace68e97$var$Mi(a, b);
        "function" !== typeof d && (null === $0331271bace68e97$var$Si ? $0331271bace68e97$var$Si = new Set([
            this
        ]) : $0331271bace68e97$var$Si.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $0331271bace68e97$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0331271bace68e97$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0331271bace68e97$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0331271bace68e97$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0331271bace68e97$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0331271bace68e97$var$ch(-1, 1), b.tag = 2, $0331271bace68e97$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0331271bace68e97$var$Xi = $0331271bace68e97$var$ua.ReactCurrentOwner, $0331271bace68e97$var$Ug = !1;
function $0331271bace68e97$var$Yi(a, b, c, d) {
    b.child = null === a ? $0331271bace68e97$var$Ch(b, null, c, d) : $0331271bace68e97$var$Bh(b, a.child, c, d);
}
function $0331271bace68e97$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0331271bace68e97$var$Tg(b, e);
    d = $0331271bace68e97$var$Xh(a, b, c, d, f, e);
    c = $0331271bace68e97$var$bi();
    if (null !== a && !$0331271bace68e97$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0331271bace68e97$var$$i(a, b, e);
    $0331271bace68e97$var$I && c && $0331271bace68e97$var$vg(b);
    b.flags |= 1;
    $0331271bace68e97$var$Yi(a, b, d, e);
    return b.child;
}
function $0331271bace68e97$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0331271bace68e97$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0331271bace68e97$var$cj(a, b, f, d, e);
        a = $0331271bace68e97$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0331271bace68e97$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0331271bace68e97$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0331271bace68e97$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0331271bace68e97$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0331271bace68e97$var$Ie(f, d) && a.ref === b.ref) {
            if ($0331271bace68e97$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0331271bace68e97$var$Ug = !0);
            else return b.lanes = a.lanes, $0331271bace68e97$var$$i(a, b, e);
        }
    }
    return $0331271bace68e97$var$dj(a, b, c, d, e);
}
function $0331271bace68e97$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0331271bace68e97$var$G($0331271bace68e97$var$fj, $0331271bace68e97$var$gj), $0331271bace68e97$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0331271bace68e97$var$G($0331271bace68e97$var$fj, $0331271bace68e97$var$gj), $0331271bace68e97$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0331271bace68e97$var$G($0331271bace68e97$var$fj, $0331271bace68e97$var$gj);
            $0331271bace68e97$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0331271bace68e97$var$G($0331271bace68e97$var$fj, $0331271bace68e97$var$gj), $0331271bace68e97$var$gj |= d;
    $0331271bace68e97$var$Yi(a, b, e, c);
    return b.child;
}
function $0331271bace68e97$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0331271bace68e97$var$dj(a, b, c, d, e) {
    var f = $0331271bace68e97$var$Zf(c) ? $0331271bace68e97$var$Xf : $0331271bace68e97$var$H.current;
    f = $0331271bace68e97$var$Yf(b, f);
    $0331271bace68e97$var$Tg(b, e);
    c = $0331271bace68e97$var$Xh(a, b, c, d, f, e);
    d = $0331271bace68e97$var$bi();
    if (null !== a && !$0331271bace68e97$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0331271bace68e97$var$$i(a, b, e);
    $0331271bace68e97$var$I && d && $0331271bace68e97$var$vg(b);
    b.flags |= 1;
    $0331271bace68e97$var$Yi(a, b, c, e);
    return b.child;
}
function $0331271bace68e97$var$ij(a, b, c, d, e) {
    if ($0331271bace68e97$var$Zf(c)) {
        var f = !0;
        $0331271bace68e97$var$cg(b);
    } else f = !1;
    $0331271bace68e97$var$Tg(b, e);
    if (null === b.stateNode) $0331271bace68e97$var$jj(a, b), $0331271bace68e97$var$ph(b, c, d), $0331271bace68e97$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0331271bace68e97$var$Vg(l) : (l = $0331271bace68e97$var$Zf(c) ? $0331271bace68e97$var$Xf : $0331271bace68e97$var$H.current, l = $0331271bace68e97$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0331271bace68e97$var$qh(b, g, d, l);
        $0331271bace68e97$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0331271bace68e97$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0331271bace68e97$var$Wf.current || $0331271bace68e97$var$$g ? ("function" === typeof m && ($0331271bace68e97$var$kh(b, c, m, d), k = b.memoizedState), (h = $0331271bace68e97$var$$g || $0331271bace68e97$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0331271bace68e97$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0331271bace68e97$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0331271bace68e97$var$Vg(k) : (k = $0331271bace68e97$var$Zf(c) ? $0331271bace68e97$var$Xf : $0331271bace68e97$var$H.current, k = $0331271bace68e97$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0331271bace68e97$var$qh(b, g, d, k);
        $0331271bace68e97$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0331271bace68e97$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0331271bace68e97$var$Wf.current || $0331271bace68e97$var$$g ? ("function" === typeof y && ($0331271bace68e97$var$kh(b, c, y, d), n = b.memoizedState), (l = $0331271bace68e97$var$$g || $0331271bace68e97$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0331271bace68e97$var$kj(a, b, c, d, f, e);
}
function $0331271bace68e97$var$kj(a, b, c, d, e, f) {
    $0331271bace68e97$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0331271bace68e97$var$dg(b, c, !1), $0331271bace68e97$var$$i(a, b, f);
    d = b.stateNode;
    $0331271bace68e97$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0331271bace68e97$var$Bh(b, a.child, null, f), b.child = $0331271bace68e97$var$Bh(b, null, h, f)) : $0331271bace68e97$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0331271bace68e97$var$dg(b, c, !0);
    return b.child;
}
function $0331271bace68e97$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0331271bace68e97$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0331271bace68e97$var$ag(a, b.context, !1);
    $0331271bace68e97$var$Ih(a, b.containerInfo);
}
function $0331271bace68e97$var$mj(a, b, c, d, e) {
    $0331271bace68e97$var$Ig();
    $0331271bace68e97$var$Jg(e);
    b.flags |= 256;
    $0331271bace68e97$var$Yi(a, b, c, d);
    return b.child;
}
var $0331271bace68e97$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0331271bace68e97$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0331271bace68e97$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0331271bace68e97$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0331271bace68e97$var$G($0331271bace68e97$var$M, e & 1);
    if (null === a) {
        $0331271bace68e97$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0331271bace68e97$var$qj(g, d, 0, null), a = $0331271bace68e97$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0331271bace68e97$var$oj(c), b.memoizedState = $0331271bace68e97$var$nj, a) : $0331271bace68e97$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0331271bace68e97$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0331271bace68e97$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0331271bace68e97$var$wh(h, f) : (f = $0331271bace68e97$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0331271bace68e97$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0331271bace68e97$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0331271bace68e97$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0331271bace68e97$var$rj(a, b) {
    b = $0331271bace68e97$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0331271bace68e97$var$tj(a, b, c, d) {
    null !== d && $0331271bace68e97$var$Jg(d);
    $0331271bace68e97$var$Bh(b, a.child, null, c);
    a = $0331271bace68e97$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0331271bace68e97$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0331271bace68e97$var$Li(Error($0331271bace68e97$var$p(422))), $0331271bace68e97$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0331271bace68e97$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0331271bace68e97$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0331271bace68e97$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0331271bace68e97$var$oj(g);
        b.memoizedState = $0331271bace68e97$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0331271bace68e97$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0331271bace68e97$var$p(419));
        d = $0331271bace68e97$var$Li(f, d, void 0);
        return $0331271bace68e97$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0331271bace68e97$var$Ug || h) {
        d = $0331271bace68e97$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0331271bace68e97$var$Zg(a, e), $0331271bace68e97$var$mh(d, a, e, -1));
        }
        $0331271bace68e97$var$uj();
        d = $0331271bace68e97$var$Li(Error($0331271bace68e97$var$p(421)));
        return $0331271bace68e97$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0331271bace68e97$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0331271bace68e97$var$yg = $0331271bace68e97$var$Lf(e.nextSibling);
    $0331271bace68e97$var$xg = b;
    $0331271bace68e97$var$I = !0;
    $0331271bace68e97$var$zg = null;
    null !== a && ($0331271bace68e97$var$og[$0331271bace68e97$var$pg++] = $0331271bace68e97$var$rg, $0331271bace68e97$var$og[$0331271bace68e97$var$pg++] = $0331271bace68e97$var$sg, $0331271bace68e97$var$og[$0331271bace68e97$var$pg++] = $0331271bace68e97$var$qg, $0331271bace68e97$var$rg = a.id, $0331271bace68e97$var$sg = a.overflow, $0331271bace68e97$var$qg = b);
    b = $0331271bace68e97$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0331271bace68e97$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0331271bace68e97$var$Sg(a.return, b, c);
}
function $0331271bace68e97$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0331271bace68e97$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0331271bace68e97$var$Yi(a, b, d.children, c);
    d = $0331271bace68e97$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0331271bace68e97$var$wj(a, c, b);
            else if (19 === a.tag) $0331271bace68e97$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0331271bace68e97$var$G($0331271bace68e97$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0331271bace68e97$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0331271bace68e97$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0331271bace68e97$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0331271bace68e97$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0331271bace68e97$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0331271bace68e97$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0331271bace68e97$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0331271bace68e97$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0331271bace68e97$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0331271bace68e97$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0331271bace68e97$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0331271bace68e97$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0331271bace68e97$var$lj(b);
            $0331271bace68e97$var$Ig();
            break;
        case 5:
            $0331271bace68e97$var$Kh(b);
            break;
        case 1:
            $0331271bace68e97$var$Zf(b.type) && $0331271bace68e97$var$cg(b);
            break;
        case 4:
            $0331271bace68e97$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0331271bace68e97$var$G($0331271bace68e97$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0331271bace68e97$var$G($0331271bace68e97$var$M, $0331271bace68e97$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0331271bace68e97$var$pj(a, b, c);
                $0331271bace68e97$var$G($0331271bace68e97$var$M, $0331271bace68e97$var$M.current & 1);
                a = $0331271bace68e97$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0331271bace68e97$var$G($0331271bace68e97$var$M, $0331271bace68e97$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0331271bace68e97$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0331271bace68e97$var$G($0331271bace68e97$var$M, $0331271bace68e97$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0331271bace68e97$var$ej(a, b, c);
    }
    return $0331271bace68e97$var$$i(a, b, c);
}
var $0331271bace68e97$var$Aj, $0331271bace68e97$var$Bj, $0331271bace68e97$var$Cj, $0331271bace68e97$var$Dj;
$0331271bace68e97$var$Aj = function Aj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0331271bace68e97$var$Bj = function Bj() {};
$0331271bace68e97$var$Cj = function Cj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0331271bace68e97$var$Hh($0331271bace68e97$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0331271bace68e97$var$Ya(a, e);
                d = $0331271bace68e97$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0331271bace68e97$var$A({}, e, {
                    value: void 0
                });
                d = $0331271bace68e97$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0331271bace68e97$var$gb(a, e);
                d = $0331271bace68e97$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0331271bace68e97$var$Bf);
        }
        $0331271bace68e97$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0331271bace68e97$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0331271bace68e97$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0331271bace68e97$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0331271bace68e97$var$Dj = function Dj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0331271bace68e97$var$Ej(a, b) {
    if (!$0331271bace68e97$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0331271bace68e97$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0331271bace68e97$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0331271bace68e97$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0331271bace68e97$var$S(b), null;
        case 1:
            return $0331271bace68e97$var$Zf(b.type) && $0331271bace68e97$var$$f(), $0331271bace68e97$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0331271bace68e97$var$Jh();
            $0331271bace68e97$var$E($0331271bace68e97$var$Wf);
            $0331271bace68e97$var$E($0331271bace68e97$var$H);
            $0331271bace68e97$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0331271bace68e97$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0331271bace68e97$var$zg && ($0331271bace68e97$var$Gj($0331271bace68e97$var$zg), $0331271bace68e97$var$zg = null));
            $0331271bace68e97$var$Bj(a, b);
            $0331271bace68e97$var$S(b);
            return null;
        case 5:
            $0331271bace68e97$var$Lh(b);
            var e = $0331271bace68e97$var$Hh($0331271bace68e97$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0331271bace68e97$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0331271bace68e97$var$p(166));
                    $0331271bace68e97$var$S(b);
                    return null;
                }
                a = $0331271bace68e97$var$Hh($0331271bace68e97$var$Eh.current);
                if ($0331271bace68e97$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0331271bace68e97$var$Of] = b;
                    d[$0331271bace68e97$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0331271bace68e97$var$D("cancel", d);
                            $0331271bace68e97$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0331271bace68e97$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0331271bace68e97$var$lf.length; e++)$0331271bace68e97$var$D($0331271bace68e97$var$lf[e], d);
                            break;
                        case "source":
                            $0331271bace68e97$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0331271bace68e97$var$D("error", d);
                            $0331271bace68e97$var$D("load", d);
                            break;
                        case "details":
                            $0331271bace68e97$var$D("toggle", d);
                            break;
                        case "input":
                            $0331271bace68e97$var$Za(d, f);
                            $0331271bace68e97$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0331271bace68e97$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0331271bace68e97$var$hb(d, f), $0331271bace68e97$var$D("invalid", d);
                    }
                    $0331271bace68e97$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0331271bace68e97$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0331271bace68e97$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0331271bace68e97$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0331271bace68e97$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0331271bace68e97$var$Va(d);
                            $0331271bace68e97$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0331271bace68e97$var$Va(d);
                            $0331271bace68e97$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0331271bace68e97$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0331271bace68e97$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0331271bace68e97$var$Of] = b;
                    a[$0331271bace68e97$var$Pf] = d;
                    $0331271bace68e97$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0331271bace68e97$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0331271bace68e97$var$D("cancel", a);
                                $0331271bace68e97$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0331271bace68e97$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0331271bace68e97$var$lf.length; e++)$0331271bace68e97$var$D($0331271bace68e97$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0331271bace68e97$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0331271bace68e97$var$D("error", a);
                                $0331271bace68e97$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0331271bace68e97$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0331271bace68e97$var$Za(a, d);
                                e = $0331271bace68e97$var$Ya(a, d);
                                $0331271bace68e97$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0331271bace68e97$var$A({}, d, {
                                    value: void 0
                                });
                                $0331271bace68e97$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0331271bace68e97$var$hb(a, d);
                                e = $0331271bace68e97$var$gb(a, d);
                                $0331271bace68e97$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0331271bace68e97$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0331271bace68e97$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0331271bace68e97$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0331271bace68e97$var$ob(a, k) : "number" === typeof k && $0331271bace68e97$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0331271bace68e97$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0331271bace68e97$var$D("scroll", a) : null != k && $0331271bace68e97$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0331271bace68e97$var$Va(a);
                                $0331271bace68e97$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0331271bace68e97$var$Va(a);
                                $0331271bace68e97$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0331271bace68e97$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0331271bace68e97$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0331271bace68e97$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0331271bace68e97$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0331271bace68e97$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0331271bace68e97$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0331271bace68e97$var$p(166));
                c = $0331271bace68e97$var$Hh($0331271bace68e97$var$Gh.current);
                $0331271bace68e97$var$Hh($0331271bace68e97$var$Eh.current);
                if ($0331271bace68e97$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0331271bace68e97$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0331271bace68e97$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0331271bace68e97$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0331271bace68e97$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0331271bace68e97$var$Of] = b, b.stateNode = d;
            }
            $0331271bace68e97$var$S(b);
            return null;
        case 13:
            $0331271bace68e97$var$E($0331271bace68e97$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0331271bace68e97$var$I && null !== $0331271bace68e97$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0331271bace68e97$var$Hg(), $0331271bace68e97$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0331271bace68e97$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0331271bace68e97$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0331271bace68e97$var$p(317));
                        f[$0331271bace68e97$var$Of] = b;
                    } else $0331271bace68e97$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0331271bace68e97$var$S(b);
                    f = !1;
                } else null !== $0331271bace68e97$var$zg && ($0331271bace68e97$var$Gj($0331271bace68e97$var$zg), $0331271bace68e97$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0331271bace68e97$var$M.current & 1) ? 0 === $0331271bace68e97$var$T && ($0331271bace68e97$var$T = 3) : $0331271bace68e97$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0331271bace68e97$var$S(b);
            return null;
        case 4:
            return $0331271bace68e97$var$Jh(), $0331271bace68e97$var$Bj(a, b), null === a && $0331271bace68e97$var$sf(b.stateNode.containerInfo), $0331271bace68e97$var$S(b), null;
        case 10:
            return $0331271bace68e97$var$Rg(b.type._context), $0331271bace68e97$var$S(b), null;
        case 17:
            return $0331271bace68e97$var$Zf(b.type) && $0331271bace68e97$var$$f(), $0331271bace68e97$var$S(b), null;
        case 19:
            $0331271bace68e97$var$E($0331271bace68e97$var$M);
            f = b.memoizedState;
            if (null === f) return $0331271bace68e97$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0331271bace68e97$var$Ej(f, !1);
                else {
                    if (0 !== $0331271bace68e97$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0331271bace68e97$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0331271bace68e97$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0331271bace68e97$var$G($0331271bace68e97$var$M, $0331271bace68e97$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0331271bace68e97$var$B() > $0331271bace68e97$var$Hj && (b.flags |= 128, d = !0, $0331271bace68e97$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0331271bace68e97$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0331271bace68e97$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0331271bace68e97$var$I) return $0331271bace68e97$var$S(b), null;
                    } else 2 * $0331271bace68e97$var$B() - f.renderingStartTime > $0331271bace68e97$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0331271bace68e97$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0331271bace68e97$var$B(), b.sibling = null, c = $0331271bace68e97$var$M.current, $0331271bace68e97$var$G($0331271bace68e97$var$M, d ? c & 1 | 2 : c & 1), b;
            $0331271bace68e97$var$S(b);
            return null;
        case 22:
        case 23:
            return $0331271bace68e97$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0331271bace68e97$var$gj & 1073741824) && ($0331271bace68e97$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0331271bace68e97$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0331271bace68e97$var$p(156, b.tag));
}
function $0331271bace68e97$var$Jj(a, b) {
    $0331271bace68e97$var$wg(b);
    switch(b.tag){
        case 1:
            return $0331271bace68e97$var$Zf(b.type) && $0331271bace68e97$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0331271bace68e97$var$Jh(), $0331271bace68e97$var$E($0331271bace68e97$var$Wf), $0331271bace68e97$var$E($0331271bace68e97$var$H), $0331271bace68e97$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0331271bace68e97$var$Lh(b), null;
        case 13:
            $0331271bace68e97$var$E($0331271bace68e97$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0331271bace68e97$var$p(340));
                $0331271bace68e97$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0331271bace68e97$var$E($0331271bace68e97$var$M), null;
        case 4:
            return $0331271bace68e97$var$Jh(), null;
        case 10:
            return $0331271bace68e97$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0331271bace68e97$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0331271bace68e97$var$Kj = !1, $0331271bace68e97$var$U = !1, $0331271bace68e97$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0331271bace68e97$var$V = null;
function $0331271bace68e97$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0331271bace68e97$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0331271bace68e97$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0331271bace68e97$var$W(a, b, d);
    }
}
var $0331271bace68e97$var$Oj = !1;
function $0331271bace68e97$var$Pj(a, b) {
    $0331271bace68e97$var$Cf = $0331271bace68e97$var$dd;
    a = $0331271bace68e97$var$Me();
    if ($0331271bace68e97$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0331271bace68e97$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0331271bace68e97$var$dd = !1;
    for($0331271bace68e97$var$V = b; null !== $0331271bace68e97$var$V;)if (b = $0331271bace68e97$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0331271bace68e97$var$V = a;
    else for(; null !== $0331271bace68e97$var$V;){
        b = $0331271bace68e97$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0331271bace68e97$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0331271bace68e97$var$p(163));
            }
        } catch (F) {
            $0331271bace68e97$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0331271bace68e97$var$V = a;
            break;
        }
        $0331271bace68e97$var$V = b.return;
    }
    n = $0331271bace68e97$var$Oj;
    $0331271bace68e97$var$Oj = !1;
    return n;
}
function $0331271bace68e97$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0331271bace68e97$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0331271bace68e97$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0331271bace68e97$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0331271bace68e97$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0331271bace68e97$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0331271bace68e97$var$Of], delete b[$0331271bace68e97$var$Pf], delete b[$0331271bace68e97$var$of], delete b[$0331271bace68e97$var$Qf], delete b[$0331271bace68e97$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0331271bace68e97$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0331271bace68e97$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0331271bace68e97$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0331271bace68e97$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0331271bace68e97$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0331271bace68e97$var$Wj(a, b, c), a = a.sibling; null !== a;)$0331271bace68e97$var$Wj(a, b, c), a = a.sibling;
}
function $0331271bace68e97$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0331271bace68e97$var$Xj(a, b, c), a = a.sibling; null !== a;)$0331271bace68e97$var$Xj(a, b, c), a = a.sibling;
}
var $0331271bace68e97$var$X = null, $0331271bace68e97$var$Yj = !1;
function $0331271bace68e97$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0331271bace68e97$var$ak(a, b, c), c = c.sibling;
}
function $0331271bace68e97$var$ak(a, b, c) {
    if ($0331271bace68e97$var$lc && "function" === typeof $0331271bace68e97$var$lc.onCommitFiberUnmount) try {
        $0331271bace68e97$var$lc.onCommitFiberUnmount($0331271bace68e97$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0331271bace68e97$var$U || $0331271bace68e97$var$Mj(c, b);
        case 6:
            var d = $0331271bace68e97$var$X, e = $0331271bace68e97$var$Yj;
            $0331271bace68e97$var$X = null;
            $0331271bace68e97$var$Zj(a, b, c);
            $0331271bace68e97$var$X = d;
            $0331271bace68e97$var$Yj = e;
            null !== $0331271bace68e97$var$X && ($0331271bace68e97$var$Yj ? (a = $0331271bace68e97$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0331271bace68e97$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0331271bace68e97$var$X && ($0331271bace68e97$var$Yj ? (a = $0331271bace68e97$var$X, c = c.stateNode, 8 === a.nodeType ? $0331271bace68e97$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0331271bace68e97$var$Kf(a, c), $0331271bace68e97$var$bd(a)) : $0331271bace68e97$var$Kf($0331271bace68e97$var$X, c.stateNode));
            break;
        case 4:
            d = $0331271bace68e97$var$X;
            e = $0331271bace68e97$var$Yj;
            $0331271bace68e97$var$X = c.stateNode.containerInfo;
            $0331271bace68e97$var$Yj = !0;
            $0331271bace68e97$var$Zj(a, b, c);
            $0331271bace68e97$var$X = d;
            $0331271bace68e97$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0331271bace68e97$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0331271bace68e97$var$Nj(c, b, g) : 0 !== (f & 4) && $0331271bace68e97$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0331271bace68e97$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0331271bace68e97$var$U && ($0331271bace68e97$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0331271bace68e97$var$W(c, b, h);
            }
            $0331271bace68e97$var$Zj(a, b, c);
            break;
        case 21:
            $0331271bace68e97$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0331271bace68e97$var$U = (d = $0331271bace68e97$var$U) || null !== c.memoizedState, $0331271bace68e97$var$Zj(a, b, c), $0331271bace68e97$var$U = d) : $0331271bace68e97$var$Zj(a, b, c);
            break;
        default:
            $0331271bace68e97$var$Zj(a, b, c);
    }
}
function $0331271bace68e97$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0331271bace68e97$var$Lj);
        b.forEach(function(b) {
            var d = $0331271bace68e97$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0331271bace68e97$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0331271bace68e97$var$X = h.stateNode;
                        $0331271bace68e97$var$Yj = !1;
                        break a;
                    case 3:
                        $0331271bace68e97$var$X = h.stateNode.containerInfo;
                        $0331271bace68e97$var$Yj = !0;
                        break a;
                    case 4:
                        $0331271bace68e97$var$X = h.stateNode.containerInfo;
                        $0331271bace68e97$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0331271bace68e97$var$X) throw Error($0331271bace68e97$var$p(160));
            $0331271bace68e97$var$ak(f, g, e);
            $0331271bace68e97$var$X = null;
            $0331271bace68e97$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0331271bace68e97$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0331271bace68e97$var$ek(b, a), b = b.sibling;
}
function $0331271bace68e97$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0331271bace68e97$var$dk(b, a);
            $0331271bace68e97$var$fk(a);
            if (d & 4) {
                try {
                    $0331271bace68e97$var$Qj(3, a, a.return), $0331271bace68e97$var$Rj(3, a);
                } catch (t) {
                    $0331271bace68e97$var$W(a, a.return, t);
                }
                try {
                    $0331271bace68e97$var$Qj(5, a, a.return);
                } catch (t) {
                    $0331271bace68e97$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0331271bace68e97$var$dk(b, a);
            $0331271bace68e97$var$fk(a);
            d & 512 && null !== c && $0331271bace68e97$var$Mj(c, c.return);
            break;
        case 5:
            $0331271bace68e97$var$dk(b, a);
            $0331271bace68e97$var$fk(a);
            d & 512 && null !== c && $0331271bace68e97$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0331271bace68e97$var$ob(e, "");
                } catch (t) {
                    $0331271bace68e97$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0331271bace68e97$var$ab(e, f);
                    $0331271bace68e97$var$vb(h, g);
                    var l = $0331271bace68e97$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0331271bace68e97$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0331271bace68e97$var$nb(e, q) : "children" === m ? $0331271bace68e97$var$ob(e, q) : $0331271bace68e97$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0331271bace68e97$var$bb(e, f);
                            break;
                        case "textarea":
                            $0331271bace68e97$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0331271bace68e97$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0331271bace68e97$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0331271bace68e97$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0331271bace68e97$var$Pf] = f;
                } catch (t) {
                    $0331271bace68e97$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0331271bace68e97$var$dk(b, a);
            $0331271bace68e97$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0331271bace68e97$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0331271bace68e97$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0331271bace68e97$var$dk(b, a);
            $0331271bace68e97$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0331271bace68e97$var$bd(b.containerInfo);
            } catch (t) {
                $0331271bace68e97$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0331271bace68e97$var$dk(b, a);
            $0331271bace68e97$var$fk(a);
            break;
        case 13:
            $0331271bace68e97$var$dk(b, a);
            $0331271bace68e97$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0331271bace68e97$var$gk = $0331271bace68e97$var$B()));
            d & 4 && $0331271bace68e97$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0331271bace68e97$var$U = (l = $0331271bace68e97$var$U) || m, $0331271bace68e97$var$dk(b, a), $0331271bace68e97$var$U = l) : $0331271bace68e97$var$dk(b, a);
            $0331271bace68e97$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0331271bace68e97$var$V = a, m = a.child; null !== m;){
                    for(q = $0331271bace68e97$var$V = m; null !== $0331271bace68e97$var$V;){
                        r = $0331271bace68e97$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0331271bace68e97$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0331271bace68e97$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0331271bace68e97$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0331271bace68e97$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0331271bace68e97$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0331271bace68e97$var$V = y) : $0331271bace68e97$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0331271bace68e97$var$rb("display", g));
                            } catch (t) {
                                $0331271bace68e97$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0331271bace68e97$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0331271bace68e97$var$dk(b, a);
            $0331271bace68e97$var$fk(a);
            d & 4 && $0331271bace68e97$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0331271bace68e97$var$dk(b, a), $0331271bace68e97$var$fk(a);
    }
}
function $0331271bace68e97$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0331271bace68e97$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0331271bace68e97$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0331271bace68e97$var$ob(e, ""), d.flags &= -33);
                    var f = $0331271bace68e97$var$Vj(a);
                    $0331271bace68e97$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0331271bace68e97$var$Vj(a);
                    $0331271bace68e97$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0331271bace68e97$var$p(161));
            }
        } catch (k) {
            $0331271bace68e97$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0331271bace68e97$var$ik(a, b, c) {
    $0331271bace68e97$var$V = a;
    $0331271bace68e97$var$jk(a, b, c);
}
function $0331271bace68e97$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0331271bace68e97$var$V;){
        var e = $0331271bace68e97$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0331271bace68e97$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0331271bace68e97$var$U;
                h = $0331271bace68e97$var$Kj;
                var l = $0331271bace68e97$var$U;
                $0331271bace68e97$var$Kj = g;
                if (($0331271bace68e97$var$U = k) && !l) for($0331271bace68e97$var$V = e; null !== $0331271bace68e97$var$V;)g = $0331271bace68e97$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0331271bace68e97$var$kk(e) : null !== k ? (k.return = g, $0331271bace68e97$var$V = k) : $0331271bace68e97$var$kk(e);
                for(; null !== f;)$0331271bace68e97$var$V = f, $0331271bace68e97$var$jk(f, b, c), f = f.sibling;
                $0331271bace68e97$var$V = e;
                $0331271bace68e97$var$Kj = h;
                $0331271bace68e97$var$U = l;
            }
            $0331271bace68e97$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0331271bace68e97$var$V = f) : $0331271bace68e97$var$lk(a, b, c);
    }
}
function $0331271bace68e97$var$lk(a) {
    for(; null !== $0331271bace68e97$var$V;){
        var b = $0331271bace68e97$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0331271bace68e97$var$U || $0331271bace68e97$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0331271bace68e97$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0331271bace68e97$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0331271bace68e97$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0331271bace68e97$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0331271bace68e97$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0331271bace68e97$var$p(163));
                }
                $0331271bace68e97$var$U || b.flags & 512 && $0331271bace68e97$var$Sj(b);
            } catch (r) {
                $0331271bace68e97$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0331271bace68e97$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0331271bace68e97$var$V = c;
            break;
        }
        $0331271bace68e97$var$V = b.return;
    }
}
function $0331271bace68e97$var$hk(a) {
    for(; null !== $0331271bace68e97$var$V;){
        var b = $0331271bace68e97$var$V;
        if (b === a) {
            $0331271bace68e97$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0331271bace68e97$var$V = c;
            break;
        }
        $0331271bace68e97$var$V = b.return;
    }
}
function $0331271bace68e97$var$kk(a) {
    for(; null !== $0331271bace68e97$var$V;){
        var b = $0331271bace68e97$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0331271bace68e97$var$Rj(4, b);
                    } catch (k) {
                        $0331271bace68e97$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0331271bace68e97$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0331271bace68e97$var$Sj(b);
                    } catch (k) {
                        $0331271bace68e97$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0331271bace68e97$var$Sj(b);
                    } catch (k) {
                        $0331271bace68e97$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0331271bace68e97$var$W(b, b.return, k);
        }
        if (b === a) {
            $0331271bace68e97$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0331271bace68e97$var$V = h;
            break;
        }
        $0331271bace68e97$var$V = b.return;
    }
}
var $0331271bace68e97$var$mk = Math.ceil, $0331271bace68e97$var$nk = $0331271bace68e97$var$ua.ReactCurrentDispatcher, $0331271bace68e97$var$ok = $0331271bace68e97$var$ua.ReactCurrentOwner, $0331271bace68e97$var$pk = $0331271bace68e97$var$ua.ReactCurrentBatchConfig, $0331271bace68e97$var$K = 0, $0331271bace68e97$var$R = null, $0331271bace68e97$var$Y = null, $0331271bace68e97$var$Z = 0, $0331271bace68e97$var$gj = 0, $0331271bace68e97$var$fj = $0331271bace68e97$var$Uf(0), $0331271bace68e97$var$T = 0, $0331271bace68e97$var$qk = null, $0331271bace68e97$var$hh = 0, $0331271bace68e97$var$rk = 0, $0331271bace68e97$var$sk = 0, $0331271bace68e97$var$tk = null, $0331271bace68e97$var$uk = null, $0331271bace68e97$var$gk = 0, $0331271bace68e97$var$Hj = Infinity, $0331271bace68e97$var$vk = null, $0331271bace68e97$var$Pi = !1, $0331271bace68e97$var$Qi = null, $0331271bace68e97$var$Si = null, $0331271bace68e97$var$wk = !1, $0331271bace68e97$var$xk = null, $0331271bace68e97$var$yk = 0, $0331271bace68e97$var$zk = 0, $0331271bace68e97$var$Ak = null, $0331271bace68e97$var$Bk = -1, $0331271bace68e97$var$Ck = 0;
function $0331271bace68e97$var$L() {
    return 0 !== ($0331271bace68e97$var$K & 6) ? $0331271bace68e97$var$B() : -1 !== $0331271bace68e97$var$Bk ? $0331271bace68e97$var$Bk : $0331271bace68e97$var$Bk = $0331271bace68e97$var$B();
}
function $0331271bace68e97$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0331271bace68e97$var$K & 2) && 0 !== $0331271bace68e97$var$Z) return $0331271bace68e97$var$Z & -$0331271bace68e97$var$Z;
    if (null !== $0331271bace68e97$var$Kg.transition) return 0 === $0331271bace68e97$var$Ck && ($0331271bace68e97$var$Ck = $0331271bace68e97$var$yc()), $0331271bace68e97$var$Ck;
    a = $0331271bace68e97$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0331271bace68e97$var$jd(a.type);
    return a;
}
function $0331271bace68e97$var$mh(a, b, c, d) {
    if (50 < $0331271bace68e97$var$zk) throw $0331271bace68e97$var$zk = 0, $0331271bace68e97$var$Ak = null, Error($0331271bace68e97$var$p(185));
    $0331271bace68e97$var$Ac(a, c, d);
    if (0 === ($0331271bace68e97$var$K & 2) || a !== $0331271bace68e97$var$R) a === $0331271bace68e97$var$R && (0 === ($0331271bace68e97$var$K & 2) && ($0331271bace68e97$var$rk |= c), 4 === $0331271bace68e97$var$T && $0331271bace68e97$var$Dk(a, $0331271bace68e97$var$Z)), $0331271bace68e97$var$Ek(a, d), 1 === c && 0 === $0331271bace68e97$var$K && 0 === (b.mode & 1) && ($0331271bace68e97$var$Hj = $0331271bace68e97$var$B() + 500, $0331271bace68e97$var$fg && $0331271bace68e97$var$jg());
}
function $0331271bace68e97$var$Ek(a, b) {
    var c = a.callbackNode;
    $0331271bace68e97$var$wc(a, b);
    var d = $0331271bace68e97$var$uc(a, a === $0331271bace68e97$var$R ? $0331271bace68e97$var$Z : 0);
    if (0 === d) null !== c && $0331271bace68e97$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0331271bace68e97$var$bc(c);
        if (1 === b) 0 === a.tag ? $0331271bace68e97$var$ig($0331271bace68e97$var$Fk.bind(null, a)) : $0331271bace68e97$var$hg($0331271bace68e97$var$Fk.bind(null, a)), $0331271bace68e97$var$Jf(function() {
            0 === ($0331271bace68e97$var$K & 6) && $0331271bace68e97$var$jg();
        }), c = null;
        else {
            switch($0331271bace68e97$var$Dc(d)){
                case 1:
                    c = $0331271bace68e97$var$fc;
                    break;
                case 4:
                    c = $0331271bace68e97$var$gc;
                    break;
                case 16:
                    c = $0331271bace68e97$var$hc;
                    break;
                case 536870912:
                    c = $0331271bace68e97$var$jc;
                    break;
                default:
                    c = $0331271bace68e97$var$hc;
            }
            c = $0331271bace68e97$var$Gk(c, $0331271bace68e97$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0331271bace68e97$var$Hk(a, b) {
    $0331271bace68e97$var$Bk = -1;
    $0331271bace68e97$var$Ck = 0;
    if (0 !== ($0331271bace68e97$var$K & 6)) throw Error($0331271bace68e97$var$p(327));
    var c = a.callbackNode;
    if ($0331271bace68e97$var$Ik() && a.callbackNode !== c) return null;
    var d = $0331271bace68e97$var$uc(a, a === $0331271bace68e97$var$R ? $0331271bace68e97$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0331271bace68e97$var$Jk(a, d);
    else {
        b = d;
        var e = $0331271bace68e97$var$K;
        $0331271bace68e97$var$K |= 2;
        var f = $0331271bace68e97$var$Kk();
        if ($0331271bace68e97$var$R !== a || $0331271bace68e97$var$Z !== b) $0331271bace68e97$var$vk = null, $0331271bace68e97$var$Hj = $0331271bace68e97$var$B() + 500, $0331271bace68e97$var$Lk(a, b);
        for(;;)try {
            $0331271bace68e97$var$Mk();
            break;
        } catch (h) {
            $0331271bace68e97$var$Nk(a, h);
        }
        $0331271bace68e97$var$Qg();
        $0331271bace68e97$var$nk.current = f;
        $0331271bace68e97$var$K = e;
        null !== $0331271bace68e97$var$Y ? b = 0 : ($0331271bace68e97$var$R = null, $0331271bace68e97$var$Z = 0, b = $0331271bace68e97$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0331271bace68e97$var$xc(a), 0 !== e && (d = e, b = $0331271bace68e97$var$Ok(a, e)));
        if (1 === b) throw c = $0331271bace68e97$var$qk, $0331271bace68e97$var$Lk(a, 0), $0331271bace68e97$var$Dk(a, d), $0331271bace68e97$var$Ek(a, $0331271bace68e97$var$B()), c;
        if (6 === b) $0331271bace68e97$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0331271bace68e97$var$Pk(e) && (b = $0331271bace68e97$var$Jk(a, d), 2 === b && (f = $0331271bace68e97$var$xc(a), 0 !== f && (d = f, b = $0331271bace68e97$var$Ok(a, f))), 1 === b)) throw c = $0331271bace68e97$var$qk, $0331271bace68e97$var$Lk(a, 0), $0331271bace68e97$var$Dk(a, d), $0331271bace68e97$var$Ek(a, $0331271bace68e97$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0331271bace68e97$var$p(345));
                case 2:
                    $0331271bace68e97$var$Qk(a, $0331271bace68e97$var$uk, $0331271bace68e97$var$vk);
                    break;
                case 3:
                    $0331271bace68e97$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0331271bace68e97$var$gk + 500 - $0331271bace68e97$var$B(), 10 < b)) {
                        if (0 !== $0331271bace68e97$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0331271bace68e97$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0331271bace68e97$var$Ff($0331271bace68e97$var$Qk.bind(null, a, $0331271bace68e97$var$uk, $0331271bace68e97$var$vk), b);
                        break;
                    }
                    $0331271bace68e97$var$Qk(a, $0331271bace68e97$var$uk, $0331271bace68e97$var$vk);
                    break;
                case 4:
                    $0331271bace68e97$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0331271bace68e97$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0331271bace68e97$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0331271bace68e97$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0331271bace68e97$var$Ff($0331271bace68e97$var$Qk.bind(null, a, $0331271bace68e97$var$uk, $0331271bace68e97$var$vk), d);
                        break;
                    }
                    $0331271bace68e97$var$Qk(a, $0331271bace68e97$var$uk, $0331271bace68e97$var$vk);
                    break;
                case 5:
                    $0331271bace68e97$var$Qk(a, $0331271bace68e97$var$uk, $0331271bace68e97$var$vk);
                    break;
                default:
                    throw Error($0331271bace68e97$var$p(329));
            }
        }
    }
    $0331271bace68e97$var$Ek(a, $0331271bace68e97$var$B());
    return a.callbackNode === c ? $0331271bace68e97$var$Hk.bind(null, a) : null;
}
function $0331271bace68e97$var$Ok(a, b) {
    var c = $0331271bace68e97$var$tk;
    a.current.memoizedState.isDehydrated && ($0331271bace68e97$var$Lk(a, b).flags |= 256);
    a = $0331271bace68e97$var$Jk(a, b);
    2 !== a && (b = $0331271bace68e97$var$uk, $0331271bace68e97$var$uk = c, null !== b && $0331271bace68e97$var$Gj(b));
    return a;
}
function $0331271bace68e97$var$Gj(a) {
    null === $0331271bace68e97$var$uk ? $0331271bace68e97$var$uk = a : $0331271bace68e97$var$uk.push.apply($0331271bace68e97$var$uk, a);
}
function $0331271bace68e97$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0331271bace68e97$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0331271bace68e97$var$Dk(a, b) {
    b &= ~$0331271bace68e97$var$sk;
    b &= ~$0331271bace68e97$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0331271bace68e97$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0331271bace68e97$var$Fk(a) {
    if (0 !== ($0331271bace68e97$var$K & 6)) throw Error($0331271bace68e97$var$p(327));
    $0331271bace68e97$var$Ik();
    var b = $0331271bace68e97$var$uc(a, 0);
    if (0 === (b & 1)) return $0331271bace68e97$var$Ek(a, $0331271bace68e97$var$B()), null;
    var c = $0331271bace68e97$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0331271bace68e97$var$xc(a);
        0 !== d && (b = d, c = $0331271bace68e97$var$Ok(a, d));
    }
    if (1 === c) throw c = $0331271bace68e97$var$qk, $0331271bace68e97$var$Lk(a, 0), $0331271bace68e97$var$Dk(a, b), $0331271bace68e97$var$Ek(a, $0331271bace68e97$var$B()), c;
    if (6 === c) throw Error($0331271bace68e97$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0331271bace68e97$var$Qk(a, $0331271bace68e97$var$uk, $0331271bace68e97$var$vk);
    $0331271bace68e97$var$Ek(a, $0331271bace68e97$var$B());
    return null;
}
function $0331271bace68e97$var$Rk(a, b) {
    var c = $0331271bace68e97$var$K;
    $0331271bace68e97$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0331271bace68e97$var$K = c, 0 === $0331271bace68e97$var$K && ($0331271bace68e97$var$Hj = $0331271bace68e97$var$B() + 500, $0331271bace68e97$var$fg && $0331271bace68e97$var$jg());
    }
}
function $0331271bace68e97$var$Sk(a) {
    null !== $0331271bace68e97$var$xk && 0 === $0331271bace68e97$var$xk.tag && 0 === ($0331271bace68e97$var$K & 6) && $0331271bace68e97$var$Ik();
    var b = $0331271bace68e97$var$K;
    $0331271bace68e97$var$K |= 1;
    var c = $0331271bace68e97$var$pk.transition, d = $0331271bace68e97$var$C;
    try {
        if ($0331271bace68e97$var$pk.transition = null, $0331271bace68e97$var$C = 1, a) return a();
    } finally{
        $0331271bace68e97$var$C = d, $0331271bace68e97$var$pk.transition = c, $0331271bace68e97$var$K = b, 0 === ($0331271bace68e97$var$K & 6) && $0331271bace68e97$var$jg();
    }
}
function $0331271bace68e97$var$Ij() {
    $0331271bace68e97$var$gj = $0331271bace68e97$var$fj.current;
    $0331271bace68e97$var$E($0331271bace68e97$var$fj);
}
function $0331271bace68e97$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0331271bace68e97$var$Gf(c));
    if (null !== $0331271bace68e97$var$Y) for(c = $0331271bace68e97$var$Y.return; null !== c;){
        var d = c;
        $0331271bace68e97$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0331271bace68e97$var$$f();
                break;
            case 3:
                $0331271bace68e97$var$Jh();
                $0331271bace68e97$var$E($0331271bace68e97$var$Wf);
                $0331271bace68e97$var$E($0331271bace68e97$var$H);
                $0331271bace68e97$var$Oh();
                break;
            case 5:
                $0331271bace68e97$var$Lh(d);
                break;
            case 4:
                $0331271bace68e97$var$Jh();
                break;
            case 13:
                $0331271bace68e97$var$E($0331271bace68e97$var$M);
                break;
            case 19:
                $0331271bace68e97$var$E($0331271bace68e97$var$M);
                break;
            case 10:
                $0331271bace68e97$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0331271bace68e97$var$Ij();
        }
        c = c.return;
    }
    $0331271bace68e97$var$R = a;
    $0331271bace68e97$var$Y = a = $0331271bace68e97$var$wh(a.current, null);
    $0331271bace68e97$var$Z = $0331271bace68e97$var$gj = b;
    $0331271bace68e97$var$T = 0;
    $0331271bace68e97$var$qk = null;
    $0331271bace68e97$var$sk = $0331271bace68e97$var$rk = $0331271bace68e97$var$hh = 0;
    $0331271bace68e97$var$uk = $0331271bace68e97$var$tk = null;
    if (null !== $0331271bace68e97$var$Wg) {
        for(b = 0; b < $0331271bace68e97$var$Wg.length; b++)if (c = $0331271bace68e97$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0331271bace68e97$var$Wg = null;
    }
    return a;
}
function $0331271bace68e97$var$Nk(a, b) {
    do {
        var c = $0331271bace68e97$var$Y;
        try {
            $0331271bace68e97$var$Qg();
            $0331271bace68e97$var$Ph.current = $0331271bace68e97$var$ai;
            if ($0331271bace68e97$var$Sh) {
                for(var d = $0331271bace68e97$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0331271bace68e97$var$Sh = !1;
            }
            $0331271bace68e97$var$Rh = 0;
            $0331271bace68e97$var$P = $0331271bace68e97$var$O = $0331271bace68e97$var$N = null;
            $0331271bace68e97$var$Th = !1;
            $0331271bace68e97$var$Uh = 0;
            $0331271bace68e97$var$ok.current = null;
            if (null === c || null === c.return) {
                $0331271bace68e97$var$T = 1;
                $0331271bace68e97$var$qk = b;
                $0331271bace68e97$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0331271bace68e97$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0331271bace68e97$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0331271bace68e97$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0331271bace68e97$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0331271bace68e97$var$Ti(f, l, b);
                            $0331271bace68e97$var$uj();
                            break a;
                        }
                        k = Error($0331271bace68e97$var$p(426));
                    }
                } else if ($0331271bace68e97$var$I && h.mode & 1) {
                    var J = $0331271bace68e97$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0331271bace68e97$var$Wi(J, g, h, f, b);
                        $0331271bace68e97$var$Jg($0331271bace68e97$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0331271bace68e97$var$Ki(k, h);
                4 !== $0331271bace68e97$var$T && ($0331271bace68e97$var$T = 2);
                null === $0331271bace68e97$var$tk ? $0331271bace68e97$var$tk = [
                    f
                ] : $0331271bace68e97$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0331271bace68e97$var$Oi(f, k, b);
                            $0331271bace68e97$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0331271bace68e97$var$Si || !$0331271bace68e97$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0331271bace68e97$var$Ri(f, h, b);
                                $0331271bace68e97$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0331271bace68e97$var$Tk(c);
        } catch (na) {
            b = na;
            $0331271bace68e97$var$Y === c && null !== c && ($0331271bace68e97$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0331271bace68e97$var$Kk() {
    var a = $0331271bace68e97$var$nk.current;
    $0331271bace68e97$var$nk.current = $0331271bace68e97$var$ai;
    return null === a ? $0331271bace68e97$var$ai : a;
}
function $0331271bace68e97$var$uj() {
    if (0 === $0331271bace68e97$var$T || 3 === $0331271bace68e97$var$T || 2 === $0331271bace68e97$var$T) $0331271bace68e97$var$T = 4;
    null === $0331271bace68e97$var$R || 0 === ($0331271bace68e97$var$hh & 268435455) && 0 === ($0331271bace68e97$var$rk & 268435455) || $0331271bace68e97$var$Dk($0331271bace68e97$var$R, $0331271bace68e97$var$Z);
}
function $0331271bace68e97$var$Jk(a, b) {
    var c = $0331271bace68e97$var$K;
    $0331271bace68e97$var$K |= 2;
    var d = $0331271bace68e97$var$Kk();
    if ($0331271bace68e97$var$R !== a || $0331271bace68e97$var$Z !== b) $0331271bace68e97$var$vk = null, $0331271bace68e97$var$Lk(a, b);
    for(;;)try {
        $0331271bace68e97$var$Uk();
        break;
    } catch (e) {
        $0331271bace68e97$var$Nk(a, e);
    }
    $0331271bace68e97$var$Qg();
    $0331271bace68e97$var$K = c;
    $0331271bace68e97$var$nk.current = d;
    if (null !== $0331271bace68e97$var$Y) throw Error($0331271bace68e97$var$p(261));
    $0331271bace68e97$var$R = null;
    $0331271bace68e97$var$Z = 0;
    return $0331271bace68e97$var$T;
}
function $0331271bace68e97$var$Uk() {
    for(; null !== $0331271bace68e97$var$Y;)$0331271bace68e97$var$Vk($0331271bace68e97$var$Y);
}
function $0331271bace68e97$var$Mk() {
    for(; null !== $0331271bace68e97$var$Y && !$0331271bace68e97$var$cc();)$0331271bace68e97$var$Vk($0331271bace68e97$var$Y);
}
function $0331271bace68e97$var$Vk(a) {
    var b = $0331271bace68e97$var$Wk(a.alternate, a, $0331271bace68e97$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0331271bace68e97$var$Tk(a) : $0331271bace68e97$var$Y = b;
    $0331271bace68e97$var$ok.current = null;
}
function $0331271bace68e97$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0331271bace68e97$var$Fj(c, b, $0331271bace68e97$var$gj), null !== c) {
                $0331271bace68e97$var$Y = c;
                return;
            }
        } else {
            c = $0331271bace68e97$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0331271bace68e97$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0331271bace68e97$var$T = 6;
                $0331271bace68e97$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0331271bace68e97$var$Y = b;
            return;
        }
        $0331271bace68e97$var$Y = b = a;
    }while (null !== b);
    0 === $0331271bace68e97$var$T && ($0331271bace68e97$var$T = 5);
}
function $0331271bace68e97$var$Qk(a, b, c) {
    var d = $0331271bace68e97$var$C, e = $0331271bace68e97$var$pk.transition;
    try {
        $0331271bace68e97$var$pk.transition = null, $0331271bace68e97$var$C = 1, $0331271bace68e97$var$Xk(a, b, c, d);
    } finally{
        $0331271bace68e97$var$pk.transition = e, $0331271bace68e97$var$C = d;
    }
    return null;
}
function $0331271bace68e97$var$Xk(a, b, c, d) {
    do $0331271bace68e97$var$Ik();
    while (null !== $0331271bace68e97$var$xk);
    if (0 !== ($0331271bace68e97$var$K & 6)) throw Error($0331271bace68e97$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0331271bace68e97$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0331271bace68e97$var$Bc(a, f);
    a === $0331271bace68e97$var$R && ($0331271bace68e97$var$Y = $0331271bace68e97$var$R = null, $0331271bace68e97$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0331271bace68e97$var$wk || ($0331271bace68e97$var$wk = !0, $0331271bace68e97$var$Gk($0331271bace68e97$var$hc, function() {
        $0331271bace68e97$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0331271bace68e97$var$pk.transition;
        $0331271bace68e97$var$pk.transition = null;
        var g = $0331271bace68e97$var$C;
        $0331271bace68e97$var$C = 1;
        var h = $0331271bace68e97$var$K;
        $0331271bace68e97$var$K |= 4;
        $0331271bace68e97$var$ok.current = null;
        $0331271bace68e97$var$Pj(a, c);
        $0331271bace68e97$var$ek(c, a);
        $0331271bace68e97$var$Oe($0331271bace68e97$var$Df);
        $0331271bace68e97$var$dd = !!$0331271bace68e97$var$Cf;
        $0331271bace68e97$var$Df = $0331271bace68e97$var$Cf = null;
        a.current = c;
        $0331271bace68e97$var$ik(c, a, e);
        $0331271bace68e97$var$dc();
        $0331271bace68e97$var$K = h;
        $0331271bace68e97$var$C = g;
        $0331271bace68e97$var$pk.transition = f;
    } else a.current = c;
    $0331271bace68e97$var$wk && ($0331271bace68e97$var$wk = !1, $0331271bace68e97$var$xk = a, $0331271bace68e97$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0331271bace68e97$var$Si = null);
    $0331271bace68e97$var$mc(c.stateNode, d);
    $0331271bace68e97$var$Ek(a, $0331271bace68e97$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0331271bace68e97$var$Pi) throw $0331271bace68e97$var$Pi = !1, a = $0331271bace68e97$var$Qi, $0331271bace68e97$var$Qi = null, a;
    0 !== ($0331271bace68e97$var$yk & 1) && 0 !== a.tag && $0331271bace68e97$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0331271bace68e97$var$Ak ? $0331271bace68e97$var$zk++ : ($0331271bace68e97$var$zk = 0, $0331271bace68e97$var$Ak = a) : $0331271bace68e97$var$zk = 0;
    $0331271bace68e97$var$jg();
    return null;
}
function $0331271bace68e97$var$Ik() {
    if (null !== $0331271bace68e97$var$xk) {
        var a = $0331271bace68e97$var$Dc($0331271bace68e97$var$yk), b = $0331271bace68e97$var$pk.transition, c = $0331271bace68e97$var$C;
        try {
            $0331271bace68e97$var$pk.transition = null;
            $0331271bace68e97$var$C = 16 > a ? 16 : a;
            if (null === $0331271bace68e97$var$xk) var d = !1;
            else {
                a = $0331271bace68e97$var$xk;
                $0331271bace68e97$var$xk = null;
                $0331271bace68e97$var$yk = 0;
                if (0 !== ($0331271bace68e97$var$K & 6)) throw Error($0331271bace68e97$var$p(331));
                var e = $0331271bace68e97$var$K;
                $0331271bace68e97$var$K |= 4;
                for($0331271bace68e97$var$V = a.current; null !== $0331271bace68e97$var$V;){
                    var f = $0331271bace68e97$var$V, g = f.child;
                    if (0 !== ($0331271bace68e97$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0331271bace68e97$var$V = l; null !== $0331271bace68e97$var$V;){
                                    var m = $0331271bace68e97$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0331271bace68e97$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0331271bace68e97$var$V = q;
                                    else for(; null !== $0331271bace68e97$var$V;){
                                        m = $0331271bace68e97$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0331271bace68e97$var$Tj(m);
                                        if (m === l) {
                                            $0331271bace68e97$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0331271bace68e97$var$V = r;
                                            break;
                                        }
                                        $0331271bace68e97$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0331271bace68e97$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0331271bace68e97$var$V = g;
                    else b: for(; null !== $0331271bace68e97$var$V;){
                        f = $0331271bace68e97$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0331271bace68e97$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0331271bace68e97$var$V = x;
                            break b;
                        }
                        $0331271bace68e97$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0331271bace68e97$var$V = w; null !== $0331271bace68e97$var$V;){
                    g = $0331271bace68e97$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0331271bace68e97$var$V = u;
                    else b: for(g = w; null !== $0331271bace68e97$var$V;){
                        h = $0331271bace68e97$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0331271bace68e97$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0331271bace68e97$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0331271bace68e97$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0331271bace68e97$var$V = F;
                            break b;
                        }
                        $0331271bace68e97$var$V = h.return;
                    }
                }
                $0331271bace68e97$var$K = e;
                $0331271bace68e97$var$jg();
                if ($0331271bace68e97$var$lc && "function" === typeof $0331271bace68e97$var$lc.onPostCommitFiberRoot) try {
                    $0331271bace68e97$var$lc.onPostCommitFiberRoot($0331271bace68e97$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0331271bace68e97$var$C = c, $0331271bace68e97$var$pk.transition = b;
        }
    }
    return !1;
}
function $0331271bace68e97$var$Yk(a, b, c) {
    b = $0331271bace68e97$var$Ki(c, b);
    b = $0331271bace68e97$var$Oi(a, b, 1);
    a = $0331271bace68e97$var$dh(a, b, 1);
    b = $0331271bace68e97$var$L();
    null !== a && ($0331271bace68e97$var$Ac(a, 1, b), $0331271bace68e97$var$Ek(a, b));
}
function $0331271bace68e97$var$W(a, b, c) {
    if (3 === a.tag) $0331271bace68e97$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0331271bace68e97$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0331271bace68e97$var$Si || !$0331271bace68e97$var$Si.has(d))) {
                a = $0331271bace68e97$var$Ki(c, a);
                a = $0331271bace68e97$var$Ri(b, a, 1);
                b = $0331271bace68e97$var$dh(b, a, 1);
                a = $0331271bace68e97$var$L();
                null !== b && ($0331271bace68e97$var$Ac(b, 1, a), $0331271bace68e97$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0331271bace68e97$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0331271bace68e97$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0331271bace68e97$var$R === a && ($0331271bace68e97$var$Z & c) === c && (4 === $0331271bace68e97$var$T || 3 === $0331271bace68e97$var$T && ($0331271bace68e97$var$Z & 130023424) === $0331271bace68e97$var$Z && 500 > $0331271bace68e97$var$B() - $0331271bace68e97$var$gk ? $0331271bace68e97$var$Lk(a, 0) : $0331271bace68e97$var$sk |= c);
    $0331271bace68e97$var$Ek(a, b);
}
function $0331271bace68e97$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0331271bace68e97$var$sc, $0331271bace68e97$var$sc <<= 1, 0 === ($0331271bace68e97$var$sc & 130023424) && ($0331271bace68e97$var$sc = 4194304)));
    var c = $0331271bace68e97$var$L();
    a = $0331271bace68e97$var$Zg(a, b);
    null !== a && ($0331271bace68e97$var$Ac(a, b, c), $0331271bace68e97$var$Ek(a, c));
}
function $0331271bace68e97$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0331271bace68e97$var$Zk(a, c);
}
function $0331271bace68e97$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0331271bace68e97$var$p(314));
    }
    null !== d && d.delete(b);
    $0331271bace68e97$var$Zk(a, c);
}
var $0331271bace68e97$var$Wk;
$0331271bace68e97$var$Wk = function Wk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0331271bace68e97$var$Wf.current) $0331271bace68e97$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0331271bace68e97$var$Ug = !1, $0331271bace68e97$var$zj(a, b, c);
            $0331271bace68e97$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0331271bace68e97$var$Ug = !1, $0331271bace68e97$var$I && 0 !== (b.flags & 1048576) && $0331271bace68e97$var$ug(b, $0331271bace68e97$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0331271bace68e97$var$jj(a, b);
            a = b.pendingProps;
            var e = $0331271bace68e97$var$Yf(b, $0331271bace68e97$var$H.current);
            $0331271bace68e97$var$Tg(b, c);
            e = $0331271bace68e97$var$Xh(null, b, d, a, e, c);
            var f = $0331271bace68e97$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0331271bace68e97$var$Zf(d) ? (f = !0, $0331271bace68e97$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0331271bace68e97$var$ah(b), e.updater = $0331271bace68e97$var$nh, b.stateNode = e, e._reactInternals = b, $0331271bace68e97$var$rh(b, d, a, c), b = $0331271bace68e97$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0331271bace68e97$var$I && f && $0331271bace68e97$var$vg(b), $0331271bace68e97$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0331271bace68e97$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0331271bace68e97$var$$k(d);
                a = $0331271bace68e97$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0331271bace68e97$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0331271bace68e97$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0331271bace68e97$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0331271bace68e97$var$aj(null, b, d, $0331271bace68e97$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0331271bace68e97$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0331271bace68e97$var$Lg(d, e), $0331271bace68e97$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0331271bace68e97$var$Lg(d, e), $0331271bace68e97$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0331271bace68e97$var$lj(b);
                if (null === a) throw Error($0331271bace68e97$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0331271bace68e97$var$bh(a, b);
                $0331271bace68e97$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0331271bace68e97$var$Ki(Error($0331271bace68e97$var$p(423)), b);
                        b = $0331271bace68e97$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0331271bace68e97$var$Ki(Error($0331271bace68e97$var$p(424)), b);
                        b = $0331271bace68e97$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0331271bace68e97$var$yg = $0331271bace68e97$var$Lf(b.stateNode.containerInfo.firstChild), $0331271bace68e97$var$xg = b, $0331271bace68e97$var$I = !0, $0331271bace68e97$var$zg = null, c = $0331271bace68e97$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0331271bace68e97$var$Ig();
                    if (d === e) {
                        b = $0331271bace68e97$var$$i(a, b, c);
                        break a;
                    }
                    $0331271bace68e97$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0331271bace68e97$var$Kh(b), null === a && $0331271bace68e97$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0331271bace68e97$var$Ef(d, e) ? g = null : null !== f && $0331271bace68e97$var$Ef(d, f) && (b.flags |= 32), $0331271bace68e97$var$hj(a, b), $0331271bace68e97$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0331271bace68e97$var$Eg(b), null;
        case 13:
            return $0331271bace68e97$var$pj(a, b, c);
        case 4:
            return $0331271bace68e97$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0331271bace68e97$var$Bh(b, null, d, c) : $0331271bace68e97$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0331271bace68e97$var$Lg(d, e), $0331271bace68e97$var$Zi(a, b, d, e, c);
        case 7:
            return $0331271bace68e97$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0331271bace68e97$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0331271bace68e97$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0331271bace68e97$var$G($0331271bace68e97$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0331271bace68e97$var$He(f.value, g)) {
                        if (f.children === e.children && !$0331271bace68e97$var$Wf.current) {
                            b = $0331271bace68e97$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0331271bace68e97$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0331271bace68e97$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0331271bace68e97$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0331271bace68e97$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0331271bace68e97$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0331271bace68e97$var$Tg(b, c), e = $0331271bace68e97$var$Vg(e), d = d(e), b.flags |= 1, $0331271bace68e97$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0331271bace68e97$var$Lg(d, b.pendingProps), e = $0331271bace68e97$var$Lg(d.type, e), $0331271bace68e97$var$aj(a, b, d, e, c);
        case 15:
            return $0331271bace68e97$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0331271bace68e97$var$Lg(d, e), $0331271bace68e97$var$jj(a, b), b.tag = 1, $0331271bace68e97$var$Zf(d) ? (a = !0, $0331271bace68e97$var$cg(b)) : a = !1, $0331271bace68e97$var$Tg(b, c), $0331271bace68e97$var$ph(b, d, e), $0331271bace68e97$var$rh(b, d, e, c), $0331271bace68e97$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0331271bace68e97$var$yj(a, b, c);
        case 22:
            return $0331271bace68e97$var$ej(a, b, c);
    }
    throw Error($0331271bace68e97$var$p(156, b.tag));
};
function $0331271bace68e97$var$Gk(a, b) {
    return $0331271bace68e97$var$ac(a, b);
}
function $0331271bace68e97$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0331271bace68e97$var$Bg(a, b, c, d) {
    return new $0331271bace68e97$var$al(a, b, c, d);
}
function $0331271bace68e97$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0331271bace68e97$var$$k(a) {
    if ("function" === typeof a) return $0331271bace68e97$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0331271bace68e97$var$Da) return 11;
        if (a === $0331271bace68e97$var$Ga) return 14;
    }
    return 2;
}
function $0331271bace68e97$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0331271bace68e97$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0331271bace68e97$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0331271bace68e97$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0331271bace68e97$var$ya:
            return $0331271bace68e97$var$Ah(c.children, e, f, b);
        case $0331271bace68e97$var$za:
            g = 8;
            e |= 8;
            break;
        case $0331271bace68e97$var$Aa:
            return a = $0331271bace68e97$var$Bg(12, c, b, e | 2), a.elementType = $0331271bace68e97$var$Aa, a.lanes = f, a;
        case $0331271bace68e97$var$Ea:
            return a = $0331271bace68e97$var$Bg(13, c, b, e), a.elementType = $0331271bace68e97$var$Ea, a.lanes = f, a;
        case $0331271bace68e97$var$Fa:
            return a = $0331271bace68e97$var$Bg(19, c, b, e), a.elementType = $0331271bace68e97$var$Fa, a.lanes = f, a;
        case $0331271bace68e97$var$Ia:
            return $0331271bace68e97$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0331271bace68e97$var$Ba:
                    g = 10;
                    break a;
                case $0331271bace68e97$var$Ca:
                    g = 9;
                    break a;
                case $0331271bace68e97$var$Da:
                    g = 11;
                    break a;
                case $0331271bace68e97$var$Ga:
                    g = 14;
                    break a;
                case $0331271bace68e97$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0331271bace68e97$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a), ""));
    }
    b = $0331271bace68e97$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0331271bace68e97$var$Ah(a, b, c, d) {
    a = $0331271bace68e97$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0331271bace68e97$var$qj(a, b, c, d) {
    a = $0331271bace68e97$var$Bg(22, a, d, b);
    a.elementType = $0331271bace68e97$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0331271bace68e97$var$xh(a, b, c) {
    a = $0331271bace68e97$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0331271bace68e97$var$zh(a, b, c) {
    b = $0331271bace68e97$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0331271bace68e97$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0331271bace68e97$var$zc(0);
    this.expirationTimes = $0331271bace68e97$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0331271bace68e97$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0331271bace68e97$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0331271bace68e97$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0331271bace68e97$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0331271bace68e97$var$ah(f);
    return a;
}
function $0331271bace68e97$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0331271bace68e97$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0331271bace68e97$var$el(a) {
    if (!a) return $0331271bace68e97$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0331271bace68e97$var$Vb(a) !== a || 1 !== a.tag) throw Error($0331271bace68e97$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0331271bace68e97$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0331271bace68e97$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0331271bace68e97$var$Zf(c)) return $0331271bace68e97$var$bg(a, c, b);
    }
    return b;
}
function $0331271bace68e97$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0331271bace68e97$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0331271bace68e97$var$el(null);
    c = a.current;
    d = $0331271bace68e97$var$L();
    e = $0331271bace68e97$var$lh(c);
    f = $0331271bace68e97$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0331271bace68e97$var$dh(c, f, e);
    a.current.lanes = e;
    $0331271bace68e97$var$Ac(a, e, d);
    $0331271bace68e97$var$Ek(a, d);
    return a;
}
function $0331271bace68e97$var$gl(a, b, c, d) {
    var e = b.current, f = $0331271bace68e97$var$L(), g = $0331271bace68e97$var$lh(e);
    c = $0331271bace68e97$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0331271bace68e97$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0331271bace68e97$var$dh(e, b, g);
    null !== a && ($0331271bace68e97$var$mh(a, e, g, f), $0331271bace68e97$var$eh(a, e, g));
    return g;
}
function $0331271bace68e97$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0331271bace68e97$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0331271bace68e97$var$jl(a, b) {
    $0331271bace68e97$var$il(a, b);
    (a = a.alternate) && $0331271bace68e97$var$il(a, b);
}
function $0331271bace68e97$var$kl() {
    return null;
}
var $0331271bace68e97$var$ll = "function" === typeof reportError ? reportError : function ll(a) {
    console.error(a);
};
function $0331271bace68e97$var$ml(a) {
    this._internalRoot = a;
}
$0331271bace68e97$var$nl.prototype.render = $0331271bace68e97$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0331271bace68e97$var$p(409));
    $0331271bace68e97$var$gl(a, b, null, null);
};
$0331271bace68e97$var$nl.prototype.unmount = $0331271bace68e97$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0331271bace68e97$var$Sk(function() {
            $0331271bace68e97$var$gl(null, a, null, null);
        });
        b[$0331271bace68e97$var$uf] = null;
    }
};
function $0331271bace68e97$var$nl(a) {
    this._internalRoot = a;
}
$0331271bace68e97$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0331271bace68e97$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0331271bace68e97$var$Qc.length && 0 !== b && b < $0331271bace68e97$var$Qc[c].priority; c++);
        $0331271bace68e97$var$Qc.splice(c, 0, a);
        0 === c && $0331271bace68e97$var$Vc(a);
    }
};
function $0331271bace68e97$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0331271bace68e97$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0331271bace68e97$var$ql() {}
function $0331271bace68e97$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $0331271bace68e97$var$hl(g);
                f.call(_$a);
            };
        }
        var g = $0331271bace68e97$var$fl(b, d, a, 0, null, !1, !1, "", $0331271bace68e97$var$ql);
        a._reactRootContainer = g;
        a[$0331271bace68e97$var$uf] = g.current;
        $0331271bace68e97$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0331271bace68e97$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $0331271bace68e97$var$hl(k);
            h.call(_$a);
        };
    }
    var k = $0331271bace68e97$var$cl(a, 0, !1, null, null, !1, !1, "", $0331271bace68e97$var$ql);
    a._reactRootContainer = k;
    a[$0331271bace68e97$var$uf] = k.current;
    $0331271bace68e97$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0331271bace68e97$var$Sk(function() {
        $0331271bace68e97$var$gl(b, k, c, d);
    });
    return k;
}
function $0331271bace68e97$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $0331271bace68e97$var$hl(g);
                h.call(_$a);
            };
        }
        $0331271bace68e97$var$gl(b, g, a, e);
    } else g = $0331271bace68e97$var$rl(c, b, a, e, d);
    return $0331271bace68e97$var$hl(g);
}
$0331271bace68e97$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0331271bace68e97$var$tc(b.pendingLanes);
                0 !== c && ($0331271bace68e97$var$Cc(b, c | 1), $0331271bace68e97$var$Ek(b, $0331271bace68e97$var$B()), 0 === ($0331271bace68e97$var$K & 6) && ($0331271bace68e97$var$Hj = $0331271bace68e97$var$B() + 500, $0331271bace68e97$var$jg()));
            }
            break;
        case 13:
            $0331271bace68e97$var$Sk(function() {
                var b = $0331271bace68e97$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0331271bace68e97$var$L();
                    $0331271bace68e97$var$mh(b, a, 1, c);
                }
            }), $0331271bace68e97$var$jl(a, 1);
    }
};
$0331271bace68e97$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $0331271bace68e97$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0331271bace68e97$var$L();
            $0331271bace68e97$var$mh(b, a, 134217728, c);
        }
        $0331271bace68e97$var$jl(a, 134217728);
    }
};
$0331271bace68e97$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $0331271bace68e97$var$lh(a), c = $0331271bace68e97$var$Zg(a, b);
        if (null !== c) {
            var d = $0331271bace68e97$var$L();
            $0331271bace68e97$var$mh(c, a, b, d);
        }
        $0331271bace68e97$var$jl(a, b);
    }
};
$0331271bace68e97$var$Hc = function Hc() {
    return $0331271bace68e97$var$C;
};
$0331271bace68e97$var$Ic = function Ic(a, b) {
    var c = $0331271bace68e97$var$C;
    try {
        return $0331271bace68e97$var$C = a, b();
    } finally{
        $0331271bace68e97$var$C = c;
    }
};
$0331271bace68e97$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $0331271bace68e97$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0331271bace68e97$var$Db(d);
                        if (!e) throw Error($0331271bace68e97$var$p(90));
                        $0331271bace68e97$var$Wa(d);
                        $0331271bace68e97$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0331271bace68e97$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0331271bace68e97$var$fb(a, !!c.multiple, b, !1);
    }
};
$0331271bace68e97$var$Gb = $0331271bace68e97$var$Rk;
$0331271bace68e97$var$Hb = $0331271bace68e97$var$Sk;
var $0331271bace68e97$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0331271bace68e97$var$Cb,
        $0331271bace68e97$var$ue,
        $0331271bace68e97$var$Db,
        $0331271bace68e97$var$Eb,
        $0331271bace68e97$var$Fb,
        $0331271bace68e97$var$Rk
    ]
}, $0331271bace68e97$var$ul = {
    findFiberByHostInstance: $0331271bace68e97$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0331271bace68e97$var$vl = {
    bundleType: $0331271bace68e97$var$ul.bundleType,
    version: $0331271bace68e97$var$ul.version,
    rendererPackageName: $0331271bace68e97$var$ul.rendererPackageName,
    rendererConfig: $0331271bace68e97$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0331271bace68e97$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $0331271bace68e97$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0331271bace68e97$var$ul.findFiberByHostInstance || $0331271bace68e97$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0331271bace68e97$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0331271bace68e97$var$wl.isDisabled && $0331271bace68e97$var$wl.supportsFiber) try {
        $0331271bace68e97$var$kc = $0331271bace68e97$var$wl.inject($0331271bace68e97$var$vl), $0331271bace68e97$var$lc = $0331271bace68e97$var$wl;
    } catch (a) {}
}
$0331271bace68e97$export$ae55be85d98224ed = $0331271bace68e97$var$tl;
$0331271bace68e97$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0331271bace68e97$var$ol(b)) throw Error($0331271bace68e97$var$p(200));
    return $0331271bace68e97$var$dl(a, b, null, c);
};
$0331271bace68e97$export$882461b6382ed46c = function(a, b) {
    if (!$0331271bace68e97$var$ol(a)) throw Error($0331271bace68e97$var$p(299));
    var c = !1, d = "", e = $0331271bace68e97$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0331271bace68e97$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0331271bace68e97$var$uf] = b.current;
    $0331271bace68e97$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0331271bace68e97$var$ml(b);
};
$0331271bace68e97$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0331271bace68e97$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0331271bace68e97$var$p(268, a));
    }
    a = $0331271bace68e97$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0331271bace68e97$export$cd75ccfd720a3cd4 = function(a) {
    return $0331271bace68e97$var$Sk(a);
};
$0331271bace68e97$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0331271bace68e97$var$pl(b)) throw Error($0331271bace68e97$var$p(200));
    return $0331271bace68e97$var$sl(null, a, b, !0, c);
};
$0331271bace68e97$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0331271bace68e97$var$ol(a)) throw Error($0331271bace68e97$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0331271bace68e97$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0331271bace68e97$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0331271bace68e97$var$uf] = b.current;
    $0331271bace68e97$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0331271bace68e97$var$nl(b);
};
$0331271bace68e97$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0331271bace68e97$var$pl(b)) throw Error($0331271bace68e97$var$p(200));
    return $0331271bace68e97$var$sl(null, a, b, !1, c);
};
$0331271bace68e97$export$502457920280e6be = function(a) {
    if (!$0331271bace68e97$var$pl(a)) throw Error($0331271bace68e97$var$p(40));
    return a._reactRootContainer ? ($0331271bace68e97$var$Sk(function() {
        $0331271bace68e97$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0331271bace68e97$var$uf] = null;
        });
    }), !0) : !1;
};
$0331271bace68e97$export$c78a37762a8d58e1 = $0331271bace68e97$var$Rk;
$0331271bace68e97$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0331271bace68e97$var$pl(c)) throw Error($0331271bace68e97$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0331271bace68e97$var$p(38));
    return $0331271bace68e97$var$sl(a, b, c, !1, d);
};
$0331271bace68e97$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("1iyD5", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2nkgC"));

});
parcelRequire.register("2nkgC", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $1bad735fa80bcaf4$export$c4744153514ff05d; }, function (v) { return $1bad735fa80bcaf4$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $1bad735fa80bcaf4$export$3e506c1ccc9cc1a7; }, function (v) { return $1bad735fa80bcaf4$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $1bad735fa80bcaf4$export$e26fe2ed2fa76875; }, function (v) { return $1bad735fa80bcaf4$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $1bad735fa80bcaf4$export$502329bbf4b505b1; }, function (v) { return $1bad735fa80bcaf4$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $1bad735fa80bcaf4$export$6e3807111c4874c4; }, function (v) { return $1bad735fa80bcaf4$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $1bad735fa80bcaf4$export$c27134553091fb3a; }, function (v) { return $1bad735fa80bcaf4$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $1bad735fa80bcaf4$export$33ee1acdc04fd2a2; }, function (v) { return $1bad735fa80bcaf4$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $1bad735fa80bcaf4$export$b00a404bbd5edef2; }, function (v) { return $1bad735fa80bcaf4$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $1bad735fa80bcaf4$export$8352ce38b91d0c62; }, function (v) { return $1bad735fa80bcaf4$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $1bad735fa80bcaf4$export$d66a1c1c77bd778b; }, function (v) { return $1bad735fa80bcaf4$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $1bad735fa80bcaf4$export$d3dfb8e4810cb555; }, function (v) { return $1bad735fa80bcaf4$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $1bad735fa80bcaf4$export$839f9183b0465a69; }, function (v) { return $1bad735fa80bcaf4$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $1bad735fa80bcaf4$export$72fdf0e06517287b; }, function (v) { return $1bad735fa80bcaf4$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $1bad735fa80bcaf4$export$4b844e58a3e414b4; }, function (v) { return $1bad735fa80bcaf4$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $1bad735fa80bcaf4$export$816d2913ae6b83b1; }, function (v) { return $1bad735fa80bcaf4$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $1bad735fa80bcaf4$export$61bcfe829111a1d0; }, function (v) { return $1bad735fa80bcaf4$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $1bad735fa80bcaf4$export$7ee8c9beb337bc3f; }, function (v) { return $1bad735fa80bcaf4$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $1bad735fa80bcaf4$export$b5836b71941fa3ed; }, function (v) { return $1bad735fa80bcaf4$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $1bad735fa80bcaf4$export$cf845f2c119da08a; }, function (v) { return $1bad735fa80bcaf4$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bad735fa80bcaf4$export$c4744153514ff05d;
var $1bad735fa80bcaf4$export$3e506c1ccc9cc1a7;
var $1bad735fa80bcaf4$export$e26fe2ed2fa76875;
var $1bad735fa80bcaf4$export$502329bbf4b505b1;
var $1bad735fa80bcaf4$export$6e3807111c4874c4;
var $1bad735fa80bcaf4$export$c27134553091fb3a;
var $1bad735fa80bcaf4$export$33ee1acdc04fd2a2;
var $1bad735fa80bcaf4$export$b00a404bbd5edef2;
var $1bad735fa80bcaf4$export$8352ce38b91d0c62;
var $1bad735fa80bcaf4$export$d66a1c1c77bd778b;
var $1bad735fa80bcaf4$export$d3dfb8e4810cb555;
var $1bad735fa80bcaf4$export$839f9183b0465a69;
var $1bad735fa80bcaf4$export$72fdf0e06517287b;
var $1bad735fa80bcaf4$export$4b844e58a3e414b4;
var $1bad735fa80bcaf4$export$816d2913ae6b83b1;
var $1bad735fa80bcaf4$export$61bcfe829111a1d0;
var $1bad735fa80bcaf4$export$7ee8c9beb337bc3f;
var $1bad735fa80bcaf4$export$b5836b71941fa3ed;
var $1bad735fa80bcaf4$export$cf845f2c119da08a;
"use strict";
function $1bad735fa80bcaf4$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $1bad735fa80bcaf4$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $1bad735fa80bcaf4$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $1bad735fa80bcaf4$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $1bad735fa80bcaf4$var$g(C, c)) n < e && 0 > $1bad735fa80bcaf4$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $1bad735fa80bcaf4$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $1bad735fa80bcaf4$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $1bad735fa80bcaf4$var$l = performance;
    $1bad735fa80bcaf4$export$c4744153514ff05d = function() {
        return $1bad735fa80bcaf4$var$l.now();
    };
} else {
    var $1bad735fa80bcaf4$var$p = Date, $1bad735fa80bcaf4$var$q = $1bad735fa80bcaf4$var$p.now();
    $1bad735fa80bcaf4$export$c4744153514ff05d = function() {
        return $1bad735fa80bcaf4$var$p.now() - $1bad735fa80bcaf4$var$q;
    };
}
var $1bad735fa80bcaf4$var$r = [], $1bad735fa80bcaf4$var$t = [], $1bad735fa80bcaf4$var$u = 1, $1bad735fa80bcaf4$var$v = null, $1bad735fa80bcaf4$var$y = 3, $1bad735fa80bcaf4$var$z = !1, $1bad735fa80bcaf4$var$A = !1, $1bad735fa80bcaf4$var$B = !1, $1bad735fa80bcaf4$var$D = "function" === typeof setTimeout ? setTimeout : null, $1bad735fa80bcaf4$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $1bad735fa80bcaf4$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $1bad735fa80bcaf4$var$G(a) {
    for(var b = $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$t); null !== b;){
        if (null === b.callback) $1bad735fa80bcaf4$var$k($1bad735fa80bcaf4$var$t);
        else if (b.startTime <= a) $1bad735fa80bcaf4$var$k($1bad735fa80bcaf4$var$t), b.sortIndex = b.expirationTime, $1bad735fa80bcaf4$var$f($1bad735fa80bcaf4$var$r, b);
        else break;
        b = $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$t);
    }
}
function $1bad735fa80bcaf4$var$H(a) {
    $1bad735fa80bcaf4$var$B = !1;
    $1bad735fa80bcaf4$var$G(a);
    if (!$1bad735fa80bcaf4$var$A) {
        if (null !== $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$r)) $1bad735fa80bcaf4$var$A = !0, $1bad735fa80bcaf4$var$I($1bad735fa80bcaf4$var$J);
        else {
            var b = $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$t);
            null !== b && $1bad735fa80bcaf4$var$K($1bad735fa80bcaf4$var$H, b.startTime - a);
        }
    }
}
function $1bad735fa80bcaf4$var$J(a, b) {
    $1bad735fa80bcaf4$var$A = !1;
    $1bad735fa80bcaf4$var$B && ($1bad735fa80bcaf4$var$B = !1, $1bad735fa80bcaf4$var$E($1bad735fa80bcaf4$var$L), $1bad735fa80bcaf4$var$L = -1);
    $1bad735fa80bcaf4$var$z = !0;
    var c = $1bad735fa80bcaf4$var$y;
    try {
        $1bad735fa80bcaf4$var$G(b);
        for($1bad735fa80bcaf4$var$v = $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$r); null !== $1bad735fa80bcaf4$var$v && (!($1bad735fa80bcaf4$var$v.expirationTime > b) || a && !$1bad735fa80bcaf4$var$M());){
            var d = $1bad735fa80bcaf4$var$v.callback;
            if ("function" === typeof d) {
                $1bad735fa80bcaf4$var$v.callback = null;
                $1bad735fa80bcaf4$var$y = $1bad735fa80bcaf4$var$v.priorityLevel;
                var e = d($1bad735fa80bcaf4$var$v.expirationTime <= b);
                b = $1bad735fa80bcaf4$export$c4744153514ff05d();
                "function" === typeof e ? $1bad735fa80bcaf4$var$v.callback = e : $1bad735fa80bcaf4$var$v === $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$r) && $1bad735fa80bcaf4$var$k($1bad735fa80bcaf4$var$r);
                $1bad735fa80bcaf4$var$G(b);
            } else $1bad735fa80bcaf4$var$k($1bad735fa80bcaf4$var$r);
            $1bad735fa80bcaf4$var$v = $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$r);
        }
        if (null !== $1bad735fa80bcaf4$var$v) var w = !0;
        else {
            var m = $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$t);
            null !== m && $1bad735fa80bcaf4$var$K($1bad735fa80bcaf4$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $1bad735fa80bcaf4$var$v = null, $1bad735fa80bcaf4$var$y = c, $1bad735fa80bcaf4$var$z = !1;
    }
}
var $1bad735fa80bcaf4$var$N = !1, $1bad735fa80bcaf4$var$O = null, $1bad735fa80bcaf4$var$L = -1, $1bad735fa80bcaf4$var$P = 5, $1bad735fa80bcaf4$var$Q = -1;
function $1bad735fa80bcaf4$var$M() {
    return $1bad735fa80bcaf4$export$c4744153514ff05d() - $1bad735fa80bcaf4$var$Q < $1bad735fa80bcaf4$var$P ? !1 : !0;
}
function $1bad735fa80bcaf4$var$R() {
    if (null !== $1bad735fa80bcaf4$var$O) {
        var a = $1bad735fa80bcaf4$export$c4744153514ff05d();
        $1bad735fa80bcaf4$var$Q = a;
        var b = !0;
        try {
            b = $1bad735fa80bcaf4$var$O(!0, a);
        } finally{
            b ? $1bad735fa80bcaf4$var$S() : ($1bad735fa80bcaf4$var$N = !1, $1bad735fa80bcaf4$var$O = null);
        }
    } else $1bad735fa80bcaf4$var$N = !1;
}
var $1bad735fa80bcaf4$var$S;
if ("function" === typeof $1bad735fa80bcaf4$var$F) $1bad735fa80bcaf4$var$S = function S() {
    $1bad735fa80bcaf4$var$F($1bad735fa80bcaf4$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $1bad735fa80bcaf4$var$T = new MessageChannel, $1bad735fa80bcaf4$var$U = $1bad735fa80bcaf4$var$T.port2;
    $1bad735fa80bcaf4$var$T.port1.onmessage = $1bad735fa80bcaf4$var$R;
    $1bad735fa80bcaf4$var$S = function S() {
        $1bad735fa80bcaf4$var$U.postMessage(null);
    };
} else $1bad735fa80bcaf4$var$S = function S() {
    $1bad735fa80bcaf4$var$D($1bad735fa80bcaf4$var$R, 0);
};
function $1bad735fa80bcaf4$var$I(a) {
    $1bad735fa80bcaf4$var$O = a;
    $1bad735fa80bcaf4$var$N || ($1bad735fa80bcaf4$var$N = !0, $1bad735fa80bcaf4$var$S());
}
function $1bad735fa80bcaf4$var$K(a, b) {
    $1bad735fa80bcaf4$var$L = $1bad735fa80bcaf4$var$D(function() {
        a($1bad735fa80bcaf4$export$c4744153514ff05d());
    }, b);
}
$1bad735fa80bcaf4$export$3e506c1ccc9cc1a7 = 5;
$1bad735fa80bcaf4$export$e26fe2ed2fa76875 = 1;
$1bad735fa80bcaf4$export$502329bbf4b505b1 = 4;
$1bad735fa80bcaf4$export$6e3807111c4874c4 = 3;
$1bad735fa80bcaf4$export$c27134553091fb3a = null;
$1bad735fa80bcaf4$export$33ee1acdc04fd2a2 = 2;
$1bad735fa80bcaf4$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$1bad735fa80bcaf4$export$8352ce38b91d0c62 = function() {
    $1bad735fa80bcaf4$var$A || $1bad735fa80bcaf4$var$z || ($1bad735fa80bcaf4$var$A = !0, $1bad735fa80bcaf4$var$I($1bad735fa80bcaf4$var$J));
};
$1bad735fa80bcaf4$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $1bad735fa80bcaf4$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$1bad735fa80bcaf4$export$d3dfb8e4810cb555 = function() {
    return $1bad735fa80bcaf4$var$y;
};
$1bad735fa80bcaf4$export$839f9183b0465a69 = function() {
    return $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$r);
};
$1bad735fa80bcaf4$export$72fdf0e06517287b = function(a) {
    switch($1bad735fa80bcaf4$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $1bad735fa80bcaf4$var$y;
    }
    var c = $1bad735fa80bcaf4$var$y;
    $1bad735fa80bcaf4$var$y = b;
    try {
        return a();
    } finally{
        $1bad735fa80bcaf4$var$y = c;
    }
};
$1bad735fa80bcaf4$export$4b844e58a3e414b4 = function() {};
$1bad735fa80bcaf4$export$816d2913ae6b83b1 = function() {};
$1bad735fa80bcaf4$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $1bad735fa80bcaf4$var$y;
    $1bad735fa80bcaf4$var$y = a;
    try {
        return b();
    } finally{
        $1bad735fa80bcaf4$var$y = c;
    }
};
$1bad735fa80bcaf4$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $1bad735fa80bcaf4$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $1bad735fa80bcaf4$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $1bad735fa80bcaf4$var$f($1bad735fa80bcaf4$var$t, a), null === $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$r) && a === $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$t) && ($1bad735fa80bcaf4$var$B ? ($1bad735fa80bcaf4$var$E($1bad735fa80bcaf4$var$L), $1bad735fa80bcaf4$var$L = -1) : $1bad735fa80bcaf4$var$B = !0, $1bad735fa80bcaf4$var$K($1bad735fa80bcaf4$var$H, c - d))) : (a.sortIndex = e, $1bad735fa80bcaf4$var$f($1bad735fa80bcaf4$var$r, a), $1bad735fa80bcaf4$var$A || $1bad735fa80bcaf4$var$z || ($1bad735fa80bcaf4$var$A = !0, $1bad735fa80bcaf4$var$I($1bad735fa80bcaf4$var$J)));
    return a;
};
$1bad735fa80bcaf4$export$b5836b71941fa3ed = $1bad735fa80bcaf4$var$M;
$1bad735fa80bcaf4$export$cf845f2c119da08a = function(a) {
    var b = $1bad735fa80bcaf4$var$y;
    return function() {
        var c = $1bad735fa80bcaf4$var$y;
        $1bad735fa80bcaf4$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $1bad735fa80bcaf4$var$y = c;
        }
    };
};

});



var $d8ffb49eb4cd7afd$exports = {};
"use strict";

$d8ffb49eb4cd7afd$exports = (parcelRequire("jIgWH"));


parcelRequire("dQFEZ");
var $8dbfa3fee6dc40a7$exports = {};

$parcel$export($8dbfa3fee6dc40a7$exports, "createRoot", function () { return $8dbfa3fee6dc40a7$export$882461b6382ed46c; }, function (v) { return $8dbfa3fee6dc40a7$export$882461b6382ed46c = v; });
$parcel$export($8dbfa3fee6dc40a7$exports, "hydrateRoot", function () { return $8dbfa3fee6dc40a7$export$757ceba2d55c277e; }, function (v) { return $8dbfa3fee6dc40a7$export$757ceba2d55c277e = v; });
var $8dbfa3fee6dc40a7$export$882461b6382ed46c;
var $8dbfa3fee6dc40a7$export$757ceba2d55c277e;
"use strict";
var $4288f0eb191085d1$exports = {};
"use strict";
function $4288f0eb191085d1$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($4288f0eb191085d1$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$4288f0eb191085d1$var$checkDCE();

$4288f0eb191085d1$exports = (parcelRequire("gZreO"));


var $8dbfa3fee6dc40a7$var$i;
$8dbfa3fee6dc40a7$export$882461b6382ed46c = $4288f0eb191085d1$exports.createRoot;
$8dbfa3fee6dc40a7$export$757ceba2d55c277e = $4288f0eb191085d1$exports.hydrateRoot;


function $0eaa95b9f3cb7234$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}


function $7e2f2d8338cd036c$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $6cb937a794637792$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $489def0a77882a2a$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $1ebd819a91fcf92e$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $489def0a77882a2a$export$79e617b1955a2616)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $489def0a77882a2a$export$79e617b1955a2616)(o, minLen);
}


function $1bb6f341c8f857d6$export$fdf2a89c76341bbf(arr, i) {
    return (0, $0eaa95b9f3cb7234$export$e6256bf45c68d561)(arr) || (0, $7e2f2d8338cd036c$export$2fd15edff6687200)(arr, i) || (0, $1ebd819a91fcf92e$export$a5be06335b3a083c)(arr, i) || (0, $6cb937a794637792$export$60dbc22abd7da546)();
}



var $1ad00fd5a6f8ced9$var$CORS_PROXY = "https://corsproxy.io/?";
var $1ad00fd5a6f8ced9$export$8878ead86ed0da0b = "https://t3.ftcdn.net/jpg/01/31/19/42/360_F_131194206_jk113fvl8oFmeAHSWzDyhRJIkiBmnNaN.jpg";
var $1ad00fd5a6f8ced9$export$d5ef6164957048b8 = "https://image.shutterstock.com/image-vector/contact-us-concept-icon-information-260nw-1212067657.jpg";
var $1ad00fd5a6f8ced9$export$1d6744690e556718 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
var $1ad00fd5a6f8ced9$export$3c67ec6258c4a827 = "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/";
var $1ad00fd5a6f8ced9$export$28758bffe9e46c7e = $1ad00fd5a6f8ced9$var$CORS_PROXY + "https://www.swiggy.com/dapi/restaurants/list/v5?lat=21.1702401&lng=72.83106070000001&page_type=DESKTOP_WEB_LISTING";
var $1ad00fd5a6f8ced9$export$db8df6be5e4ba8bc = "https://i.pinimg.com/originals/30/32/96/303296521d256bfbb17f76c3b3592738.png";
var $1ad00fd5a6f8ced9$export$f9288df19face69b = "https://corsproxy.io/?https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=21.1702401&lng=72.83106070000001&&submitAction=ENTER&restaurantId=";
var $1ad00fd5a6f8ced9$export$138fdc351675302c = "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory";
var $1ad00fd5a6f8ced9$export$4a3a00b9ff5cf3da = "type.googleapis.com/swiggy.presentation.food.v2.Restaurant";
var $1ad00fd5a6f8ced9$export$3c5a5d8e1e203ce0 = "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_208,h_208,c_fit/";



var $dQFEZ = parcelRequire("dQFEZ");
/**
 * React Router DOM v6.15.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

function $ae6d0dee9f5eb3eb$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $489def0a77882a2a$export$79e617b1955a2616)(arr);
}


function $a50bc32ea5ddcbbf$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $2fce3437f4cf1874$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $1d041ee89e51af1b$export$1b5e630bc3aea29f(arr) {
    return (0, $ae6d0dee9f5eb3eb$export$7e0947b5ad3404e2)(arr) || (0, $a50bc32ea5ddcbbf$export$1eb58a6e75231000)(arr) || (0, $1ebd819a91fcf92e$export$a5be06335b3a083c)(arr) || (0, $2fce3437f4cf1874$export$e6f3c4780d19eb2b)();
}



var $dQFEZ = parcelRequire("dQFEZ");
/**
 * @remix-run/router v1.8.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $baf9b2a64fedef68$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $baf9b2a64fedef68$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $baf9b2a64fedef68$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $baf9b2a64fedef68$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


function $bf86af1e5034cb56$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $9ac25a306229a9ff$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9ac25a306229a9ff$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $9ac25a306229a9ff$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9ac25a306229a9ff$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $51fbb26672273063$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $b7d0b832e35ee57e$export$c2c98ac76e997b63(o, p) {
    $b7d0b832e35ee57e$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b7d0b832e35ee57e$export$c2c98ac76e997b63(o, p);
}


function $de944088b801fe33$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $b7d0b832e35ee57e$export$c2c98ac76e997b63)(subClass, superClass);
}







function $f625ca9f0dc92caa$export$e62c166da838fa3(arr) {
    return (0, $0eaa95b9f3cb7234$export$e6256bf45c68d561)(arr) || (0, $a50bc32ea5ddcbbf$export$1eb58a6e75231000)(arr) || (0, $1ebd819a91fcf92e$export$a5be06335b3a083c)(arr) || (0, $6cb937a794637792$export$60dbc22abd7da546)();
}



function $b4560d09ed0b6bd9$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}



function $634d6964686a1afa$export$2d841144c5f8c4ab(Parent, args, Class) {
    if ((0, $b4560d09ed0b6bd9$export$685354647fba1516)()) $634d6964686a1afa$export$2d841144c5f8c4ab = Reflect.construct;
    else $634d6964686a1afa$export$2d841144c5f8c4ab = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $b7d0b832e35ee57e$export$c2c98ac76e997b63)(instance, Class.prototype);
        return instance;
    };
    return $634d6964686a1afa$export$2d841144c5f8c4ab.apply(null, arguments);
}


function $c0e0c9403f4e59d3$export$f09211a7d3c496a1(o) {
    $c0e0c9403f4e59d3$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c0e0c9403f4e59d3$export$f09211a7d3c496a1(o);
}


function $7c446d547ed0cd60$export$514eda94019f4334(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}



function $135979cf6d0dc133$export$2466d533fda16e33(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $135979cf6d0dc133$export$2466d533fda16e33 = function(Class) {
        if (Class === null || !(0, $7c446d547ed0cd60$export$514eda94019f4334)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $634d6964686a1afa$export$2d841144c5f8c4ab)(Class, arguments, (0, $c0e0c9403f4e59d3$export$f09211a7d3c496a1)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $b7d0b832e35ee57e$export$c2c98ac76e997b63)(Wrapper, Class);
    };
    return $135979cf6d0dc133$export$2466d533fda16e33(Class);
}




function $99cfd4696d3ae8ed$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}



var $bJtXW = parcelRequire("bJtXW");
function $031a439d9bd8f8b3$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $bJtXW._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $99cfd4696d3ae8ed$export$f3b8ed2e4a5d10b8)(self);
}


function $f8f85617d0e0b5b6$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $b4560d09ed0b6bd9$export$685354647fba1516)();
    return function _createSuperInternal() {
        var Super = (0, $c0e0c9403f4e59d3$export$f09211a7d3c496a1)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $c0e0c9403f4e59d3$export$f09211a7d3c496a1)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $031a439d9bd8f8b3$export$ef97c660ca164e52)(this, result);
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $bJtXW = parcelRequire("bJtXW");
var $b8c3f91e5973f862$var$extendStatics = function extendStatics1(d, b) {
    $b8c3f91e5973f862$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $b8c3f91e5973f862$var$extendStatics(d, b);
};
function $b8c3f91e5973f862$export$a8ba968b8961cb8a(d, b) {
    var __ = function __() {
        this.constructor = d;
    };
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $b8c3f91e5973f862$var$extendStatics(d, b);
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b8c3f91e5973f862$export$18ce0697a983be9b = function __assign1() {
    $b8c3f91e5973f862$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b8c3f91e5973f862$export$18ce0697a983be9b.apply(this, arguments);
};
function $b8c3f91e5973f862$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b8c3f91e5973f862$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $b8c3f91e5973f862$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b8c3f91e5973f862$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    var accept = function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    };
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $b8c3f91e5973f862$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $b8c3f91e5973f862$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $bJtXW._)(x)) === "symbol" ? x : "".concat(x);
}
function $b8c3f91e5973f862$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $bJtXW._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $b8c3f91e5973f862$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $b8c3f91e5973f862$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b8c3f91e5973f862$export$67ebef60e6f28a6(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
}
var $b8c3f91e5973f862$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $b8c3f91e5973f862$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $b8c3f91e5973f862$export$45d3717a4c69092e(o, m, p);
}
function $b8c3f91e5973f862$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b8c3f91e5973f862$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $b8c3f91e5973f862$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($b8c3f91e5973f862$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $b8c3f91e5973f862$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b8c3f91e5973f862$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $b8c3f91e5973f862$export$10c90e4f7922046c(v) {
    return this instanceof $b8c3f91e5973f862$export$10c90e4f7922046c ? (this.v = v, this) : new $b8c3f91e5973f862$export$10c90e4f7922046c(v);
}
function $b8c3f91e5973f862$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    var verb = function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    };
    var resume = function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    };
    var step = function step(r) {
        r.value instanceof $b8c3f91e5973f862$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    };
    var fulfill = function fulfill(value) {
        resume("next", value);
    };
    var reject = function reject(value) {
        resume("throw", value);
    };
    var settle = function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    };
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
}
function $b8c3f91e5973f862$export$bbd80228419bb833(o) {
    var verb = function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $b8c3f91e5973f862$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    };
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
}
function $b8c3f91e5973f862$export$e3b29a3d6162315f(o) {
    var verb = function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    };
    var settle = function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    };
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $b8c3f91e5973f862$export$19a8beecd37a4c45 === "function" ? $b8c3f91e5973f862$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
}
function $b8c3f91e5973f862$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $b8c3f91e5973f862$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $b8c3f91e5973f862$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b8c3f91e5973f862$export$45d3717a4c69092e(result, mod, k);
    }
    $b8c3f91e5973f862$var$__setModuleDefault(result, mod);
    return result;
}
function $b8c3f91e5973f862$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $b8c3f91e5973f862$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $b8c3f91e5973f862$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $b8c3f91e5973f862$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $b8c3f91e5973f862$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $b8c3f91e5973f862$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $b8c3f91e5973f862$export$8f076105dc360e92(env) {
    var fail = function fail(e) {
        env.error = env.hasError ? new $b8c3f91e5973f862$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    };
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $b8c3f91e5973f862$export$2e2bcd8739ae039 = {
    __extends: $b8c3f91e5973f862$export$a8ba968b8961cb8a,
    __assign: $b8c3f91e5973f862$export$18ce0697a983be9b,
    __rest: $b8c3f91e5973f862$export$3c9a16f847548506,
    __decorate: $b8c3f91e5973f862$export$29e00dfd3077644b,
    __param: $b8c3f91e5973f862$export$d5ad3fd78186038f,
    __metadata: $b8c3f91e5973f862$export$f1db080c865becb9,
    __awaiter: $b8c3f91e5973f862$export$1050f835b63b671e,
    __generator: $b8c3f91e5973f862$export$67ebef60e6f28a6,
    __createBinding: $b8c3f91e5973f862$export$45d3717a4c69092e,
    __exportStar: $b8c3f91e5973f862$export$f33643c0debef087,
    __values: $b8c3f91e5973f862$export$19a8beecd37a4c45,
    __read: $b8c3f91e5973f862$export$8d051b38c9118094,
    __spread: $b8c3f91e5973f862$export$afc72e2116322959,
    __spreadArrays: $b8c3f91e5973f862$export$6388937ca91ccae8,
    __spreadArray: $b8c3f91e5973f862$export$1216008129fb82ed,
    __await: $b8c3f91e5973f862$export$10c90e4f7922046c,
    __asyncGenerator: $b8c3f91e5973f862$export$e427f37a30a4de9b,
    __asyncDelegator: $b8c3f91e5973f862$export$bbd80228419bb833,
    __asyncValues: $b8c3f91e5973f862$export$e3b29a3d6162315f,
    __makeTemplateObject: $b8c3f91e5973f862$export$4fb47efe1390b86f,
    __importStar: $b8c3f91e5973f862$export$c21735bcef00d192,
    __importDefault: $b8c3f91e5973f862$export$da59b14a69baef04,
    __classPrivateFieldGet: $b8c3f91e5973f862$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $b8c3f91e5973f862$export$d40a35129aaff81f,
    __classPrivateFieldIn: $b8c3f91e5973f862$export$81fdc39f203e4e04,
    __addDisposableResource: $b8c3f91e5973f862$export$88ac25d8e944e405,
    __disposeResources: $b8c3f91e5973f862$export$8f076105dc360e92
};



function $be547bb6c77acdb8$var$_extends() {
    $be547bb6c77acdb8$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $be547bb6c77acdb8$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $be547bb6c77acdb8$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($be547bb6c77acdb8$export$e19cd5f9376f8cee || ($be547bb6c77acdb8$export$e19cd5f9376f8cee = {}));
var $be547bb6c77acdb8$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $be547bb6c77acdb8$export$2b76ad033c6e6d08(options) {
    var clampIndex = function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    };
    var getCurrentLocation = function getCurrentLocation() {
        return entries[index];
    };
    var createMemoryLocation = function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        var location = $be547bb6c77acdb8$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $be547bb6c77acdb8$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    };
    var createHref = function createHref(to) {
        return typeof to === "string" ? to : $be547bb6c77acdb8$export$fe53371bee54353d(to);
    };
    if (options === void 0) options = {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map(function(entry, index) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL: function(to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? $be547bb6c77acdb8$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Push;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Replace;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Pop;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $be547bb6c77acdb8$export$719fc203c4e16dee(options) {
    var createBrowserLocation = function createBrowserLocation(window1, globalHistory) {
        var _window_location = window1.location, pathname = _window_location.pathname, search = _window_location.search, hash = _window_location.hash;
        return $be547bb6c77acdb8$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    };
    var createBrowserHref = function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $be547bb6c77acdb8$export$fe53371bee54353d(to);
    };
    if (options === void 0) options = {};
    return $be547bb6c77acdb8$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $be547bb6c77acdb8$export$b71fdd3798280242(options) {
    var createHashLocation = function createHashLocation(window1, globalHistory) {
        var _parsePath = $be547bb6c77acdb8$export$8ccf933b0513f8d0(window1.location.hash.substr(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $be547bb6c77acdb8$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    };
    var createHashHref = function createHashHref(window1, to) {
        var base = window1.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window1.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $be547bb6c77acdb8$export$fe53371bee54353d(to));
    };
    var validateHashLocation = function validateHashLocation(location, to) {
        $be547bb6c77acdb8$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    };
    if (options === void 0) options = {};
    return $be547bb6c77acdb8$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $be547bb6c77acdb8$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $be547bb6c77acdb8$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $be547bb6c77acdb8$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $be547bb6c77acdb8$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $be547bb6c77acdb8$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    var location = $be547bb6c77acdb8$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $be547bb6c77acdb8$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $be547bb6c77acdb8$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $be547bb6c77acdb8$export$fe53371bee54353d(_ref) {
    var _ref_pathname = _ref.pathname, pathname = _ref_pathname === void 0 ? "/" : _ref_pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $be547bb6c77acdb8$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $be547bb6c77acdb8$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    var getIndex = function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    };
    var handlePop = function handlePop() {
        action = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Pop;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    };
    var push = function push(to, state) {
        action = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Push;
        var location = $be547bb6c77acdb8$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = $be547bb6c77acdb8$var$getHistoryState(location, index);
        var url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    };
    var replace = function replace(to, state) {
        action = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Replace;
        var location = $be547bb6c77acdb8$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = $be547bb6c77acdb8$var$getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    };
    var createURL = function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        var base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        var href = typeof to === "string" ? to : $be547bb6c77acdb8$export$fe53371bee54353d(to);
        $be547bb6c77acdb8$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    };
    if (options === void 0) options = {};
    var _options_window = options.window, window1 = _options_window === void 0 ? document.defaultView : _options_window, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window1.history;
    var action = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    var index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($be547bb6c77acdb8$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($be547bb6c77acdb8$var$PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window1.removeEventListener($be547bb6c77acdb8$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            // Encode a Location the same way window.location would
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $be547bb6c77acdb8$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($be547bb6c77acdb8$var$ResultType || ($be547bb6c77acdb8$var$ResultType = {}));
var $be547bb6c77acdb8$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $be547bb6c77acdb8$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $be547bb6c77acdb8$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map(function(route, index) {
        var treePath = (0, $1d041ee89e51af1b$export$1b5e630bc3aea29f)(parentPath).concat([
            index
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        $be547bb6c77acdb8$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $be547bb6c77acdb8$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($be547bb6c77acdb8$var$isIndexRoute(route)) {
            var indexRoute = $be547bb6c77acdb8$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = $be547bb6c77acdb8$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $be547bb6c77acdb8$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $be547bb6c77acdb8$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    var location = typeof locationArg === "string" ? $be547bb6c77acdb8$export$8ccf933b0513f8d0(locationArg) : locationArg;
    var pathname = $be547bb6c77acdb8$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = $be547bb6c77acdb8$var$flattenRoutes(routes);
    $be547bb6c77acdb8$var$rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i)matches = $be547bb6c77acdb8$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $be547bb6c77acdb8$var$safelyDecodeURI(pathname));
    return matches;
}
function $be547bb6c77acdb8$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    var flattenRoute = function(route, index, relativePath) {
        var meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $be547bb6c77acdb8$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = $be547bb6c77acdb8$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $be547bb6c77acdb8$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $be547bb6c77acdb8$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $be547bb6c77acdb8$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route$path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = $be547bb6c77acdb8$var$explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $be547bb6c77acdb8$var$explodeOptionalSegments(path) {
    var // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $f625ca9f0dc92caa$export$e62c166da838fa3)(segments), first = _segments[0], rest = _segments.slice(1);
    // Optional path segments are denoted by a trailing `?`
    var isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = $be547bb6c77acdb8$var$explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, $1d041ee89e51af1b$export$1b5e630bc3aea29f)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    // Then if this is an optional value, add all child versions without
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $1d041ee89e51af1b$export$1b5e630bc3aea29f)(restExploded));
    // for absolute paths, ensure `/` instead of empty segment
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function $be547bb6c77acdb8$var$rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score // Higher score first
         : $be547bb6c77acdb8$var$compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var $be547bb6c77acdb8$var$paramRe = /^:\w+$/;
var $be547bb6c77acdb8$var$dynamicSegmentValue = 3;
var $be547bb6c77acdb8$var$indexRouteValue = 2;
var $be547bb6c77acdb8$var$emptySegmentValue = 1;
var $be547bb6c77acdb8$var$staticSegmentValue = 10;
var $be547bb6c77acdb8$var$splatPenalty = -2;
var $be547bb6c77acdb8$var$isSplat = function(s) {
    return s === "*";
};
function $be547bb6c77acdb8$var$computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some($be547bb6c77acdb8$var$isSplat)) initialScore += $be547bb6c77acdb8$var$splatPenalty;
    if (index) initialScore += $be547bb6c77acdb8$var$indexRouteValue;
    return segments.filter(function(s) {
        return !$be547bb6c77acdb8$var$isSplat(s);
    }).reduce(function(score, segment) {
        return score + ($be547bb6c77acdb8$var$paramRe.test(segment) ? $be547bb6c77acdb8$var$dynamicSegmentValue : segment === "" ? $be547bb6c77acdb8$var$emptySegmentValue : $be547bb6c77acdb8$var$staticSegmentValue);
    }, initialScore);
}
function $be547bb6c77acdb8$var$compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $be547bb6c77acdb8$var$matchRouteBranch(branch, pathname) {
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = $be547bb6c77acdb8$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        var route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $be547bb6c77acdb8$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $be547bb6c77acdb8$export$a5c6d149b50c1d86($be547bb6c77acdb8$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $be547bb6c77acdb8$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $be547bb6c77acdb8$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $be547bb6c77acdb8$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            var star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        var keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            $be547bb6c77acdb8$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $be547bb6c77acdb8$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)($be547bb6c77acdb8$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], paramNames = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = paramNames.reduce(function(memo, paramName, index) {
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $be547bb6c77acdb8$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $be547bb6c77acdb8$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $be547bb6c77acdb8$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    var paramNames = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, function(_, paramName) {
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $be547bb6c77acdb8$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $be547bb6c77acdb8$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $be547bb6c77acdb8$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $be547bb6c77acdb8$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $be547bb6c77acdb8$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $be547bb6c77acdb8$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    var _ref = typeof to === "string" ? $be547bb6c77acdb8$export$8ccf933b0513f8d0(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $be547bb6c77acdb8$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $be547bb6c77acdb8$var$normalizeSearch(search),
        hash: $be547bb6c77acdb8$var$normalizeHash(hash)
    };
}
function $be547bb6c77acdb8$var$resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $be547bb6c77acdb8$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $be547bb6c77acdb8$export$90ba53ce1c7fdff2(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
/**
 * @private
 */ function $be547bb6c77acdb8$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    var to;
    if (typeof toArg === "string") to = $be547bb6c77acdb8$export$8ccf933b0513f8d0(toArg);
    else {
        to = $be547bb6c77acdb8$var$_extends({}, toArg);
        $be547bb6c77acdb8$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $be547bb6c77acdb8$var$getInvalidPathError("?", "pathname", "search", to));
        $be547bb6c77acdb8$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $be547bb6c77acdb8$var$getInvalidPathError("#", "pathname", "hash", to));
        $be547bb6c77acdb8$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $be547bb6c77acdb8$var$getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = $be547bb6c77acdb8$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $be547bb6c77acdb8$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $be547bb6c77acdb8$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ var $be547bb6c77acdb8$export$86d9a7913e44197e = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */ var $be547bb6c77acdb8$export$a5c6d149b50c1d86 = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
/**
 * @private
 */ var $be547bb6c77acdb8$var$normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */ var $be547bb6c77acdb8$var$normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ var $be547bb6c77acdb8$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    var headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $be547bb6c77acdb8$var$_extends({}, responseInit, {
        headers: headers
    }));
};
var $be547bb6c77acdb8$export$42a99a7a4bc0e76a = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $de944088b801fe33$export$7e4530ad35d3bb8)(AbortedDeferredError, Error1);
    var _super = (0, $f8f85617d0e0b5b6$export$8dd05c13f5255580)(AbortedDeferredError);
    function AbortedDeferredError() {
        (0, $bf86af1e5034cb56$export$2996f80ef42b8419)(this, AbortedDeferredError);
        return _super.apply(this, arguments);
    }
    return AbortedDeferredError;
}((0, $135979cf6d0dc133$export$2466d533fda16e33)(Error));
var $be547bb6c77acdb8$export$61d759255b4eec65 = /*#__PURE__*/ function() {
    "use strict";
    function DeferredData(data, responseInit) {
        var _this = this;
        (0, $bf86af1e5034cb56$export$2996f80ef42b8419)(this, DeferredData);
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $be547bb6c77acdb8$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        var reject;
        this.abortPromise = new Promise(function(_, r) {
            return reject = r;
        });
        this.controller = new AbortController();
        var onAbort = function() {
            return reject(new $be547bb6c77acdb8$export$42a99a7a4bc0e76a("Deferred data aborted"));
        };
        this.unlistenAbortSignal = function() {
            return _this.controller.signal.removeEventListener("abort", onAbort);
        };
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce(function(acc, _ref) {
            var _$_ref = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)(_ref, 2), key = _$_ref[0], value = _$_ref[1];
            return Object.assign(acc, (0, $51fbb26672273063$export$1e71eb4bef00f6b0)({}, key, _this.trackPromise(key, value)));
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    (0, $9ac25a306229a9ff$export$d60067ff2358eee8)(DeferredData, [
        {
            key: "trackPromise",
            value: function trackPromise(key, value) {
                var _this = this;
                if (!(value instanceof Promise)) return value;
                this.deferredKeys.push(key);
                this.pendingKeysSet.add(key);
                // We store a little wrapper promise that will be extended with
                // _data/_error props upon resolve/reject
                var promise = Promise.race([
                    value,
                    this.abortPromise
                ]).then(function(data) {
                    return _this.onSettle(promise, key, undefined, data);
                }, function(error) {
                    return _this.onSettle(promise, key, error);
                });
                // Register rejection listeners to avoid uncaught promise rejections on
                // errors or aborted deferred values
                promise.catch(function() {});
                Object.defineProperty(promise, "_tracked", {
                    get: function() {
                        return true;
                    }
                });
                return promise;
            }
        },
        {
            key: "onSettle",
            value: function onSettle(promise, key, error, data) {
                if (this.controller.signal.aborted && error instanceof $be547bb6c77acdb8$export$42a99a7a4bc0e76a) {
                    this.unlistenAbortSignal();
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    return Promise.reject(error);
                }
                this.pendingKeysSet.delete(key);
                if (this.done) // Nothing left to abort!
                this.unlistenAbortSignal();
                // If the promise was resolved/rejected with undefined, we'll throw an error as you
                // should always resolve with a value or null
                if (error === undefined && data === undefined) {
                    var undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return undefinedError;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(undefinedError);
                }
                if (data === undefined) {
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(error);
                }
                Object.defineProperty(promise, "_data", {
                    get: function() {
                        return data;
                    }
                });
                this.emit(false, key);
                return data;
            }
        },
        {
            key: "emit",
            value: function emit(aborted, settledKey) {
                this.subscribers.forEach(function(subscriber) {
                    return subscriber(aborted, settledKey);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(fn) {
                var _this = this;
                this.subscribers.add(fn);
                return function() {
                    return _this.subscribers.delete(fn);
                };
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this = this;
                this.controller.abort();
                this.pendingKeysSet.forEach(function(v, k) {
                    return _this.pendingKeysSet.delete(k);
                });
                this.emit(true);
            }
        },
        {
            key: "resolveData",
            value: function resolveData(signal) {
                var _this = this;
                return (0, $baf9b2a64fedef68$export$7c398597f8905a1)(function() {
                    var aborted, onAbort;
                    return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                aborted = false;
                                if (!!_this.done) return [
                                    3,
                                    2
                                ];
                                onAbort = function() {
                                    return _this.cancel();
                                };
                                signal.addEventListener("abort", onAbort);
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.subscribe(function(aborted) {
                                            signal.removeEventListener("abort", onAbort);
                                            if (aborted || _this.done) resolve(aborted);
                                        });
                                    })
                                ];
                            case 1:
                                aborted = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    aborted
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "done",
            get: function get() {
                return this.pendingKeysSet.size === 0;
            }
        },
        {
            key: "unwrappedData",
            get: function get() {
                $be547bb6c77acdb8$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
                return Object.entries(this.data).reduce(function(acc, _ref2) {
                    var _$_ref2 = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)(_ref2, 2), key = _$_ref2[0], value = _$_ref2[1];
                    return Object.assign(acc, (0, $51fbb26672273063$export$1e71eb4bef00f6b0)({}, key, $be547bb6c77acdb8$var$unwrapTrackedPromise(value)));
                }, {});
            }
        },
        {
            key: "pendingKeys",
            get: function get() {
                return Array.from(this.pendingKeysSet);
            }
        }
    ]);
    return DeferredData;
}();
function $be547bb6c77acdb8$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $be547bb6c77acdb8$var$unwrapTrackedPromise(value) {
    if (!$be547bb6c77acdb8$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
var $be547bb6c77acdb8$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $be547bb6c77acdb8$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $be547bb6c77acdb8$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $be547bb6c77acdb8$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $be547bb6c77acdb8$export$a6cd19cd1951a23c = function(url, init) {
    var response = $be547bb6c77acdb8$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ var $be547bb6c77acdb8$export$acf1a680051f5031 = function ErrorResponse(status, statusText, data, internal) {
    "use strict";
    (0, $bf86af1e5034cb56$export$2996f80ef42b8419)(this, ErrorResponse);
    if (internal === void 0) internal = false;
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data instanceof Error) {
        this.data = data.toString();
        this.error = data;
    } else this.data = data;
};
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $be547bb6c77acdb8$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
var $be547bb6c77acdb8$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
var $be547bb6c77acdb8$var$validMutationMethods = new Set($be547bb6c77acdb8$var$validMutationMethodsArr);
var $be547bb6c77acdb8$var$validRequestMethodsArr = [
    "get"
].concat((0, $1d041ee89e51af1b$export$1b5e630bc3aea29f)($be547bb6c77acdb8$var$validMutationMethodsArr));
var $be547bb6c77acdb8$var$validRequestMethods = new Set($be547bb6c77acdb8$var$validRequestMethodsArr);
var $be547bb6c77acdb8$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
var $be547bb6c77acdb8$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
var $be547bb6c77acdb8$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $be547bb6c77acdb8$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $be547bb6c77acdb8$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
var $be547bb6c77acdb8$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $be547bb6c77acdb8$var$defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $be547bb6c77acdb8$export$baddd0131ee8c05b(init) {
    var initialize = // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen(function(_ref) {
            var historyAction = _ref.action, location = _ref.location, delta = _ref.delta;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $be547bb6c77acdb8$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $be547bb6c77acdb8$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($be547bb6c77acdb8$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    };
    var dispose = // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    };
    var subscribe = // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers.delete(fn);
        };
    };
    var updateState = // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $be547bb6c77acdb8$var$_extends({}, state, newState);
        subscribers.forEach(function(subscriber) {
            return subscriber(state);
        });
    };
    var completeNavigation = // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && $be547bb6c77acdb8$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        var loaderData = newState.loaderData ? $be547bb6c77acdb8$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, $be547bb6c77acdb8$export$386d57f03f0b2883);
            });
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $be547bb6c77acdb8$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $be547bb6c77acdb8$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $be547bb6c77acdb8$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $be547bb6c77acdb8$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        updateState($be547bb6c77acdb8$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $be547bb6c77acdb8$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }));
        // Reset stateful navigation vars
        pendingAction = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    };
    var revalidate = // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    };
    var getFetcher = function getFetcher(key) {
        return state.fetchers.get(key) || $be547bb6c77acdb8$export$52eace9c284d3585;
    };
    var fetch = // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var normalizedPath = $be547bb6c77acdb8$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        var matches = $be547bb6c77acdb8$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $be547bb6c77acdb8$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        var _normalizeNavigateOptions = $be547bb6c77acdb8$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        var match = $be547bb6c77acdb8$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $be547bb6c77acdb8$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    };
    var interruptActiveLoads = function interruptActiveLoads() {
        var // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        _cancelledDeferredRoutes;
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        (_cancelledDeferredRoutes = cancelledDeferredRoutes).push.apply(_cancelledDeferredRoutes, (0, $1d041ee89e51af1b$export$1b5e630bc3aea29f)(cancelActiveDeferreds()));
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    };
    var setFetcherError = function setFetcherError(key, routeId, error) {
        var boundaryMatch = $be547bb6c77acdb8$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, $51fbb26672273063$export$1e71eb4bef00f6b0)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        });
    };
    var deleteFetcher = function deleteFetcher(key) {
        var fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    };
    var abortFetcher = function abortFetcher(key) {
        var controller = fetchControllers.get(key);
        $be547bb6c77acdb8$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    };
    var markFetchersDone = function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = $be547bb6c77acdb8$var$getDoneFetcher(fetcher.data);
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var markFetchRedirectsDone = function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                $be547bb6c77acdb8$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    };
    var abortStaleFetchLoads = function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    $be547bb6c77acdb8$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    };
    var getBlocker = function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || $be547bb6c77acdb8$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    };
    var deleteBlocker = function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    };
    var updateBlocker = // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || $be547bb6c77acdb8$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $be547bb6c77acdb8$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    };
    var shouldBlockNavigation = function shouldBlockNavigation(_ref2) {
        var currentLocation = _ref2.currentLocation, nextLocation = _ref2.nextLocation, historyAction = _ref2.historyAction;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $be547bb6c77acdb8$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    };
    var cancelActiveDeferreds = function cancelActiveDeferreds(predicate) {
        var cancelledRouteIds = [];
        activeDeferreds.forEach(function(dfd, routeId) {
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    };
    var enableScrollRestoration = // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $be547bb6c77acdb8$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    };
    var getScrollKey = function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            var key = getScrollRestorationKey(location, matches.map(function(m) {
                return $be547bb6c77acdb8$var$createUseMatchesMatch(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    };
    var saveScrollPosition = function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    };
    var getSavedScrollPosition = function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    };
    var _internalSetRoutes = function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $be547bb6c77acdb8$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    };
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    var isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    var isServer = !isBrowser;
    $be547bb6c77acdb8$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $be547bb6c77acdb8$var$defaultMapRouteProperties;
    // Routes keyed by ID
    var manifest = {};
    // Routes in tree format for matching
    var dataRoutes = $be547bb6c77acdb8$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/";
    // Config driven behavior flags
    var future = $be547bb6c77acdb8$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    var unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    var subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    var savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    var getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    var getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = $be547bb6c77acdb8$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    var initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        var error = $be547bb6c77acdb8$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = $be547bb6c77acdb8$var$getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialMatches = matches;
        initialErrors = (0, $51fbb26672273063$export$1e71eb4bef00f6b0)({}, route.id, error);
    }
    var initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some(function(m) {
        return m.route.lazy;
    }) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some(function(m) {
        return m.route.loader;
    }) || init.hydrationData != null);
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $be547bb6c77acdb8$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    var pendingAction = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    var pendingPreventScrollReset = false;
    // AbortController for the active navigation
    var pendingNavigationController;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    var isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    var isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    var cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    var cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    var fetchControllers = new Map();
    // Track loads based on the order in which they started
    var incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    var pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    var fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    var fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    var fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    var activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    var blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    var ignoreNextHistoryUpdate = false;
    function navigate(to, opts) {
        return _navigate.apply(this, arguments);
    }
    function _navigate() {
        _navigate = // Trigger a navigation event, which can either be a numerical POP or a PUSH
        // replace with an optional submission
        (0, $baf9b2a64fedef68$export$7c398597f8905a1)(function(to, opts) {
            var normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, blockerKey;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        normalizedPath = $be547bb6c77acdb8$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
                        _normalizeNavigateOptions = $be547bb6c77acdb8$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = $be547bb6c77acdb8$var$createLocation(state.location, path, opts && opts.state);
                        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
                        // URL from window.location, so we need to encode it here so the behavior
                        // remains the same as POP and non-data-router usages.  new URL() does all
                        // the same encoding we'd get from a history.pushState/window.location read
                        // without having to touch history
                        nextLocation = $be547bb6c77acdb8$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : undefined;
                        historyAction = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Push;
                        if (userReplace === true) historyAction = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Replace;
                        else if (userReplace === false) ;
                        else if (submission != null && $be547bb6c77acdb8$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
                        // users don't have to double-click the back button to get to the prior
                        // location.  If the user redirects to a different location from the
                        // action/loader this will be ignored and the redirect will be a PUSH
                        historyAction = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Replace;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            // Put the blocker into a blocked state
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: undefined,
                                        reset: undefined,
                                        location: nextLocation
                                    });
                                    // Send the same navigation through
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, $be547bb6c77acdb8$export$386d57f03f0b2883);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _navigate.apply(this, arguments);
    }
    function startNavigation(historyAction, location, opts) {
        return _startNavigation.apply(this, arguments);
    }
    function _startNavigation() {
        _startNavigation = // Start a navigation to the given action/location.  Can optionally provide a
        // overrideNavigation which will override the normalLoad in the case of a redirect
        // navigation
        (0, $baf9b2a64fedef68$export$7c398597f8905a1)(function(historyAction, location, opts) {
            var routesToUse, loadingNavigation, matches, error, _getShortCircuitMatches, notFoundMatches, route, request, pendingActionData, pendingError, actionOutput, _ref, shortCircuited, loaderData, errors;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Abort any in-progress navigations and start a new one. Unset any ongoing
                        // uninterrupted revalidations unless told otherwise, since we want this
                        // new navigation to update history normally
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        // Save the current scroll position every time we start a new navigation,
                        // and track whether we should reset scroll on completion
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = $be547bb6c77acdb8$export$2708184779ceb39d(routesToUse, location, basename);
                        // Short circuit with a 404 on the root error boundary if we match nothing
                        if (!matches) {
                            error = $be547bb6c77acdb8$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches = $be547bb6c77acdb8$var$getShortCircuitMatches(routesToUse), notFoundMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            // Cancel all pending deferred on 404s since we don't keep any routes
                            cancelActiveDeferreds();
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $51fbb26672273063$export$1e71eb4bef00f6b0)({}, route.id, error)
                            });
                            return [
                                2
                            ];
                        }
                        // Short circuit if it's only a hash change and not a revalidation or
                        // mutation submission.
                        //
                        // Ignore on initial page loads because since the initial load will always
                        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
                        // which will default to a navigation to /page
                        if (state.initialized && !isRevalidationRequired && $be547bb6c77acdb8$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $be547bb6c77acdb8$var$isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            });
                            return [
                                2
                            ];
                        }
                        // Create a controller/Request for this navigation
                        pendingNavigationController = new AbortController();
                        request = $be547bb6c77acdb8$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!(opts && opts.pendingError)) return [
                            3,
                            1
                        ];
                        // If we have a pendingError, it means the user attempted a GET submission
                        // with binary FormData so assign here and skip to handleLoaders.  That
                        // way we handle calling loaders above the boundary etc.  It's not really
                        // different from an actionError in that sense.
                        pendingError = (0, $51fbb26672273063$export$1e71eb4bef00f6b0)({}, $be547bb6c77acdb8$var$findNearestBoundary(matches).route.id, opts.pendingError);
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(opts && opts.submission && $be547bb6c77acdb8$var$isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, {
                                replace: opts.replace
                            })
                        ];
                    case 2:
                        actionOutput = _state.sent();
                        if (actionOutput.shortCircuited) return [
                            2
                        ];
                        pendingActionData = actionOutput.pendingActionData;
                        pendingError = actionOutput.pendingActionError;
                        loadingNavigation = $be547bb6c77acdb8$var$getLoadingNavigation(location, opts.submission);
                        // Create a GET request for the loaders
                        request = new Request(request.url, {
                            signal: request.signal
                        });
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError)
                        ];
                    case 4:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                        // Clean up now that the action/loaders have completed.  Don't clean up if
                        // we short circuited because pendingNavigationController will have already
                        // been assigned to a new controller for the next navigation
                        pendingNavigationController = null;
                        completeNavigation(location, $be547bb6c77acdb8$var$_extends({
                            matches: matches
                        }, pendingActionData ? {
                            actionData: pendingActionData
                        } : {}, {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return _startNavigation.apply(this, arguments);
    }
    function handleAction(request, location, submission, matches, opts) {
        return _handleAction.apply(this, arguments);
    }
    function _handleAction() {
        _handleAction = // Call the action matched by the leaf route for this navigation and handle
        // redirects/errors
        (0, $baf9b2a64fedef68$export$7c398597f8905a1)(function(request, location, submission, matches, opts) {
            var navigation, result, actionMatch, replace, boundaryMatch;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (opts === void 0) opts = {};
                        interruptActiveLoads();
                        navigation = $be547bb6c77acdb8$var$getSubmittingNavigation(location, submission);
                        updateState({
                            navigation: navigation
                        });
                        actionMatch = $be547bb6c77acdb8$var$getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        result = {
                            type: $be547bb6c77acdb8$var$ResultType.error,
                            error: $be547bb6c77acdb8$var$getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            $be547bb6c77acdb8$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename)
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 3;
                    case 3:
                        if (!$be547bb6c77acdb8$var$isRedirectResult(result)) return [
                            3,
                            5
                        ];
                        if (opts && opts.replace != null) replace = opts.replace;
                        else // If the user didn't explicity indicate replace behavior, replace if
                        // we redirected to the exact same location we're currently at to avoid
                        // double back-buttons
                        replace = result.location === state.location.pathname + state.location.search;
                        return [
                            4,
                            startRedirectNavigation(state, result, {
                                submission: submission,
                                replace: replace
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        if ($be547bb6c77acdb8$var$isErrorResult(result)) {
                            boundaryMatch = $be547bb6c77acdb8$var$findNearestBoundary(matches, actionMatch.route.id);
                            // By default, all submissions are REPLACE navigations, but if the
                            // action threw an error that'll be rendered in an errorElement, we fall
                            // back to PUSH so that the user can use the back button to get back to
                            // the pre-submission form location to try again
                            if ((opts && opts.replace) !== true) pendingAction = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Push;
                            return [
                                2,
                                {
                                    // Send back an empty object we can use to clear out any prior actionData
                                    pendingActionData: {},
                                    pendingActionError: (0, $51fbb26672273063$export$1e71eb4bef00f6b0)({}, boundaryMatch.route.id, result.error)
                                }
                            ];
                        }
                        if ($be547bb6c77acdb8$var$isDeferredResult(result)) throw $be547bb6c77acdb8$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        return [
                            2,
                            {
                                pendingActionData: (0, $51fbb26672273063$export$1e71eb4bef00f6b0)({}, actionMatch.route.id, result.data)
                            }
                        ];
                }
            });
        });
        return _handleAction.apply(this, arguments);
    }
    function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        return _handleLoaders.apply(this, arguments);
    }
    function _handleLoaders() {
        _handleLoaders = // Call all applicable loaders for the given matches, handling redirects,
        // errors, etc.
        (0, $baf9b2a64fedef68$export$7c398597f8905a1)(function(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
            var loadingNavigation, activeSubmission, routesToUse, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, updatedFetchers, actionData, abortPendingFetchRevalidations, _ref, results, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, updatedFetchers1, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        loadingNavigation = overrideNavigation || $be547bb6c77acdb8$var$getLoadingNavigation(location, submission);
                        activeSubmission = submission || fetcherSubmission || $be547bb6c77acdb8$var$getSubmissionFromNavigation(loadingNavigation);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)($be547bb6c77acdb8$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Cancel pending deferreds for no-longer-matched routes or routes we're
                        // about to reload.  Note that if this is an action reload we would have
                        // already cancelled all pending deferreds so this would be a no-op
                        cancelActiveDeferreds(function(routeId) {
                            return !(matches && matches.some(function(m) {
                                return m.route.id === routeId;
                            })) || matchesToLoad && matchesToLoad.some(function(m) {
                                return m.route.id === routeId;
                            });
                        });
                        pendingNavigationLoadId = ++incrementingLoadId;
                        // Short circuit if we have no loaders to run
                        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
                            updatedFetchers = markFetchRedirectsDone();
                            completeNavigation(location, $be547bb6c77acdb8$var$_extends({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingError || null
                            }, pendingActionData ? {
                                actionData: pendingActionData
                            } : {}, updatedFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {}));
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        // If this is an uninterrupted revalidation, we remain in our current idle
                        // state.  If not, we need to switch to our loading state and load data,
                        // preserving any new action data or existing action data (in the case of
                        // a revalidation interrupting an actionReload)
                        if (!isUninterruptedRevalidation) {
                            revalidatingFetchers.forEach(function(rf) {
                                var fetcher = state.fetchers.get(rf.key);
                                var revalidatingFetcher = $be547bb6c77acdb8$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                                state.fetchers.set(rf.key, revalidatingFetcher);
                            });
                            actionData = pendingActionData || state.actionData;
                            updateState($be547bb6c77acdb8$var$_extends({
                                navigation: loadingNavigation
                            }, actionData ? Object.keys(actionData).length === 0 ? {
                                actionData: null
                            } : {
                                actionData: actionData
                            } : {}, revalidatingFetchers.length > 0 ? {
                                fetchers: new Map(state.fetchers)
                            } : {}));
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
                            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
                            // (via deleteFetcher) does not abort the triggering navigation that
                            // triggered the revalidation
                            fetchControllers.set(rf.key, rf.controller);
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request)
                        ];
                    case 1:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        // Clean up _after_ loaders have completed.  Don't clean up if we short
                        // circuited because fetchControllers would have been aborted and
                        // reassigned to new controllers for the next navigation
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        });
                        redirect = $be547bb6c77acdb8$var$findRedirect(results);
                        if (!redirect) return [
                            3,
                            3
                        ];
                        if (redirect.idx >= matchesToLoad.length) {
                            fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                            fetchRedirectIds.add(fetcherKey);
                        }
                        return [
                            4,
                            startRedirectNavigation(state, redirect.result, {
                                replace: replace
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 3:
                        _processLoaderData = $be547bb6c77acdb8$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Wire up subscribers to update loaderData as promises settle
                        activeDeferreds.forEach(function(deferredData, routeId) {
                            deferredData.subscribe(function(aborted) {
                                // Note: No need to updateState here since the TrackedPromise on
                                // loaderData is stable across resolve/reject
                                // Remove this instance if we were aborted or if promises have settled
                                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
                            });
                        });
                        updatedFetchers1 = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers1 || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            $be547bb6c77acdb8$var$_extends({
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        });
        return _handleLoaders.apply(this, arguments);
    }
    function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        return _handleFetcherAction.apply(this, arguments);
    }
    function _handleFetcherAction() {
        _handleFetcherAction = // Call the action for the matched fetcher.submit(), and then handle redirects,
        // errors, and revalidation
        (0, $baf9b2a64fedef68$export$7c398597f8905a1)(function(key, routeId, path, match, requestMatches, submission) {
            var error, existingFetcher, fetcher, abortController, fetchRequest, originatingLoadId, actionResult, doneFetcher, loadingFetcher, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, abortPendingFetchRevalidations, _ref, results, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, doneFetcher1, didAbortFetchLoads;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        if (!match.route.action && !match.route.lazy) {
                            error = $be547bb6c77acdb8$var$getInternalRouterError(405, {
                                method: submission.formMethod,
                                pathname: path,
                                routeId: routeId
                            });
                            setFetcherError(key, routeId, error);
                            return [
                                2
                            ];
                        }
                        existingFetcher = state.fetchers.get(key);
                        fetcher = $be547bb6c77acdb8$var$getSubmittingFetcher(submission, existingFetcher);
                        state.fetchers.set(key, fetcher);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortController = new AbortController();
                        fetchRequest = $be547bb6c77acdb8$var$createClientSideRequest(init.history, path, abortController.signal, submission);
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            $be547bb6c77acdb8$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename)
                        ];
                    case 1:
                        actionResult = _state.sent();
                        if (fetchRequest.signal.aborted) {
                            // We can delete this so long as we weren't aborted by ou our own fetcher
                            // re-submit which would have put _new_ controller is in fetchControllers
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        if ($be547bb6c77acdb8$var$isRedirectResult(actionResult)) {
                            fetchControllers.delete(key);
                            if (pendingNavigationLoadId > originatingLoadId) {
                                doneFetcher = $be547bb6c77acdb8$var$getDoneFetcher(undefined);
                                state.fetchers.set(key, doneFetcher);
                                updateState({
                                    fetchers: new Map(state.fetchers)
                                });
                                return [
                                    2
                                ];
                            } else {
                                fetchRedirectIds.add(key);
                                loadingFetcher = $be547bb6c77acdb8$var$getLoadingFetcher(submission);
                                state.fetchers.set(key, loadingFetcher);
                                updateState({
                                    fetchers: new Map(state.fetchers)
                                });
                                return [
                                    2,
                                    startRedirectNavigation(state, actionResult, {
                                        submission: submission,
                                        isFetchActionRedirect: true
                                    })
                                ];
                            }
                        }
                        // Process any non-redirect errors thrown
                        if ($be547bb6c77acdb8$var$isErrorResult(actionResult)) {
                            setFetcherError(key, routeId, actionResult.error);
                            return [
                                2
                            ];
                        }
                        if ($be547bb6c77acdb8$var$isDeferredResult(actionResult)) throw $be547bb6c77acdb8$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = $be547bb6c77acdb8$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? $be547bb6c77acdb8$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
                        $be547bb6c77acdb8$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = $be547bb6c77acdb8$var$getLoadingFetcher(submission, actionResult.data);
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)($be547bb6c77acdb8$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, (0, $51fbb26672273063$export$1e71eb4bef00f6b0)({}, match.route.id, actionResult.data), undefined // No need to send through errors since we short circuit above
                        ), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Put all revalidating fetchers into the loading state, except for the
                        // current fetcher which we want to keep in it's current loading state which
                        // contains it's action submission info + action data
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher = state.fetchers.get(staleKey);
                            var revalidatingFetcher = $be547bb6c77acdb8$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest)
                        ];
                    case 2:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        redirect = $be547bb6c77acdb8$var$findRedirect(results);
                        if (redirect) {
                            if (redirect.idx >= matchesToLoad.length) {
                                fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                                fetchRedirectIds.add(fetcherKey);
                            }
                            return [
                                2,
                                startRedirectNavigation(state, redirect.result)
                            ];
                        }
                        _processLoaderData = $be547bb6c77acdb8$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Since we let revalidations complete even if the submitting fetcher was
                        // deleted, only put it back to idle if it hasn't been deleted
                        if (state.fetchers.has(key)) {
                            doneFetcher1 = $be547bb6c77acdb8$var$getDoneFetcher(actionResult.data);
                            state.fetchers.set(key, doneFetcher1);
                        }
                        didAbortFetchLoads = abortStaleFetchLoads(loadId);
                        // If we are currently in a navigation loading state and this fetcher is
                        // more recent than the navigation, we want the newer data so abort the
                        // navigation and complete it with the fetcher data
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            $be547bb6c77acdb8$export$3e9cee6b33872309(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            // otherwise just update with the fetcher data, preserving any existing
                            // loaderData for loaders that did not need to reload.  We have to
                            // manually merge here since we aren't going through completeNavigation
                            updateState($be547bb6c77acdb8$var$_extends({
                                errors: errors,
                                loaderData: $be547bb6c77acdb8$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
                            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                                fetchers: new Map(state.fetchers)
                            } : {}));
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherAction.apply(this, arguments);
    }
    function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        return _handleFetcherLoader.apply(this, arguments);
    }
    function _handleFetcherLoader() {
        _handleFetcherLoader = // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
        (0, $baf9b2a64fedef68$export$7c398597f8905a1)(function(key, routeId, path, match, matches, submission) {
            var existingFetcher, loadingFetcher, abortController, fetchRequest, originatingLoadId, result, doneFetcher, boundaryMatch, doneFetcher1;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        loadingFetcher = $be547bb6c77acdb8$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
                        state.fetchers.set(key, loadingFetcher);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortController = new AbortController();
                        fetchRequest = $be547bb6c77acdb8$var$createClientSideRequest(init.history, path, abortController.signal);
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            $be547bb6c77acdb8$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename)
                        ];
                    case 1:
                        result = _state.sent();
                        if (!$be547bb6c77acdb8$var$isDeferredResult(result)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            $be547bb6c77acdb8$var$resolveDeferredData(result, fetchRequest.signal, true)
                        ];
                    case 2:
                        result = _state.sent() || result;
                        _state.label = 3;
                    case 3:
                        // We can delete this so long as we weren't aborted by our our own fetcher
                        // re-load which would have put _new_ controller is in fetchControllers
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        if (!$be547bb6c77acdb8$var$isRedirectResult(result)) return [
                            3,
                            6
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            4
                        ];
                        doneFetcher = $be547bb6c77acdb8$var$getDoneFetcher(undefined);
                        state.fetchers.set(key, doneFetcher);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        return [
                            2
                        ];
                    case 4:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(state, result)
                        ];
                    case 5:
                        _state.sent();
                        return [
                            2
                        ];
                    case 6:
                        // Process any non-redirect errors thrown
                        if ($be547bb6c77acdb8$var$isErrorResult(result)) {
                            boundaryMatch = $be547bb6c77acdb8$var$findNearestBoundary(state.matches, routeId);
                            state.fetchers.delete(key);
                            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
                            // do we need to behave any differently with our non-redirect errors?
                            // What if it was a non-redirect Response?
                            updateState({
                                fetchers: new Map(state.fetchers),
                                errors: (0, $51fbb26672273063$export$1e71eb4bef00f6b0)({}, boundaryMatch.route.id, result.error)
                            });
                            return [
                                2
                            ];
                        }
                        $be547bb6c77acdb8$export$3e9cee6b33872309(!$be547bb6c77acdb8$var$isDeferredResult(result), "Unhandled fetcher deferred data");
                        doneFetcher1 = $be547bb6c77acdb8$var$getDoneFetcher(result.data);
                        state.fetchers.set(key, doneFetcher1);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherLoader.apply(this, arguments);
    }
    function startRedirectNavigation(state, redirect, _temp) {
        return _startRedirectNavigation.apply(this, arguments);
    }
    function _startRedirectNavigation() {
        _startRedirectNavigation = /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ (0, $baf9b2a64fedef68$export$7c398597f8905a1)(function(state, redirect, _temp) {
            var _ref, submission, replace, isFetchActionRedirect, redirectLocation, isDocumentReload, url, redirectHistoryAction, activeSubmission, overrideNavigation;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp === void 0 ? {} : _temp, submission = _ref.submission, replace = _ref.replace, isFetchActionRedirect = _ref.isFetchActionRedirect;
                        if (redirect.revalidate) isRevalidationRequired = true;
                        redirectLocation = $be547bb6c77acdb8$var$createLocation(state.location, redirect.location, $be547bb6c77acdb8$var$_extends({
                            _isRedirect: true
                        }, isFetchActionRedirect ? {
                            _isFetchActionRedirect: true
                        } : {}));
                        $be547bb6c77acdb8$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
                        if (isBrowser) {
                            isDocumentReload = false;
                            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
                            isDocumentReload = true;
                            else if ($be547bb6c77acdb8$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                                url = init.history.createURL(redirect.location);
                                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                                $be547bb6c77acdb8$export$b69e3301ce081aa3(url.pathname, basename) == null;
                            }
                            if (isDocumentReload) {
                                if (replace) routerWindow.location.replace(redirect.location);
                                else routerWindow.location.assign(redirect.location);
                                return [
                                    2
                                ];
                            }
                        }
                        // There's no need to abort on redirects, since we don't detect the
                        // redirect until the action/loaders have settled
                        pendingNavigationController = null;
                        redirectHistoryAction = replace === true ? $be547bb6c77acdb8$export$e19cd5f9376f8cee.Replace : $be547bb6c77acdb8$export$e19cd5f9376f8cee.Push;
                        activeSubmission = submission || $be547bb6c77acdb8$var$getSubmissionFromNavigation(state.navigation);
                        if (!($be547bb6c77acdb8$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $be547bb6c77acdb8$var$isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                submission: $be547bb6c77acdb8$var$_extends({}, activeSubmission, {
                                    formAction: redirect.location
                                }),
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 2:
                        if (!isFetchActionRedirect) return [
                            3,
                            4
                        ];
                        // For a fetch action redirect, we kick off a new loading navigation
                        // without the fetcher submission, but we send it along for shouldRevalidate
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: $be547bb6c77acdb8$var$getLoadingNavigation(redirectLocation),
                                fetcherSubmission: activeSubmission,
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        overrideNavigation = $be547bb6c77acdb8$var$getLoadingNavigation(redirectLocation, activeSubmission);
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _startRedirectNavigation.apply(this, arguments);
    }
    function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function _callLoadersAndMaybeResolveData() {
        _callLoadersAndMaybeResolveData = (0, $baf9b2a64fedef68$export$7c398597f8905a1)(function(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
            var results, loaderResults, fetcherResults;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all((0, $1d041ee89e51af1b$export$1b5e630bc3aea29f)(matchesToLoad.map(function(match) {
                                return $be547bb6c77acdb8$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename);
                            })).concat((0, $1d041ee89e51af1b$export$1b5e630bc3aea29f)(fetchersToLoad.map(function(f) {
                                if (f.matches && f.match && f.controller) return $be547bb6c77acdb8$var$callLoaderOrAction("loader", $be547bb6c77acdb8$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                                else {
                                    var error = {
                                        type: $be547bb6c77acdb8$var$ResultType.error,
                                        error: $be547bb6c77acdb8$var$getInternalRouterError(404, {
                                            pathname: f.path
                                        })
                                    };
                                    return error;
                                }
                            }))))
                        ];
                    case 1:
                        results = _state.sent();
                        loaderResults = results.slice(0, matchesToLoad.length);
                        fetcherResults = results.slice(matchesToLoad.length);
                        return [
                            4,
                            Promise.all([
                                $be547bb6c77acdb8$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(function() {
                                    return request.signal;
                                }), false, state.loaderData),
                                $be547bb6c77acdb8$var$resolveDeferredResults(currentMatches, fetchersToLoad.map(function(f) {
                                    return f.match;
                                }), fetcherResults, fetchersToLoad.map(function(f) {
                                    return f.controller ? f.controller.signal : null;
                                }), true)
                            ])
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                results: results,
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        });
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
var $be547bb6c77acdb8$export$4d0306f8f6a4585b = Symbol("deferred");
function $be547bb6c77acdb8$export$3336b097a6fbc59a(routes, opts) {
    $be547bb6c77acdb8$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $be547bb6c77acdb8$var$defaultMapRouteProperties;
    var dataRoutes = $be547bb6c77acdb8$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    function query(request, _temp2) {
        return _query.apply(this, arguments);
    }
    function _query() {
        _query = /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ (0, $baf9b2a64fedef68$export$7c398597f8905a1)(function(request, _temp2) {
            var requestContext, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, error1, _getShortCircuitMatches1, notFoundMatches, route1, result;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        requestContext = (_temp2 === void 0 ? {} : _temp2).requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = $be547bb6c77acdb8$var$createLocation("", $be547bb6c77acdb8$export$fe53371bee54353d(url), null, "default");
                        matches = $be547bb6c77acdb8$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$be547bb6c77acdb8$var$isValidMethod(method) && method !== "HEAD") {
                            error = $be547bb6c77acdb8$var$getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = $be547bb6c77acdb8$var$getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: methodNotAllowedMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $51fbb26672273063$export$1e71eb4bef00f6b0)({}, route.id, error),
                                    statusCode: error.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        } else if (!matches) {
                            error1 = $be547bb6c77acdb8$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = $be547bb6c77acdb8$var$getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $51fbb26672273063$export$1e71eb4bef00f6b0)({}, route1.id, error1),
                                    statusCode: error1.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($be547bb6c77acdb8$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        // When returning StaticHandlerContext, we patch back in the location here
                        // since we need it for React Context.  But this helps keep our submit and
                        // loadRouteData operating on a Request instead of a Location
                        return [
                            2,
                            $be547bb6c77acdb8$var$_extends({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        });
        return _query.apply(this, arguments);
    }
    function queryRoute(request, _temp3) {
        return _queryRoute.apply(this, arguments);
    }
    function _queryRoute() {
        _queryRoute = /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ (0, $baf9b2a64fedef68$export$7c398597f8905a1)(function(request, _temp3) {
            var _ref, routeId, requestContext, url, method, location, matches, match, result, error, _result$activeDeferre, data;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp3 === void 0 ? {} : _temp3, routeId = _ref.routeId, requestContext = _ref.requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = $be547bb6c77acdb8$var$createLocation("", $be547bb6c77acdb8$export$fe53371bee54353d(url), null, "default");
                        matches = $be547bb6c77acdb8$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$be547bb6c77acdb8$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $be547bb6c77acdb8$var$getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw $be547bb6c77acdb8$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : $be547bb6c77acdb8$var$getTargetMatch(matches, location);
                        if (routeId && !match) throw $be547bb6c77acdb8$var$getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) // This should never hit I don't think?
                        throw $be547bb6c77acdb8$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, match)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($be547bb6c77acdb8$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        error = result.errors ? Object.values(result.errors)[0] : undefined;
                        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
                        // _something_ that wasn't a Response, but it's not guaranteed/required
                        // to be an `instanceof Error` either, so we have to use throw here to
                        // preserve the "error" state outside of queryImpl.
                        throw error;
                        // Pick off the right state value to return
                        if (result.actionData) return [
                            2,
                            Object.values(result.actionData)[0]
                        ];
                        if (result.loaderData) {
                            ;
                            data = Object.values(result.loaderData)[0];
                            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$be547bb6c77acdb8$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
                            return [
                                2,
                                data
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
        return _queryRoute.apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, routeMatch) {
        return _queryImpl.apply(this, arguments);
    }
    function _queryImpl() {
        _queryImpl = (0, $baf9b2a64fedef68$export$7c398597f8905a1)(function(request, location, matches, requestContext, routeMatch) {
            var result, result1, e;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $be547bb6c77acdb8$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!$be547bb6c77acdb8$var$isMutationMethod(request.method.toLowerCase())) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || $be547bb6c77acdb8$var$getTargetMatch(matches, location), requestContext, routeMatch != null)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, routeMatch)
                        ];
                    case 4:
                        result1 = _state.sent();
                        return [
                            2,
                            $be547bb6c77acdb8$var$isResponse(result1) ? result1 : $be547bb6c77acdb8$var$_extends({}, result1, {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        // If the user threw/returned a Response in callLoaderOrAction, we throw
                        // it to bail out and then return or throw here based on whether the user
                        // returned or threw
                        if ($be547bb6c77acdb8$var$isQueryRouteResponse(e)) {
                            if (e.type === $be547bb6c77acdb8$var$ResultType.error) throw e.response;
                            return [
                                2,
                                e.response
                            ];
                        }
                        // Redirects are always returned since they don't propagate to catch
                        // boundaries
                        if ($be547bb6c77acdb8$var$isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _queryImpl.apply(this, arguments);
    }
    function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0, $baf9b2a64fedef68$export$7c398597f8905a1)(function(request, matches, actionMatch, requestContext, isRouteRequest) {
            var result, error, method, error1, boundaryMatch, context, loaderRequest, context1;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = $be547bb6c77acdb8$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: $be547bb6c77acdb8$var$ResultType.error,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            $be547bb6c77acdb8$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                                isStaticRequest: true,
                                isRouteRequest: isRouteRequest,
                                requestContext: requestContext
                            })
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) {
                            method = isRouteRequest ? "queryRoute" : "query";
                            throw new Error(method + "() call aborted");
                        }
                        _state.label = 3;
                    case 3:
                        if ($be547bb6c77acdb8$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
                        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
                        // can get back on the "throw all redirect responses" train here should
                        // this ever happen :/
                        throw new Response(null, {
                            status: result.status,
                            headers: {
                                Location: result.location
                            }
                        });
                        if ($be547bb6c77acdb8$var$isDeferredResult(result)) {
                            error1 = $be547bb6c77acdb8$var$getInternalRouterError(400, {
                                type: "defer-action"
                            });
                            if (isRouteRequest) throw error1;
                            result = {
                                type: $be547bb6c77acdb8$var$ResultType.error,
                                error: error1
                            };
                        }
                        if (isRouteRequest) {
                            // Note: This should only be non-Response values if we get here, since
                            // isRouteRequest should throw any Response received in callLoaderOrAction
                            if ($be547bb6c77acdb8$var$isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $51fbb26672273063$export$1e71eb4bef00f6b0)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        if (!$be547bb6c77acdb8$var$isErrorResult(result)) return [
                            3,
                            5
                        ];
                        boundaryMatch = $be547bb6c77acdb8$var$findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, undefined, (0, $51fbb26672273063$export$1e71eb4bef00f6b0)({}, boundaryMatch.route.id, result.error))
                        ];
                    case 4:
                        context = _state.sent();
                        // action status codes take precedence over loader status codes
                        return [
                            2,
                            $be547bb6c77acdb8$var$_extends({}, context, {
                                statusCode: $be547bb6c77acdb8$export$972111febbeef05b(result.error) ? result.error.status : 500,
                                actionData: null,
                                actionHeaders: $be547bb6c77acdb8$var$_extends({}, result.headers ? (0, $51fbb26672273063$export$1e71eb4bef00f6b0)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext)
                        ];
                    case 6:
                        context1 = _state.sent();
                        return [
                            2,
                            $be547bb6c77acdb8$var$_extends({}, context1, result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}, {
                                actionData: (0, $51fbb26672273063$export$1e71eb4bef00f6b0)({}, actionMatch.route.id, result.data),
                                actionHeaders: $be547bb6c77acdb8$var$_extends({}, result.headers ? (0, $51fbb26672273063$export$1e71eb4bef00f6b0)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                }
            });
        });
        return _submit.apply(this, arguments);
    }
    function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        return _loadRouteData.apply(this, arguments);
    }
    function _loadRouteData() {
        _loadRouteData = (0, $baf9b2a64fedef68$export$7c398597f8905a1)(function(request, matches, requestContext, routeMatch, pendingActionError) {
            var isRouteRequest, requestMatches, matchesToLoad, results, method, activeDeferreds, context, executedLoaders;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        // Short circuit if we have no loaders to run (queryRoute())
                        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $be547bb6c77acdb8$var$getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch == null ? void 0 : routeMatch.route.id
                        });
                        requestMatches = routeMatch ? [
                            routeMatch
                        ] : $be547bb6c77acdb8$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
                        matchesToLoad = requestMatches.filter(function(m) {
                            return m.route.loader || m.route.lazy;
                        });
                        // Short circuit if we have no loaders to run (query())
                        if (matchesToLoad.length === 0) return [
                            2,
                            {
                                matches: matches,
                                // Add a null for all matched routes for proper revalidation on the client
                                loaderData: matches.reduce(function(acc, m) {
                                    return Object.assign(acc, (0, $51fbb26672273063$export$1e71eb4bef00f6b0)({}, m.route.id, null));
                                }, {}),
                                errors: pendingActionError || null,
                                statusCode: 200,
                                loaderHeaders: {},
                                activeDeferreds: null
                            }
                        ];
                        return [
                            4,
                            Promise.all((0, $1d041ee89e51af1b$export$1b5e630bc3aea29f)(matchesToLoad.map(function(match) {
                                return $be547bb6c77acdb8$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                                    isStaticRequest: true,
                                    isRouteRequest: isRouteRequest,
                                    requestContext: requestContext
                                });
                            })))
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) {
                            method = isRouteRequest ? "queryRoute" : "query";
                            throw new Error(method + "() call aborted");
                        }
                        activeDeferreds = new Map();
                        context = $be547bb6c77acdb8$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
                        executedLoaders = new Set(matchesToLoad.map(function(match) {
                            return match.route.id;
                        }));
                        matches.forEach(function(match) {
                            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
                        });
                        return [
                            2,
                            $be547bb6c77acdb8$var$_extends({}, context, {
                                matches: matches,
                                activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
                            })
                        ];
                }
            });
        });
        return _loadRouteData.apply(this, arguments);
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $be547bb6c77acdb8$export$fec11da027c70692(routes, context, error) {
    var newContext = $be547bb6c77acdb8$var$_extends({}, context, {
        statusCode: 500,
        errors: (0, $51fbb26672273063$export$1e71eb4bef00f6b0)({}, context._deepestRenderedBoundaryId || routes[0].id, error)
    });
    return newContext;
}
function $be547bb6c77acdb8$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $be547bb6c77acdb8$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    var path = $be547bb6c77acdb8$export$cae722b0cc860f13(to ? to : ".", $be547bb6c77acdb8$export$90ba53ce1c7fdff2(contextualMatches).map(function(m) {
        return m.pathnameBase;
    }), $be547bb6c77acdb8$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$be547bb6c77acdb8$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $be547bb6c77acdb8$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $be547bb6c77acdb8$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $be547bb6c77acdb8$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$be547bb6c77acdb8$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$be547bb6c77acdb8$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $be547bb6c77acdb8$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: $be547bb6c77acdb8$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    // Create a Submission on non-GET navigations
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    var formAction = $be547bb6c77acdb8$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$be547bb6c77acdb8$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, _ref3) {
                var _$_ref3 = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)(_ref3, 2), name = _$_ref3[0], value = _$_ref3[1];
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$be547bb6c77acdb8$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $be547bb6c77acdb8$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = $be547bb6c77acdb8$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $be547bb6c77acdb8$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $be547bb6c77acdb8$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $be547bb6c77acdb8$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($be547bb6c77acdb8$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    var parsedPath = $be547bb6c77acdb8$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $be547bb6c77acdb8$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $be547bb6c77acdb8$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $be547bb6c77acdb8$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    var boundaryMatches = matches;
    if (boundaryId) {
        var index = matches.findIndex(function(m) {
            return m.route.id === boundaryId;
        });
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $be547bb6c77acdb8$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    var actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    var boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    var boundaryMatches = $be547bb6c77acdb8$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    var navigationMatches = boundaryMatches.filter(function(match, index) {
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($be547bb6c77acdb8$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some(function(id) {
            return id === match.route.id;
        })) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        var currentRouteMatch = state.matches[index];
        var nextRouteMatch = match;
        return $be547bb6c77acdb8$var$shouldRevalidateLoader(match, $be547bb6c77acdb8$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $be547bb6c77acdb8$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some(function(m) {
            return m.route.id === f.routeId;
        })) return;
        var fetcherMatches = $be547bb6c77acdb8$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        var fetcher = state.fetchers.get(key);
        var fetcherMatch = $be547bb6c77acdb8$var$getTargetMatch(fetcherMatches, f.path);
        var shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $be547bb6c77acdb8$var$shouldRevalidateLoader(fetcherMatch, $be547bb6c77acdb8$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $be547bb6c77acdb8$var$isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    var isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $be547bb6c77acdb8$var$isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $be547bb6c77acdb8$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $be547bb6c77acdb8$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    return $be547bb6c77acdb8$var$_loadLazyRouteModule.apply(this, arguments);
}
function $be547bb6c77acdb8$var$_loadLazyRouteModule() {
    $be547bb6c77acdb8$var$_loadLazyRouteModule = /**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ (0, $baf9b2a64fedef68$export$7c398597f8905a1)(function(route, mapRouteProperties, manifest) {
        var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
        return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.lazy) return [
                        2
                    ];
                    return [
                        4,
                        route.lazy()
                    ];
                case 1:
                    lazyRoute = _state.sent();
                    // If the lazy route function was executed and removed by another parallel
                    // call then we can return - first lazy() to finish wins because the return
                    // value of lazy is expected to be static
                    if (!route.lazy) return [
                        2
                    ];
                    routeToUpdate = manifest[route.id];
                    $be547bb6c77acdb8$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
                    routeUpdates = {};
                    for(var lazyRouteProperty in lazyRoute){
                        staticRouteValue = routeToUpdate[lazyRouteProperty];
                        isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
                        // on the route updates
                        lazyRouteProperty !== "hasErrorBoundary";
                        $be547bb6c77acdb8$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
                        if (!isPropertyStaticallyDefined && !$be547bb6c77acdb8$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
                    }
                    // Mutate the route with the provided updates.  Do this first so we pass
                    // the updated version to mapRouteProperties
                    Object.assign(routeToUpdate, routeUpdates);
                    // Mutate the `hasErrorBoundary` property on the route based on the route
                    // updates and remove the `lazy` function so we don't resolve the lazy
                    // route again.
                    Object.assign(routeToUpdate, $be547bb6c77acdb8$var$_extends({}, mapRouteProperties(routeToUpdate), {
                        lazy: undefined
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return $be547bb6c77acdb8$var$_loadLazyRouteModule.apply(this, arguments);
}
function $be547bb6c77acdb8$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    return $be547bb6c77acdb8$var$_callLoaderOrAction.apply(this, arguments);
}
function $be547bb6c77acdb8$var$_callLoaderOrAction() {
    $be547bb6c77acdb8$var$_callLoaderOrAction = (0, $baf9b2a64fedef68$export$7c398597f8905a1)(function(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
        var resultType, result, onReject, runHandler, handler, values, url, pathname, url1, pathname1, e, status, location, currentUrl, url2, isSameBasename, queryRouteResponse, data, contentType, _result$init, _result$init2;
        return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (opts === void 0) opts = {};
                    runHandler = function(handler) {
                        // Setup a promise we can race against so that abort signals short circuit
                        var reject;
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        return Promise.race([
                            handler({
                                request: request,
                                params: match.params,
                                context: opts.requestContext
                            }),
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = match.route[type];
                    if (!match.route.lazy) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            runHandler(handler),
                            $be547bb6c77acdb8$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                        ])
                    ];
                case 2:
                    values = _state.sent();
                    result = values[0];
                    return [
                        3,
                        7
                    ];
                case 3:
                    // Load lazy route module, then run any returned handler
                    return [
                        4,
                        $be547bb6c77acdb8$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                    ];
                case 4:
                    _state.sent();
                    handler = match.route[type];
                    if (!handler) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 5:
                    // Handler still run even if we got interrupted to maintain consistency
                    // with un-abortable behavior of handler execution on non-lazy or
                    // previously-lazy-loaded routes
                    result = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw $be547bb6c77acdb8$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else // lazy() route has no loader to run.  Short circuit here so we don't
                    // hit the invariant below that errors on returning undefined.
                    return [
                        2,
                        {
                            type: $be547bb6c77acdb8$var$ResultType.data,
                            data: undefined
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw $be547bb6c77acdb8$var$getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    $be547bb6c77acdb8$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    resultType = $be547bb6c77acdb8$var$ResultType.error;
                    result = e;
                    return [
                        3,
                        14
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    if (!$be547bb6c77acdb8$var$isResponse(result)) return [
                        3,
                        19
                    ];
                    status = result.status;
                    // Process redirects
                    if ($be547bb6c77acdb8$var$redirectStatusCodes.has(status)) {
                        location = result.headers.get("Location");
                        $be547bb6c77acdb8$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
                        // Support relative routing in internal redirects
                        if (!$be547bb6c77acdb8$var$ABSOLUTE_URL_REGEX.test(location)) location = $be547bb6c77acdb8$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
                        else if (!opts.isStaticRequest) {
                            currentUrl = new URL(request.url);
                            url2 = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                            isSameBasename = $be547bb6c77acdb8$export$b69e3301ce081aa3(url2.pathname, basename) != null;
                            if (url2.origin === currentUrl.origin && isSameBasename) location = url2.pathname + url2.search + url2.hash;
                        }
                        // Don't process redirects in the router during static requests requests.
                        // Instead, throw the Response and let the server handle it with an HTTP
                        // redirect.  We also update the Location header in place in this flow so
                        // basename and relative routing is taken into account
                        if (opts.isStaticRequest) {
                            result.headers.set("Location", location);
                            throw result;
                        }
                        return [
                            2,
                            {
                                type: $be547bb6c77acdb8$var$ResultType.redirect,
                                status: status,
                                location: location,
                                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
                            }
                        ];
                    }
                    // For SSR single-route requests, we want to hand Responses back directly
                    // without unwrapping.  We do this with the QueryRouteResponse wrapper
                    // interface so we can know whether it was returned or thrown
                    if (opts.isRouteRequest) {
                        queryRouteResponse = {
                            type: resultType === $be547bb6c77acdb8$var$ResultType.error ? $be547bb6c77acdb8$var$ResultType.error : $be547bb6c77acdb8$var$ResultType.data,
                            response: result
                        };
                        throw queryRouteResponse;
                    }
                    contentType = result.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        16
                    ];
                    return [
                        4,
                        result.json()
                    ];
                case 15:
                    data = _state.sent();
                    return [
                        3,
                        18
                    ];
                case 16:
                    return [
                        4,
                        result.text()
                    ];
                case 17:
                    data = _state.sent();
                    _state.label = 18;
                case 18:
                    if (resultType === $be547bb6c77acdb8$var$ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: new $be547bb6c77acdb8$export$acf1a680051f5031(status, result.statusText, data),
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: $be547bb6c77acdb8$var$ResultType.data,
                            data: data,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 19:
                    if (resultType === $be547bb6c77acdb8$var$ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: result
                        }
                    ];
                    if ($be547bb6c77acdb8$export$fbcedacb60443473(result)) {
                        ;
                        return [
                            2,
                            {
                                type: $be547bb6c77acdb8$var$ResultType.deferred,
                                deferredData: result,
                                statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                                headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $be547bb6c77acdb8$var$ResultType.data,
                            data: result
                        }
                    ];
            }
        });
    });
    return $be547bb6c77acdb8$var$_callLoaderOrAction.apply(this, arguments);
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $be547bb6c77acdb8$var$createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL($be547bb6c77acdb8$var$stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && $be547bb6c77acdb8$var$isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $be547bb6c77acdb8$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $be547bb6c77acdb8$var$convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function $be547bb6c77acdb8$var$convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function $be547bb6c77acdb8$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach(function(result, index) {
        var id = matchesToLoad[index].route.id;
        $be547bb6c77acdb8$export$3e9cee6b33872309(!$be547bb6c77acdb8$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($be547bb6c77acdb8$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            var boundaryMatch = $be547bb6c77acdb8$var$findNearestBoundary(matches, id);
            var error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $be547bb6c77acdb8$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($be547bb6c77acdb8$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $be547bb6c77acdb8$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    var _processRouteLoaderData = $be547bb6c77acdb8$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    // Process results from our revalidating fetchers
    for(var index = 0; index < revalidatingFetchers.length; index++){
        var _revalidatingFetchers_index = revalidatingFetchers[index], key = _revalidatingFetchers_index.key, match = _revalidatingFetchers_index.match, controller = _revalidatingFetchers_index.controller;
        $be547bb6c77acdb8$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        var result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($be547bb6c77acdb8$var$isErrorResult(result)) {
            var boundaryMatch = $be547bb6c77acdb8$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $be547bb6c77acdb8$var$_extends({}, errors, (0, $51fbb26672273063$export$1e71eb4bef00f6b0)({}, boundaryMatch.route.id, result.error));
            state.fetchers.delete(key);
        } else if ($be547bb6c77acdb8$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $be547bb6c77acdb8$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($be547bb6c77acdb8$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $be547bb6c77acdb8$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            var doneFetcher = $be547bb6c77acdb8$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $be547bb6c77acdb8$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = $be547bb6c77acdb8$var$_extends({}, newLoaderData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (newLoaderData.hasOwnProperty(id)) {
                if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
            } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
            // wasn't removed by HMR
            mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $be547bb6c77acdb8$var$findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $1d041ee89e51af1b$export$1b5e630bc3aea29f)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function $be547bb6c77acdb8$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    var route = routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $be547bb6c77acdb8$var$getInternalRouterError(status, _temp4) {
    var _ref = _temp4 === void 0 ? {} : _temp4, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $be547bb6c77acdb8$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $be547bb6c77acdb8$var$findRedirect(results) {
    for(var i = results.length - 1; i >= 0; i--){
        var result = results[i];
        if ($be547bb6c77acdb8$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $be547bb6c77acdb8$var$stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? $be547bb6c77acdb8$export$8ccf933b0513f8d0(path) : path;
    return $be547bb6c77acdb8$export$fe53371bee54353d($be547bb6c77acdb8$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $be547bb6c77acdb8$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $be547bb6c77acdb8$var$isDeferredResult(result) {
    return result.type === $be547bb6c77acdb8$var$ResultType.deferred;
}
function $be547bb6c77acdb8$var$isErrorResult(result) {
    return result.type === $be547bb6c77acdb8$var$ResultType.error;
}
function $be547bb6c77acdb8$var$isRedirectResult(result) {
    return (result && result.type) === $be547bb6c77acdb8$var$ResultType.redirect;
}
function $be547bb6c77acdb8$export$fbcedacb60443473(value) {
    var deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $be547bb6c77acdb8$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $be547bb6c77acdb8$var$isRedirectResponse(result) {
    if (!$be547bb6c77acdb8$var$isResponse(result)) return false;
    var status = result.status;
    var location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $be547bb6c77acdb8$var$isQueryRouteResponse(obj) {
    return obj && $be547bb6c77acdb8$var$isResponse(obj.response) && (obj.type === $be547bb6c77acdb8$var$ResultType.data || obj.type === $be547bb6c77acdb8$var$ResultType.error);
}
function $be547bb6c77acdb8$var$isValidMethod(method) {
    return $be547bb6c77acdb8$var$validRequestMethods.has(method.toLowerCase());
}
function $be547bb6c77acdb8$var$isMutationMethod(method) {
    return $be547bb6c77acdb8$var$validMutationMethods.has(method.toLowerCase());
}
function $be547bb6c77acdb8$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    return $be547bb6c77acdb8$var$_resolveDeferredResults.apply(this, arguments);
}
function $be547bb6c77acdb8$var$_resolveDeferredResults() {
    $be547bb6c77acdb8$var$_resolveDeferredResults = (0, $baf9b2a64fedef68$export$7c398597f8905a1)(function(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
        var _loop, index;
        return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var result, match, currentMatch, isRevalidatingLoader, signal;
                        return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    result = results[index];
                                    match = matchesToLoad[index];
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    currentMatch = currentMatches.find(function(m) {
                                        return m.route.id === match.route.id;
                                    });
                                    isRevalidatingLoader = currentMatch != null && !$be547bb6c77acdb8$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
                                    if (!($be547bb6c77acdb8$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader))) return [
                                        3,
                                        2
                                    ];
                                    signal = signals[index];
                                    $be547bb6c77acdb8$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
                                    return [
                                        4,
                                        $be547bb6c77acdb8$var$resolveDeferredData(result, signal, isFetcher).then(function(result) {
                                            if (result) results[index] = result || results[index];
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < results.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $b8c3f91e5973f862$export$19a8beecd37a4c45)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $be547bb6c77acdb8$var$_resolveDeferredResults.apply(this, arguments);
}
function $be547bb6c77acdb8$var$resolveDeferredData(result, signal, unwrap) {
    return $be547bb6c77acdb8$var$_resolveDeferredData.apply(this, arguments);
}
function $be547bb6c77acdb8$var$_resolveDeferredData() {
    $be547bb6c77acdb8$var$_resolveDeferredData = (0, $baf9b2a64fedef68$export$7c398597f8905a1)(function(result, signal, unwrap) {
        var aborted;
        return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (unwrap === void 0) unwrap = false;
                    return [
                        4,
                        result.deferredData.resolveData(signal)
                    ];
                case 1:
                    aborted = _state.sent();
                    if (aborted) return [
                        2
                    ];
                    if (unwrap) try {
                        return [
                            2,
                            {
                                type: $be547bb6c77acdb8$var$ResultType.data,
                                data: result.deferredData.unwrappedData
                            }
                        ];
                    } catch (e) {
                        // Handle any TrackedPromise._error values encountered while unwrapping
                        return [
                            2,
                            {
                                type: $be547bb6c77acdb8$var$ResultType.error,
                                error: e
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $be547bb6c77acdb8$var$ResultType.data,
                            data: result.deferredData.data
                        }
                    ];
            }
        });
    });
    return $be547bb6c77acdb8$var$_resolveDeferredData.apply(this, arguments);
}
function $be547bb6c77acdb8$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
// Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $be547bb6c77acdb8$var$createUseMatchesMatch(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $be547bb6c77acdb8$var$getTargetMatch(matches, location) {
    var search = typeof location === "string" ? $be547bb6c77acdb8$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $be547bb6c77acdb8$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    var pathMatches = $be547bb6c77acdb8$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $be547bb6c77acdb8$var$getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $be547bb6c77acdb8$var$getLoadingNavigation(location, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation1;
    }
}
function $be547bb6c77acdb8$var$getSubmittingNavigation(location, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $be547bb6c77acdb8$var$getLoadingFetcher(submission, data) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data,
            " _hasFetcherDoneAnything ": true
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data,
            " _hasFetcherDoneAnything ": true
        };
        return fetcher1;
    }
}
function $be547bb6c77acdb8$var$getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined,
        " _hasFetcherDoneAnything ": true
    };
    return fetcher;
}
function $be547bb6c77acdb8$var$getDoneFetcher(data) {
    var fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data,
        " _hasFetcherDoneAnything ": true
    };
    return fetcher;
}

/**
 * React Router v6.15.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 






var $dQFEZ = parcelRequire("dQFEZ");

function $8c3ad80f8a436e0f$var$_extends() {
    $8c3ad80f8a436e0f$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8c3ad80f8a436e0f$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
var $8c3ad80f8a436e0f$export$3add0d5dce533e2e = /*#__PURE__*/ $dQFEZ.createContext(null);
var $8c3ad80f8a436e0f$export$145dfa71566a64dc = /*#__PURE__*/ $dQFEZ.createContext(null);
var $8c3ad80f8a436e0f$var$AwaitContext = /*#__PURE__*/ $dQFEZ.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ var $8c3ad80f8a436e0f$export$26749e8557646306 = /*#__PURE__*/ $dQFEZ.createContext(null);
var $8c3ad80f8a436e0f$export$c7914228fb69b0f5 = /*#__PURE__*/ $dQFEZ.createContext(null);
var $8c3ad80f8a436e0f$export$9072aa6dd1f93057 = /*#__PURE__*/ $dQFEZ.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
var $8c3ad80f8a436e0f$var$RouteErrorContext = /*#__PURE__*/ $dQFEZ.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $8c3ad80f8a436e0f$export$b66bb29c5006f12f(to, _temp) {
    var relative = (_temp === void 0 ? {} : _temp).relative;
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    var _React_useContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var _useResolvedPath = $8c3ad80f8a436e0f$export$e75d2a2d1b3c245b(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $be547bb6c77acdb8$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $8c3ad80f8a436e0f$export$9c954a9d03d32f4a() {
    return $dQFEZ.useContext($8c3ad80f8a436e0f$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $8c3ad80f8a436e0f$export$45d76561a5302f2b() {
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    return $dQFEZ.useContext($8c3ad80f8a436e0f$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $8c3ad80f8a436e0f$export$1b3f31771c5d07c() {
    return $dQFEZ.useContext($8c3ad80f8a436e0f$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $8c3ad80f8a436e0f$export$6c330e8992e8a295(pattern) {
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    var pathname = $8c3ad80f8a436e0f$export$45d76561a5302f2b().pathname;
    return $dQFEZ.useMemo(function() {
        return (0, $be547bb6c77acdb8$export$81336c211d5ff295)(pattern, pathname);
    }, [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ var $8c3ad80f8a436e0f$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $8c3ad80f8a436e0f$var$useIsomorphicLayoutEffect(cb) {
    var isStatic = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $dQFEZ.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $8c3ad80f8a436e0f$export$9770f232ac06a008() {
    var isDataRoute = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).isDataRoute;
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $8c3ad80f8a436e0f$var$useNavigateStable() : $8c3ad80f8a436e0f$var$useNavigateUnstable();
}
function $8c3ad80f8a436e0f$var$useNavigateUnstable() {
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    var dataRouterContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$3add0d5dce533e2e);
    var _React_useContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var matches = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).matches;
    var _useLocation = $8c3ad80f8a436e0f$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $be547bb6c77acdb8$export$90ba53ce1c7fdff2)(matches).map(function(match) {
        return match.pathnameBase;
    }));
    var activeRef = $dQFEZ.useRef(false);
    $8c3ad80f8a436e0f$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $dQFEZ.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = (0, $be547bb6c77acdb8$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $be547bb6c77acdb8$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $8c3ad80f8a436e0f$var$OutletContext = /*#__PURE__*/ $dQFEZ.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $8c3ad80f8a436e0f$export$4138103a3ae699cc() {
    return $dQFEZ.useContext($8c3ad80f8a436e0f$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $8c3ad80f8a436e0f$export$a3be3530d8e40d0b(context) {
    var outlet = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $8c3ad80f8a436e0f$export$99eaa27ddbbb95ef() {
    var matches = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $8c3ad80f8a436e0f$export$e75d2a2d1b3c245b(to, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var matches = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).matches;
    var _useLocation = $8c3ad80f8a436e0f$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $be547bb6c77acdb8$export$90ba53ce1c7fdff2)(matches).map(function(match) {
        return match.pathnameBase;
    }));
    return $dQFEZ.useMemo(function() {
        return (0, $be547bb6c77acdb8$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $8c3ad80f8a436e0f$export$5d3fca4a98652595(routes, locationArg) {
    return $8c3ad80f8a436e0f$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $8c3ad80f8a436e0f$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    var navigator = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306).navigator;
    var _React_useContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057), parentMatches = _React_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    var locationFromContext = $8c3ad80f8a436e0f$export$45d76561a5302f2b();
    var location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        var parsedLocationArg = typeof locationArg === "string" ? (0, $be547bb6c77acdb8$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    var matches = (0, $be547bb6c77acdb8$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    var renderedMatches = $8c3ad80f8a436e0f$var$_renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $be547bb6c77acdb8$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $be547bb6c77acdb8$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $8c3ad80f8a436e0f$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $be547bb6c77acdb8$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $8c3ad80f8a436e0f$var$DefaultErrorComponent() {
    var error = $8c3ad80f8a436e0f$export$ed527bf60f6e05f2();
    var message = (0, $be547bb6c77acdb8$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    return /*#__PURE__*/ $dQFEZ.createElement($dQFEZ.Fragment, null, /*#__PURE__*/ $dQFEZ.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $dQFEZ.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $dQFEZ.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $8c3ad80f8a436e0f$var$defaultErrorElement = /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$DefaultErrorComponent, null);
var $8c3ad80f8a436e0f$var$RenderErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $de944088b801fe33$export$7e4530ad35d3bb8)(RenderErrorBoundary, _React_Component);
    var _super = (0, $f8f85617d0e0b5b6$export$8dd05c13f5255580)(RenderErrorBoundary);
    function RenderErrorBoundary(props) {
        (0, $bf86af1e5034cb56$export$2996f80ef42b8419)(this, RenderErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $9ac25a306229a9ff$export$d60067ff2358eee8)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("React Router caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error ? /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$9072aa6dd1f93057.Provider, {
                    value: this.props.routeContext
                }, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                // When we get into an error state, the user will likely click "back" to the
                // previous page that didn't have an error. Because this wraps the entire
                // application, that will have no effect--the error page continues to display.
                // This gives us a mechanism to recover from the error when the location changes.
                //
                // Whether we're in an error state or not, we update the location in state
                // so that when we are in an error state, it gets reset when a new location
                // comes in and the user recovers from the error.
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                // If we're not changing locations, preserve the location but still surface
                // any new errors that may come through. We retain the existing error, we do
                // this because the error provided from the app state may be cleared without
                // the location changing.
                return {
                    error: props.error || state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($dQFEZ.Component);
function $8c3ad80f8a436e0f$var$RenderedRoute(_ref) {
    var routeContext = _ref.routeContext, match = _ref.match, children = _ref.children;
    var dataRouterContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $8c3ad80f8a436e0f$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    var errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors == null ? void 0 : errors[m.route.id]);
        });
        !(errorIndex >= 0) && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        var error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        var errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $8c3ad80f8a436e0f$var$defaultErrorElement;
        var _$matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $dQFEZ.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: _$matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: _$matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $8c3ad80f8a436e0f$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($8c3ad80f8a436e0f$var$DataRouterHook || {});
var $8c3ad80f8a436e0f$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($8c3ad80f8a436e0f$var$DataRouterStateHook || {});
function $8c3ad80f8a436e0f$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $8c3ad80f8a436e0f$var$useDataRouterContext(hookName) {
    var ctx = $dQFEZ.useContext($8c3ad80f8a436e0f$export$3add0d5dce533e2e);
    !ctx && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    return ctx;
}
function $8c3ad80f8a436e0f$var$useDataRouterState(hookName) {
    var state = $dQFEZ.useContext($8c3ad80f8a436e0f$export$145dfa71566a64dc);
    !state && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    return state;
}
function $8c3ad80f8a436e0f$var$useRouteContext(hookName) {
    var route = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057);
    !route && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $8c3ad80f8a436e0f$var$useCurrentRouteId(hookName) {
    var route = $8c3ad80f8a436e0f$var$useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $8c3ad80f8a436e0f$export$5fc8298006ad9e58() {
    return $8c3ad80f8a436e0f$var$useCurrentRouteId($8c3ad80f8a436e0f$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $8c3ad80f8a436e0f$export$d0fd4b7106de2769() {
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $8c3ad80f8a436e0f$export$600dc272ed516c15() {
    var dataRouterContext = $8c3ad80f8a436e0f$var$useDataRouterContext($8c3ad80f8a436e0f$var$DataRouterHook.UseRevalidator);
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseRevalidator);
    return $dQFEZ.useMemo(function() {
        return {
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        };
    }, [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $8c3ad80f8a436e0f$export$2378eb7f5ff86053() {
    var _useDataRouterState = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseMatches), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $dQFEZ.useMemo(function() {
        return matches.map(function(match) {
            var pathname = match.pathname, params = match.params;
            // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        });
    }, [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $8c3ad80f8a436e0f$export$1448a5050d252c4d() {
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseLoaderData);
    var routeId = $8c3ad80f8a436e0f$var$useCurrentRouteId($8c3ad80f8a436e0f$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $8c3ad80f8a436e0f$export$fd5d37484eab868d(routeId) {
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $8c3ad80f8a436e0f$export$fdc00f3f26066d5e() {
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseActionData);
    var route = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057);
    !route && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $8c3ad80f8a436e0f$export$ed527bf60f6e05f2() {
    var _state$errors;
    var error = $dQFEZ.useContext($8c3ad80f8a436e0f$var$RouteErrorContext);
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseRouteError);
    var routeId = $8c3ad80f8a436e0f$var$useCurrentRouteId($8c3ad80f8a436e0f$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $8c3ad80f8a436e0f$export$78a72ddb39bdd145() {
    var value = $dQFEZ.useContext($8c3ad80f8a436e0f$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $8c3ad80f8a436e0f$export$17f53340677d5831() {
    var value = $dQFEZ.useContext($8c3ad80f8a436e0f$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
var $8c3ad80f8a436e0f$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $8c3ad80f8a436e0f$export$2af03a1de5c0910(shouldBlock) {
    var _useDataRouterContext = $8c3ad80f8a436e0f$var$useDataRouterContext($8c3ad80f8a436e0f$var$DataRouterHook.UseBlocker), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseBlocker);
    var _React_useState = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)($dQFEZ.useState(""), 2), blockerKey = _React_useState[0], setBlockerKey = _React_useState[1];
    var blockerFunction = $dQFEZ.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: $8c3ad80f8a436e0f$var$_extends({}, currentLocation, {
                pathname: (0, $be547bb6c77acdb8$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $8c3ad80f8a436e0f$var$_extends({}, nextLocation, {
                pathname: (0, $be547bb6c77acdb8$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $dQFEZ.useEffect(function() {
        var key = String(++$8c3ad80f8a436e0f$var$blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $dQFEZ.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $be547bb6c77acdb8$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $8c3ad80f8a436e0f$var$useNavigateStable() {
    var router = $8c3ad80f8a436e0f$var$useDataRouterContext($8c3ad80f8a436e0f$var$DataRouterHook.UseNavigateStable).router;
    var id = $8c3ad80f8a436e0f$var$useCurrentRouteId($8c3ad80f8a436e0f$var$DataRouterStateHook.UseNavigateStable);
    var activeRef = $dQFEZ.useRef(false);
    $8c3ad80f8a436e0f$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $dQFEZ.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $8c3ad80f8a436e0f$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
var $8c3ad80f8a436e0f$var$alreadyWarned = {};
function $8c3ad80f8a436e0f$var$warningOnce(key, cond, message) {
    if (!cond && !$8c3ad80f8a436e0f$var$alreadyWarned[key]) $8c3ad80f8a436e0f$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $8c3ad80f8a436e0f$var$START_TRANSITION = "startTransition";
var $8c3ad80f8a436e0f$var$startTransitionImpl = $dQFEZ[$8c3ad80f8a436e0f$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $8c3ad80f8a436e0f$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    var _React_useState = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)($dQFEZ.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $dQFEZ.useCallback(function(newState) {
        v7_startTransition && $8c3ad80f8a436e0f$var$startTransitionImpl ? $8c3ad80f8a436e0f$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dQFEZ.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    var navigator = $dQFEZ.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $dQFEZ.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $dQFEZ.createElement($dQFEZ.Fragment, null, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $8c3ad80f8a436e0f$var$DataRoutes(_ref2) {
    var routes = _ref2.routes, state = _ref2.state;
    return $8c3ad80f8a436e0f$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $8c3ad80f8a436e0f$export$ae46f04cfaffe093(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, initialEntries = _ref3.initialEntries, initialIndex = _ref3.initialIndex, future = _ref3.future;
    var historyRef = $dQFEZ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $be547bb6c77acdb8$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)($dQFEZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $dQFEZ.useCallback(function(newState) {
        v7_startTransition && $8c3ad80f8a436e0f$var$startTransitionImpl ? $8c3ad80f8a436e0f$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dQFEZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $8c3ad80f8a436e0f$export$444b3ab0cb9aec40(_ref4) {
    var to = _ref4.to, replace = _ref4.replace, state = _ref4.state, relative = _ref4.relative;
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    var matches = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).matches;
    var _useLocation = $8c3ad80f8a436e0f$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var navigate = $8c3ad80f8a436e0f$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    var path = (0, $be547bb6c77acdb8$export$cae722b0cc860f13)(to, (0, $be547bb6c77acdb8$export$90ba53ce1c7fdff2)(matches).map(function(match) {
        return match.pathnameBase;
    }), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    $dQFEZ.useEffect(function() {
        return navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $8c3ad80f8a436e0f$export$910ae8079b2c2852(props) {
    return $8c3ad80f8a436e0f$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $8c3ad80f8a436e0f$export$e7b0ac011bb776c6(_props) {
    (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $8c3ad80f8a436e0f$export$55185c17a0fcbe46(_ref5) {
    var tmp = _ref5.basename, basenameProp = tmp === void 0 ? "/" : tmp, _ref5_children = _ref5.children, children = _ref5_children === void 0 ? null : _ref5_children, locationProp = _ref5.location, _ref5_navigationType = _ref5.navigationType, navigationType = _ref5_navigationType === void 0 ? (0, $be547bb6c77acdb8$export$e19cd5f9376f8cee).Pop : _ref5_navigationType, navigator = _ref5.navigator, tmp1 = _ref5.static, staticProp = tmp1 === void 0 ? false : tmp1;
    !!$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $dQFEZ.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp
        };
    }, [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $be547bb6c77acdb8$export$8ccf933b0513f8d0)(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = $dQFEZ.useMemo(function() {
        var trailingPathname = (0, $be547bb6c77acdb8$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $8c3ad80f8a436e0f$export$3565eb3d00ca5a74(_ref6) {
    var children = _ref6.children, location = _ref6.location;
    return $8c3ad80f8a436e0f$export$5d3fca4a98652595($8c3ad80f8a436e0f$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $8c3ad80f8a436e0f$export$6ddabde395c8c576(_ref7) {
    var children = _ref7.children, errorElement = _ref7.errorElement, resolve = _ref7.resolve;
    return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$ResolveAwait, null, children));
}
var $8c3ad80f8a436e0f$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($8c3ad80f8a436e0f$var$AwaitRenderStatus || {});
var $8c3ad80f8a436e0f$var$neverSettledPromise = new Promise(function() {});
var $8c3ad80f8a436e0f$var$AwaitErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $de944088b801fe33$export$7e4530ad35d3bb8)(AwaitErrorBoundary, _React_Component);
    var _super = (0, $f8f85617d0e0b5b6$export$8dd05c13f5255580)(AwaitErrorBoundary);
    function AwaitErrorBoundary(props) {
        (0, $bf86af1e5034cb56$export$2996f80ef42b8419)(this, AwaitErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $9ac25a306229a9ff$export$d60067ff2358eee8)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = $8c3ad80f8a436e0f$var$AwaitRenderStatus.pending;
                if (!(resolve instanceof Promise)) {
                    // Didn't get a promise - provide as a resolved promise
                    status = $8c3ad80f8a436e0f$var$AwaitRenderStatus.success;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    // Caught a render error, provide it as a rejected promise
                    status = $8c3ad80f8a436e0f$var$AwaitRenderStatus.error;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {}); // Avoid unhandled rejection warnings
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    // Already tracked promise - check contents
                    promise = resolve;
                    status = promise._error !== undefined ? $8c3ad80f8a436e0f$var$AwaitRenderStatus.error : promise._data !== undefined ? $8c3ad80f8a436e0f$var$AwaitRenderStatus.success : $8c3ad80f8a436e0f$var$AwaitRenderStatus.pending;
                } else {
                    // Raw (untracked) promise - track it
                    status = $8c3ad80f8a436e0f$var$AwaitRenderStatus.pending;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data;
                            }
                        });
                    }, function(error) {
                        return Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === $8c3ad80f8a436e0f$var$AwaitRenderStatus.error && promise._error instanceof (0, $be547bb6c77acdb8$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
                throw $8c3ad80f8a436e0f$var$neverSettledPromise;
                if (status === $8c3ad80f8a436e0f$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
                throw promise._error;
                if (status === $8c3ad80f8a436e0f$var$AwaitRenderStatus.error) // Render via our errorElement
                return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === $8c3ad80f8a436e0f$var$AwaitRenderStatus.success) // Render children with resolved value
                return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                // Throw to the suspense boundary
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($dQFEZ.Component);
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $8c3ad80f8a436e0f$var$ResolveAwait(_ref8) {
    var children = _ref8.children;
    var data = $8c3ad80f8a436e0f$export$78a72ddb39bdd145();
    var toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $dQFEZ.createElement($dQFEZ.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $8c3ad80f8a436e0f$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    var routes = [];
    $dQFEZ.Children.forEach(children, function(element, index) {
        if (!/*#__PURE__*/ $dQFEZ.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        var treePath = (0, $1d041ee89e51af1b$export$1b5e630bc3aea29f)(parentPath).concat([
            index
        ]);
        if (element.type === $dQFEZ.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $8c3ad80f8a436e0f$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $8c3ad80f8a436e0f$export$e7b0ac011bb776c6) && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $8c3ad80f8a436e0f$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $8c3ad80f8a436e0f$export$daf73786167a7f72(matches) {
    return $8c3ad80f8a436e0f$var$_renderMatches(matches);
}
function $8c3ad80f8a436e0f$export$52b333d321859367(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $dQFEZ.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $dQFEZ.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $8c3ad80f8a436e0f$export$f30f7e456d254e83(routes, opts) {
    return (0, $be547bb6c77acdb8$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $8c3ad80f8a436e0f$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $be547bb6c77acdb8$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $8c3ad80f8a436e0f$export$52b333d321859367
    }).initialize();
}



function $fc41d09ddc03e3ec$var$_extends() {
    $fc41d09ddc03e3ec$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fc41d09ddc03e3ec$var$_extends.apply(this, arguments);
}
function $fc41d09ddc03e3ec$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $fc41d09ddc03e3ec$var$defaultMethod = "get";
var $fc41d09ddc03e3ec$var$defaultEncType = "application/x-www-form-urlencoded";
function $fc41d09ddc03e3ec$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $fc41d09ddc03e3ec$var$isButtonElement(object) {
    return $fc41d09ddc03e3ec$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $fc41d09ddc03e3ec$var$isFormElement(object) {
    return $fc41d09ddc03e3ec$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $fc41d09ddc03e3ec$var$isInputElement(object) {
    return $fc41d09ddc03e3ec$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $fc41d09ddc03e3ec$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $fc41d09ddc03e3ec$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$fc41d09ddc03e3ec$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $fc41d09ddc03e3ec$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo, key) {
        var value = init[key];
        return memo.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $fc41d09ddc03e3ec$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = $fc41d09ddc03e3ec$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach(function(_, key) {
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
var $fc41d09ddc03e3ec$var$_formDataSupportsSubmitter = null;
function $fc41d09ddc03e3ec$var$isFormDataSubmitterSupported() {
    if ($fc41d09ddc03e3ec$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $fc41d09ddc03e3ec$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $fc41d09ddc03e3ec$var$_formDataSupportsSubmitter = true;
    }
    return $fc41d09ddc03e3ec$var$_formDataSupportsSubmitter;
}
var $fc41d09ddc03e3ec$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $fc41d09ddc03e3ec$var$getFormEncType(encType) {
    if (encType != null && !$fc41d09ddc03e3ec$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $fc41d09ddc03e3ec$var$getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if ($fc41d09ddc03e3ec$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr = target.getAttribute("action");
        action = attr ? (0, $be547bb6c77acdb8$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $fc41d09ddc03e3ec$var$defaultMethod;
        encType = $fc41d09ddc03e3ec$var$getFormEncType(target.getAttribute("enctype")) || $fc41d09ddc03e3ec$var$defaultEncType;
        formData = new FormData(target);
    } else if ($fc41d09ddc03e3ec$var$isButtonElement(target) || $fc41d09ddc03e3ec$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? (0, $be547bb6c77acdb8$export$b69e3301ce081aa3)(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $fc41d09ddc03e3ec$var$defaultMethod;
        encType = $fc41d09ddc03e3ec$var$getFormEncType(target.getAttribute("formenctype")) || $fc41d09ddc03e3ec$var$getFormEncType(form.getAttribute("enctype")) || $fc41d09ddc03e3ec$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$fc41d09ddc03e3ec$var$isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($fc41d09ddc03e3ec$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $fc41d09ddc03e3ec$var$defaultMethod;
        action = null;
        encType = $fc41d09ddc03e3ec$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
var $fc41d09ddc03e3ec$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $fc41d09ddc03e3ec$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $fc41d09ddc03e3ec$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset"
];
function $fc41d09ddc03e3ec$export$1f3f55432a00e06d(routes, opts) {
    return (0, $be547bb6c77acdb8$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $fc41d09ddc03e3ec$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $be547bb6c77acdb8$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $fc41d09ddc03e3ec$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $8c3ad80f8a436e0f$export$52b333d321859367)
    }).initialize();
}
function $fc41d09ddc03e3ec$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $be547bb6c77acdb8$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $fc41d09ddc03e3ec$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $be547bb6c77acdb8$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $fc41d09ddc03e3ec$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $8c3ad80f8a436e0f$export$52b333d321859367)
    }).initialize();
}
function $fc41d09ddc03e3ec$var$parseHydrationData() {
    var _window;
    var state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $fc41d09ddc03e3ec$var$_extends({}, state, {
        errors: $fc41d09ddc03e3ec$var$deserializeErrors(state.errors)
    });
    return state;
}
function $fc41d09ddc03e3ec$var$deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            // Hey you!  If you change this, please change the corresponding logic in
            // serializeErrors in react-router-dom/server.tsx :)
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $be547bb6c77acdb8$export$acf1a680051f5031)(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
                if (val.__subType) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        // @ts-expect-error
                        var error = new ErrorConstructor(val.message);
                        // Wipe away the client-side stack trace.  Nothing to fill it in with
                        // because we don't serialize SSR stack traces for security reasons
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {
                    // no-op - fall through and create a normal Error
                    }
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $fc41d09ddc03e3ec$var$START_TRANSITION = "startTransition";
var $fc41d09ddc03e3ec$var$startTransitionImpl = $dQFEZ[$fc41d09ddc03e3ec$var$START_TRANSITION];
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $fc41d09ddc03e3ec$export$9ba4e89fdfa1fc54(_ref) {
    var basename = _ref.basename, children = _ref.children, future = _ref.future, _$window = _ref.window;
    var historyRef = $dQFEZ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $be547bb6c77acdb8$export$719fc203c4e16dee)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)($dQFEZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $dQFEZ.useCallback(function(newState) {
        v7_startTransition && $fc41d09ddc03e3ec$var$startTransitionImpl ? $fc41d09ddc03e3ec$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dQFEZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $dQFEZ.createElement((0, $8c3ad80f8a436e0f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $fc41d09ddc03e3ec$export$7221d69dcfc8e36b(_ref2) {
    var basename = _ref2.basename, children = _ref2.children, future = _ref2.future, _$window = _ref2.window;
    var historyRef = $dQFEZ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $be547bb6c77acdb8$export$b71fdd3798280242)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)($dQFEZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $dQFEZ.useCallback(function(newState) {
        v7_startTransition && $fc41d09ddc03e3ec$var$startTransitionImpl ? $fc41d09ddc03e3ec$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dQFEZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $dQFEZ.createElement((0, $8c3ad80f8a436e0f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $fc41d09ddc03e3ec$export$eefb0c834599897e(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, future = _ref3.future, history = _ref3.history;
    var _React_useState = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)($dQFEZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $dQFEZ.useCallback(function(newState) {
        v7_startTransition && $fc41d09ddc03e3ec$var$startTransitionImpl ? $fc41d09ddc03e3ec$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dQFEZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $dQFEZ.createElement((0, $8c3ad80f8a436e0f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
var $fc41d09ddc03e3ec$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var $fc41d09ddc03e3ec$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ var $fc41d09ddc03e3ec$export$a6c7ac8248d6e38a = /*#__PURE__*/ $dQFEZ.forwardRef(function LinkWithRef(_ref4, ref) {
    var handleClick = function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    };
    var onClick = _ref4.onClick, relative = _ref4.relative, reloadDocument = _ref4.reloadDocument, replace = _ref4.replace, state = _ref4.state, target = _ref4.target, to = _ref4.to, preventScrollReset = _ref4.preventScrollReset, rest = $fc41d09ddc03e3ec$var$_objectWithoutPropertiesLoose(_ref4, $fc41d09ddc03e3ec$var$_excluded);
    var basename = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$26749e8557646306)).basename;
    // Rendered into <a href> for absolute URLs
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && $fc41d09ddc03e3ec$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($fc41d09ddc03e3ec$var$isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = (0, $be547bb6c77acdb8$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    var href = (0, $8c3ad80f8a436e0f$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    var internalOnClick = $fc41d09ddc03e3ec$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $dQFEZ.createElement("a", $fc41d09ddc03e3ec$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $fc41d09ddc03e3ec$export$b0d92dbee9b5b60d = /*#__PURE__*/ $dQFEZ.forwardRef(function NavLinkWithRef(_ref5, ref) {
    var tmp = _ref5["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _ref5_caseSensitive = _ref5.caseSensitive, caseSensitive = _ref5_caseSensitive === void 0 ? false : _ref5_caseSensitive, tmp1 = _ref5.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _ref5_end = _ref5.end, end = _ref5_end === void 0 ? false : _ref5_end, styleProp = _ref5.style, to = _ref5.to, children = _ref5.children, rest = $fc41d09ddc03e3ec$var$_objectWithoutPropertiesLoose(_ref5, $fc41d09ddc03e3ec$var$_excluded2);
    var path = (0, $8c3ad80f8a436e0f$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    var location = (0, $8c3ad80f8a436e0f$export$45d76561a5302f2b)();
    var routerState = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$145dfa71566a64dc));
    var navigator = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$26749e8557646306)).navigator;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var ariaCurrent = isActive ? ariaCurrentProp : undefined;
    var className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $dQFEZ.createElement($fc41d09ddc03e3ec$export$a6c7ac8248d6e38a, $fc41d09ddc03e3ec$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ var $fc41d09ddc03e3ec$export$a7fed597f4b8afd8 = /*#__PURE__*/ $dQFEZ.forwardRef(function(props, ref) {
    var submit = $fc41d09ddc03e3ec$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $dQFEZ.createElement($fc41d09ddc03e3ec$var$FormImpl, $fc41d09ddc03e3ec$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
var $fc41d09ddc03e3ec$var$FormImpl = /*#__PURE__*/ $dQFEZ.forwardRef(function(_ref6, forwardedRef) {
    var reloadDocument = _ref6.reloadDocument, replace = _ref6.replace, state = _ref6.state, _ref6_method = _ref6.method, method = _ref6_method === void 0 ? $fc41d09ddc03e3ec$var$defaultMethod : _ref6_method, action = _ref6.action, onSubmit = _ref6.onSubmit, submit = _ref6.submit, relative = _ref6.relative, preventScrollReset = _ref6.preventScrollReset, props = $fc41d09ddc03e3ec$var$_objectWithoutPropertiesLoose(_ref6, $fc41d09ddc03e3ec$var$_excluded3);
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var formAction = $fc41d09ddc03e3ec$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $dQFEZ.createElement("form", $fc41d09ddc03e3ec$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $fc41d09ddc03e3ec$export$11aac1aab828f1fa(_ref7) {
    var getKey = _ref7.getKey, storageKey = _ref7.storageKey;
    $fc41d09ddc03e3ec$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $fc41d09ddc03e3ec$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($fc41d09ddc03e3ec$var$DataRouterHook || ($fc41d09ddc03e3ec$var$DataRouterHook = {}));
var $fc41d09ddc03e3ec$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($fc41d09ddc03e3ec$var$DataRouterStateHook || ($fc41d09ddc03e3ec$var$DataRouterStateHook = {}));
function $fc41d09ddc03e3ec$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $fc41d09ddc03e3ec$var$useDataRouterContext(hookName) {
    var ctx = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$3add0d5dce533e2e));
    !ctx && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    return ctx;
}
function $fc41d09ddc03e3ec$var$useDataRouterState(hookName) {
    var state = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$145dfa71566a64dc));
    !state && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $fc41d09ddc03e3ec$export$67621102c14d847(to, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative;
    var navigate = (0, $8c3ad80f8a436e0f$export$9770f232ac06a008)();
    var location = (0, $8c3ad80f8a436e0f$export$45d76561a5302f2b)();
    var path = (0, $8c3ad80f8a436e0f$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $dQFEZ.useCallback(function(event) {
        if ($fc41d09ddc03e3ec$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            var replace = replaceProp !== undefined ? replaceProp : (0, $be547bb6c77acdb8$export$fe53371bee54353d)(location) === (0, $be547bb6c77acdb8$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $fc41d09ddc03e3ec$export$f1a78c17382fe22a(defaultInit) {
    var defaultSearchParamsRef = $dQFEZ.useRef($fc41d09ddc03e3ec$export$a2e4e2dcc7b1f22f(defaultInit));
    var hasSetSearchParamsRef = $dQFEZ.useRef(false);
    var location = (0, $8c3ad80f8a436e0f$export$45d76561a5302f2b)();
    var searchParams = $dQFEZ.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $fc41d09ddc03e3ec$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = (0, $8c3ad80f8a436e0f$export$9770f232ac06a008)();
    var setSearchParams = $dQFEZ.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = $fc41d09ddc03e3ec$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $fc41d09ddc03e3ec$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $fc41d09ddc03e3ec$export$47c85c6e3a081d3() {
    var router = $fc41d09ddc03e3ec$var$useDataRouterContext($fc41d09ddc03e3ec$var$DataRouterHook.UseSubmit).router;
    var basename = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$26749e8557646306)).basename;
    var currentRouteId = (0, $8c3ad80f8a436e0f$export$5fc8298006ad9e58)();
    return $dQFEZ.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $fc41d09ddc03e3ec$var$validateClientSideSubmission();
        var _getFormSubmissionInfo = $fc41d09ddc03e3ec$var$getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $fc41d09ddc03e3ec$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    var router = $fc41d09ddc03e3ec$var$useDataRouterContext($fc41d09ddc03e3ec$var$DataRouterHook.UseSubmitFetcher).router;
    var basename = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$26749e8557646306)).basename;
    return $dQFEZ.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $fc41d09ddc03e3ec$var$validateClientSideSubmission();
        var _getFormSubmissionInfo = $fc41d09ddc03e3ec$var$getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        !(fetcherRouteId != null) && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $fc41d09ddc03e3ec$export$89a6bd6db0d97c56(action, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var basename = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$26749e8557646306)).basename;
    var routeContext = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$9072aa6dd1f93057));
    !routeContext && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    var _routeContext_matches_slice = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    var path = $fc41d09ddc03e3ec$var$_extends({}, (0, $8c3ad80f8a436e0f$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params of the resolved URL. This is
    // the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    var location = (0, $8c3ad80f8a436e0f$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            var params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $be547bb6c77acdb8$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $be547bb6c77acdb8$export$fe53371bee54353d)(path);
}
function $fc41d09ddc03e3ec$var$createFetcherForm(fetcherKey, routeId) {
    var FetcherForm = /*#__PURE__*/ $dQFEZ.forwardRef(function(props, ref) {
        var submit = $fc41d09ddc03e3ec$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $dQFEZ.createElement($fc41d09ddc03e3ec$var$FormImpl, $fc41d09ddc03e3ec$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    return FetcherForm;
}
var $fc41d09ddc03e3ec$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $fc41d09ddc03e3ec$export$5b0d2d9a9921565a() {
    var _route$matches;
    var router = $fc41d09ddc03e3ec$var$useDataRouterContext($fc41d09ddc03e3ec$var$DataRouterHook.UseFetcher).router;
    var route = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$9072aa6dd1f93057));
    !route && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    var routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    var _React_useState = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)($dQFEZ.useState(function() {
        return String(++$fc41d09ddc03e3ec$var$fetcherId);
    }), 1), fetcherKey = _React_useState[0];
    var _React_useState1 = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)($dQFEZ.useState(function() {
        !routeId && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
        return $fc41d09ddc03e3ec$var$createFetcherForm(fetcherKey, routeId);
    }), 1), Form = _React_useState1[0];
    var _React_useState2 = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)($dQFEZ.useState(function() {
        return function(href) {
            !router && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
            !routeId && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href);
        };
    }), 1), load = _React_useState2[0];
    var submit = $fc41d09ddc03e3ec$var$useSubmitFetcher(fetcherKey, routeId);
    var fetcher = router.getFetcher(fetcherKey);
    var fetcherWithComponents = $dQFEZ.useMemo(function() {
        return $fc41d09ddc03e3ec$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher);
    }, [
        fetcher,
        Form,
        submit,
        load
    ]);
    $dQFEZ.useEffect(function() {
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return function() {
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $fc41d09ddc03e3ec$export$fa996778a3a31087() {
    var state = $fc41d09ddc03e3ec$var$useDataRouterState($fc41d09ddc03e3ec$var$DataRouterStateHook.UseFetchers);
    return (0, $1d041ee89e51af1b$export$1b5e630bc3aea29f)(state.fetchers.values());
}
var $fc41d09ddc03e3ec$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $fc41d09ddc03e3ec$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $fc41d09ddc03e3ec$export$25057cfe5591e3e9(_temp3) {
    var _ref = _temp3 === void 0 ? {} : _temp3, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = $fc41d09ddc03e3ec$var$useDataRouterContext($fc41d09ddc03e3ec$var$DataRouterHook.UseScrollRestoration).router;
    var _useDataRouterState = $fc41d09ddc03e3ec$var$useDataRouterState($fc41d09ddc03e3ec$var$DataRouterStateHook.UseScrollRestoration), restoreScrollPosition = _useDataRouterState.restoreScrollPosition, preventScrollReset = _useDataRouterState.preventScrollReset;
    var basename = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$26749e8557646306)).basename;
    var location = (0, $8c3ad80f8a436e0f$export$45d76561a5302f2b)();
    var matches = (0, $8c3ad80f8a436e0f$export$2378eb7f5ff86053)();
    var navigation = (0, $8c3ad80f8a436e0f$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $dQFEZ.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $fc41d09ddc03e3ec$var$usePageHide($dQFEZ.useCallback(function() {
        if (navigation.state === "idle") {
            var key = (getKey ? getKey(location, matches) : null) || location.key;
            $fc41d09ddc03e3ec$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $fc41d09ddc03e3ec$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($fc41d09ddc03e3ec$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dQFEZ.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || $fc41d09ddc03e3ec$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $fc41d09ddc03e3ec$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dQFEZ.useLayoutEffect(function() {
            var getKeyWithoutBasename = getKey && basename !== "/" ? function(location, matches) {
                return getKey($fc41d09ddc03e3ec$var$_extends({}, location, {
                    pathname: (0, $be547bb6c77acdb8$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches);
            } : getKey;
            var disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($fc41d09ddc03e3ec$var$savedScrollPositions, function() {
                return window.scrollY;
            }, getKeyWithoutBasename);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dQFEZ.useLayoutEffect(function() {
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $fc41d09ddc03e3ec$export$c0a586b329cae57d(callback, options) {
    var capture = (options || {}).capture;
    $dQFEZ.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $fc41d09ddc03e3ec$var$usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $dQFEZ.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $fc41d09ddc03e3ec$export$39f4eb3dbd812741(_ref8) {
    var when = _ref8.when, message = _ref8.message;
    var blocker = (0, $8c3ad80f8a436e0f$export$2af03a1de5c0910)(when);
    $dQFEZ.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $dQFEZ.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}


var $7fd29bc6f1b71fd8$var$Header = function() {
    var btnName = "Login";
    var _useState = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)((0, $dQFEZ.useState)("Login"), 2), btnNameReact = _useState[0], setbtnNameReact = _useState[1];
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        className: "header",
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "logo-container",
                children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                    className: "logo",
                    children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("img", {
                        className: "logo-image",
                        src: (0, $1ad00fd5a6f8ced9$export$8878ead86ed0da0b)
                    })
                })
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "nav-items",
                children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $fc41d09ddc03e3ec$export$a6c7ac8248d6e38a), {
                                to: "/",
                                children: "Home"
                            })
                        }),
                        /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $fc41d09ddc03e3ec$export$a6c7ac8248d6e38a), {
                                to: "/about",
                                children: "AboutUs "
                            })
                        }),
                        /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $fc41d09ddc03e3ec$export$a6c7ac8248d6e38a), {
                                to: "/contact",
                                children: "ConactUs "
                            })
                        }),
                        /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("li", {
                            children: "Cart"
                        }),
                        /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("button", {
                            className: "login",
                            onClick: function() {
                                if (btnNameReact === "Login") setbtnNameReact("Logout");
                                else setbtnNameReact("Login");
                            },
                            children: btnNameReact
                        })
                    ]
                })
            })
        ]
    });
};
var $7fd29bc6f1b71fd8$export$2e2bcd8739ae039 = $7fd29bc6f1b71fd8$var$Header;




function $e1f0c9b9d3f0410c$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $51fbb26672273063$export$1e71eb4bef00f6b0)(target, key, source[key]);
        });
    }
    return target;
}






var $dQFEZ = parcelRequire("dQFEZ");
var $df5baff8fd88aa24$var$resList = [
    {
        "info": {
            "id": "486966",
            "name": "Annapurna Bhojanalya",
            "cloudinaryImageId": "fnxxohtkdy4ke4nrz76w",
            "locality": "RDC",
            "areaName": "Raj Nagar",
            "costForTwo": "₹250 for two",
            "cuisines": [
                "Indian"
            ],
            "avgRating": 3.8,
            "veg": true,
            "feeDetails": {
                "restaurantId": "486966",
                "fees": [
                    {
                        "name": "BASE_DISTANCE",
                        "fee": 5600
                    },
                    {
                        "name": "BASE_TIME"
                    },
                    {
                        "name": "ANCILLARY_SURGE_FEE"
                    }
                ],
                "totalFee": 5600
            },
            "parentId": "34010",
            "avgRatingString": "3.8",
            "totalRatingsString": "500+",
            "promoted": true,
            "adTrackingId": "cid=7746463~p=3~eid=00000189-bd7e-d23f-0cfb-278d00850352~srvts=1691101352511~45826",
            "sla": {
                "deliveryTime": 30,
                "lastMileTravel": 4.7,
                "serviceability": "SERVICEABLE",
                "slaString": "30 mins",
                "lastMileTravelString": "4.7 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2023-08-04 06:59:00",
                "opened": true
            },
            "badges": {
                "textExtendedBadges": [
                    {
                        "iconId": "guiltfree/GF_Logo_android_3x",
                        "shortDescription": "options available",
                        "fontColor": "#7E808C"
                    }
                ]
            },
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "textBased": {},
                    "imageBased": {},
                    "textExtendedBadges": {
                        "badgeObject": [
                            {
                                "attributes": {
                                    "shortDescription": "options available",
                                    "fontColor": "#7E808C",
                                    "iconId": "guiltfree/GF_Logo_android_3x",
                                    "description": ""
                                }
                            }
                        ]
                    }
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "₹125 OFF",
                "subHeader": "ABOVE ₹249",
                "headerTypeV2": "HEADER_TYPE_V2_TOP_UP",
                "secondaryDiscountCallout": "+ EXTRA ₹75 OFF"
            },
            "loyaltyDiscoverPresentationInfo": {
                "logoCtx": {
                    "text": "BENEFITS",
                    "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                },
                "freedelMessage": "FREE DELIVERY"
            },
            "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {}
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "swiggy://menu?restaurant_id=486966",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
        }
    },
    {
        "info": {
            "id": "163817",
            "name": "Rollsking",
            "cloudinaryImageId": "y8hgfb41nsnnzwivqw16",
            "locality": "Panchsheel Square Mall",
            "areaName": "crossing republic",
            "costForTwo": "₹250 for two",
            "cuisines": [
                "North Indian",
                "Fast Food",
                "Beverages"
            ],
            "avgRating": 3.6,
            "feeDetails": {
                "restaurantId": "163817",
                "fees": [
                    {
                        "name": "BASE_DISTANCE",
                        "fee": 7600
                    },
                    {
                        "name": "BASE_TIME"
                    },
                    {
                        "name": "ANCILLARY_SURGE_FEE"
                    }
                ],
                "totalFee": 7600
            },
            "parentId": "4697",
            "avgRatingString": "3.6",
            "totalRatingsString": "1K+",
            "sla": {
                "deliveryTime": 27,
                "lastMileTravel": 6.7,
                "serviceability": "SERVICEABLE",
                "slaString": "27 mins",
                "lastMileTravelString": "6.7 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2023-08-04 12:00:00",
                "opened": true
            },
            "badges": {},
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "imageBased": {},
                    "textExtendedBadges": {},
                    "textBased": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "50% OFF",
                "subHeader": "UPTO ₹100"
            },
            "loyaltyDiscoverPresentationInfo": {
                "logoCtx": {
                    "text": "BENEFITS",
                    "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                },
                "freedelMessage": "FREE DELIVERY"
            },
            "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {}
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "swiggy://menu?restaurant_id=163817",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
        }
    },
    {
        "info": {
            "id": "311388",
            "name": "Burger Singh (Big Punjabi Burgers)",
            "cloudinaryImageId": "kvkhhrtyayzhgkdixi0k",
            "locality": "RDC\xa0Concrete (India) Pvt Ltd",
            "areaName": "Raj Nagar",
            "costForTwo": "₹300 for two",
            "cuisines": [
                "Snacks",
                "Desserts",
                "Beverages"
            ],
            "avgRating": 4.1,
            "feeDetails": {
                "restaurantId": "311388",
                "fees": [
                    {
                        "name": "BASE_DISTANCE",
                        "fee": 5600
                    },
                    {
                        "name": "BASE_TIME"
                    },
                    {
                        "name": "ANCILLARY_SURGE_FEE"
                    }
                ],
                "totalFee": 5600
            },
            "parentId": "375065",
            "avgRatingString": "4.1",
            "totalRatingsString": "5K+",
            "sla": {
                "deliveryTime": 27,
                "lastMileTravel": 4.9,
                "serviceability": "SERVICEABLE",
                "slaString": "27 mins",
                "lastMileTravelString": "4.9 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2023-08-04 04:00:00",
                "opened": true
            },
            "badges": {},
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "imageBased": {},
                    "textExtendedBadges": {},
                    "textBased": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "₹125 OFF",
                "subHeader": "ABOVE ₹249",
                "headerTypeV2": "HEADER_TYPE_V2_TOP_UP",
                "secondaryDiscountCallout": "+ EXTRA ₹75 OFF"
            },
            "loyaltyDiscoverPresentationInfo": {
                "logoCtx": {
                    "text": "BENEFITS",
                    "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                },
                "freedelMessage": "FREE DELIVERY"
            },
            "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {}
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "swiggy://menu?restaurant_id=311388",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
        }
    },
    {
        "info": {
            "id": "395550",
            "name": "The Meal Factory",
            "cloudinaryImageId": "zkc9c5bymqgvw79naf94",
            "locality": "Panchsheel Square Mall",
            "areaName": "crossing republic",
            "costForTwo": "₹150 for two",
            "cuisines": [
                "North Indian",
                "Chinese"
            ],
            "avgRating": 3.5,
            "veg": true,
            "feeDetails": {
                "restaurantId": "395550",
                "fees": [
                    {
                        "name": "BASE_DISTANCE",
                        "fee": 7600
                    },
                    {
                        "name": "BASE_TIME"
                    },
                    {
                        "name": "ANCILLARY_SURGE_FEE"
                    }
                ],
                "totalFee": 7600
            },
            "parentId": "10914",
            "avgRatingString": "3.5",
            "totalRatingsString": "100+",
            "promoted": true,
            "adTrackingId": "cid=7746293~p=4~eid=00000189-bd7e-d23f-0cfb-278e00850407~srvts=1691101352511~45826",
            "sla": {
                "deliveryTime": 37,
                "lastMileTravel": 6.6,
                "serviceability": "SERVICEABLE",
                "slaString": "37 mins",
                "lastMileTravelString": "6.6 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2023-08-04 23:59:00",
                "opened": true
            },
            "badges": {
                "textExtendedBadges": [
                    {
                        "iconId": "guiltfree/GF_Logo_android_3x",
                        "shortDescription": "options available",
                        "fontColor": "#7E808C"
                    }
                ]
            },
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "textBased": {},
                    "imageBased": {},
                    "textExtendedBadges": {
                        "badgeObject": [
                            {
                                "attributes": {
                                    "description": "",
                                    "shortDescription": "options available",
                                    "fontColor": "#7E808C",
                                    "iconId": "guiltfree/GF_Logo_android_3x"
                                }
                            }
                        ]
                    }
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "₹125 OFF",
                "subHeader": "ABOVE ₹249",
                "headerTypeV2": "HEADER_TYPE_V2_TOP_UP",
                "secondaryDiscountCallout": "+ EXTRA ₹75 OFF"
            },
            "loyaltyDiscoverPresentationInfo": {
                "logoCtx": {
                    "text": "BENEFITS",
                    "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                },
                "freedelMessage": "FREE DELIVERY"
            },
            "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {}
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "swiggy://menu?restaurant_id=395550",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
        }
    },
    {
        "info": {
            "id": "626553",
            "name": "La Pino'z Pizza",
            "cloudinaryImageId": "mkbgksj3ou3gsc7znsdd",
            "locality": "sector 10",
            "areaName": "Raj Nagar",
            "costForTwo": "₹400 for two",
            "cuisines": [
                "Pizzas",
                "Pastas",
                "Italian",
                "Desserts",
                "Beverages"
            ],
            "avgRating": 3.7,
            "feeDetails": {
                "restaurantId": "626553",
                "fees": [
                    {
                        "name": "BASE_DISTANCE",
                        "fee": 5600
                    },
                    {
                        "name": "BASE_TIME"
                    },
                    {
                        "name": "ANCILLARY_SURGE_FEE"
                    }
                ],
                "totalFee": 5600
            },
            "parentId": "4961",
            "avgRatingString": "3.7",
            "totalRatingsString": "1K+",
            "sla": {
                "deliveryTime": 28,
                "lastMileTravel": 4.9,
                "serviceability": "SERVICEABLE",
                "slaString": "28 mins",
                "lastMileTravelString": "4.9 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2023-08-04 04:30:00",
                "opened": true
            },
            "badges": {},
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "imageBased": {},
                    "textExtendedBadges": {},
                    "textBased": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "60% OFF",
                "subHeader": "UPTO ₹120"
            },
            "loyaltyDiscoverPresentationInfo": {
                "logoCtx": {
                    "text": "BENEFITS",
                    "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                },
                "freedelMessage": "FREE DELIVERY"
            },
            "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {}
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "swiggy://menu?restaurant_id=626553",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
        }
    },
    {
        "info": {
            "id": "57686",
            "name": "Subway",
            "cloudinaryImageId": "1ace5fa65eff3e1223feb696c956b38b",
            "locality": "Saviour Mall",
            "areaName": "La Gracia Mall",
            "costForTwo": "₹350 for two",
            "cuisines": [
                "Salads",
                "Snacks",
                "Desserts",
                "Beverages"
            ],
            "avgRating": 3.4,
            "feeDetails": {
                "restaurantId": "57686",
                "fees": [
                    {
                        "name": "BASE_DISTANCE",
                        "fee": 7600
                    },
                    {
                        "name": "BASE_TIME"
                    },
                    {
                        "name": "ANCILLARY_SURGE_FEE"
                    }
                ],
                "totalFee": 7600
            },
            "parentId": "2",
            "avgRatingString": "3.4",
            "totalRatingsString": "5K+",
            "sla": {
                "deliveryTime": 27,
                "lastMileTravel": 6.5,
                "serviceability": "SERVICEABLE",
                "slaString": "27 mins",
                "lastMileTravelString": "6.5 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2023-08-04 07:50:00",
                "opened": true
            },
            "badges": {},
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "textBased": {},
                    "imageBased": {},
                    "textExtendedBadges": {}
                }
            },
            "loyaltyDiscoverPresentationInfo": {
                "logoCtx": {
                    "text": "BENEFITS",
                    "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                },
                "freedelMessage": "FREE DELIVERY"
            },
            "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {}
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "swiggy://menu?restaurant_id=57686",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
        }
    },
    {
        "info": {
            "id": "306919",
            "name": "Ghar ka tadka",
            "cloudinaryImageId": "zoi1spzrb0htmaxzcckb",
            "locality": "sector 10",
            "areaName": "Raj Nagar",
            "costForTwo": "₹150 for two",
            "cuisines": [
                "Indian",
                "North Indian",
                "Chinese",
                "Home Food"
            ],
            "avgRating": 3.6,
            "veg": true,
            "feeDetails": {
                "restaurantId": "306919",
                "fees": [
                    {
                        "name": "BASE_DISTANCE",
                        "fee": 5600
                    },
                    {
                        "name": "BASE_TIME"
                    },
                    {
                        "name": "ANCILLARY_SURGE_FEE"
                    }
                ],
                "totalFee": 5600
            },
            "parentId": "8838",
            "avgRatingString": "3.6",
            "totalRatingsString": "500+",
            "promoted": true,
            "adTrackingId": "cid=7746290~p=8~eid=00000189-bd7e-d23f-0cfb-279200850840~srvts=1691101352511~45826",
            "sla": {
                "deliveryTime": 30,
                "lastMileTravel": 4.7,
                "serviceability": "SERVICEABLE",
                "slaString": "30 mins",
                "lastMileTravelString": "4.7 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2023-08-04 12:00:00",
                "opened": true
            },
            "badges": {
                "textExtendedBadges": [
                    {
                        "iconId": "guiltfree/GF_Logo_android_3x",
                        "shortDescription": "options available",
                        "fontColor": "#7E808C"
                    }
                ]
            },
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "textBased": {},
                    "imageBased": {},
                    "textExtendedBadges": {
                        "badgeObject": [
                            {
                                "attributes": {
                                    "shortDescription": "options available",
                                    "fontColor": "#7E808C",
                                    "iconId": "guiltfree/GF_Logo_android_3x",
                                    "description": ""
                                }
                            }
                        ]
                    }
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "60% OFF",
                "subHeader": "UPTO ₹120"
            },
            "loyaltyDiscoverPresentationInfo": {
                "logoCtx": {
                    "text": "BENEFITS",
                    "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                },
                "freedelMessage": "FREE DELIVERY"
            },
            "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {}
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "swiggy://menu?restaurant_id=306919",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
        }
    },
    {
        "info": {
            "id": "712135",
            "name": "Goli Vada Pav No.1",
            "cloudinaryImageId": "5bd0f232897bb15eae923593adcf80b4",
            "locality": "Panchsheel",
            "areaName": "Crossing Republic",
            "costForTwo": "₹200 for two",
            "cuisines": [
                "Snacks"
            ],
            "avgRating": 3.8,
            "feeDetails": {
                "restaurantId": "712135",
                "fees": [
                    {
                        "name": "BASE_DISTANCE",
                        "fee": 7600
                    },
                    {
                        "name": "BASE_TIME"
                    },
                    {
                        "name": "ANCILLARY_SURGE_FEE"
                    }
                ],
                "totalFee": 7600
            },
            "parentId": "3998",
            "avgRatingString": "3.8",
            "totalRatingsString": "50+",
            "sla": {
                "deliveryTime": 29,
                "lastMileTravel": 6.7,
                "serviceability": "SERVICEABLE",
                "slaString": "29 mins",
                "lastMileTravelString": "6.7 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2023-08-04 23:55:00",
                "opened": true
            },
            "badges": {},
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "textBased": {},
                    "imageBased": {},
                    "textExtendedBadges": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "50% OFF",
                "subHeader": "UPTO ₹100"
            },
            "loyaltyDiscoverPresentationInfo": {
                "logoCtx": {
                    "text": "BENEFITS",
                    "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                },
                "freedelMessage": "FREE DELIVERY"
            },
            "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {}
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "isNewlyOnboarded": true,
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "swiggy://menu?restaurant_id=712135",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
        }
    },
    {
        "info": {
            "id": "549819",
            "name": "Biryani Blues",
            "cloudinaryImageId": "sludnbblldmevxug95kt",
            "locality": "Rakesh Marg",
            "areaName": "Nehru Nagar",
            "costForTwo": "₹400 for two",
            "cuisines": [
                "Biryani",
                "Hyderabadi",
                "Lucknowi",
                "Kebabs",
                "Desserts",
                "Beverages"
            ],
            "avgRating": 4.3,
            "feeDetails": {
                "restaurantId": "549819",
                "fees": [
                    {
                        "name": "BASE_TIME"
                    },
                    {
                        "name": "BASE_DISTANCE",
                        "fee": 6600
                    },
                    {
                        "name": "ANCILLARY_SURGE_FEE"
                    }
                ],
                "totalFee": 6600
            },
            "parentId": "13813",
            "avgRatingString": "4.3",
            "totalRatingsString": "1K+",
            "sla": {
                "deliveryTime": 26,
                "lastMileTravel": 5,
                "serviceability": "SERVICEABLE",
                "slaString": "26 mins",
                "lastMileTravelString": "5.0 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2023-08-04 04:00:00",
                "opened": true
            },
            "badges": {
                "textExtendedBadges": [
                    {
                        "iconId": "guiltfree/GF_Logo_android_3x",
                        "shortDescription": "options available",
                        "fontColor": "#7E808C"
                    }
                ]
            },
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "imageBased": {},
                    "textExtendedBadges": {
                        "badgeObject": [
                            {
                                "attributes": {
                                    "description": "",
                                    "shortDescription": "options available",
                                    "fontColor": "#7E808C",
                                    "iconId": "guiltfree/GF_Logo_android_3x"
                                }
                            }
                        ]
                    },
                    "textBased": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "₹125 OFF",
                "subHeader": "ABOVE ₹249",
                "headerTypeV2": "HEADER_TYPE_V2_TOP_UP",
                "secondaryDiscountCallout": "+ EXTRA ₹75 OFF"
            },
            "loyaltyDiscoverPresentationInfo": {
                "logoCtx": {
                    "text": "BENEFITS",
                    "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                },
                "freedelMessage": "FREE DELIVERY"
            },
            "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {}
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "swiggy://menu?restaurant_id=549819",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
        }
    },
    {
        "info": {
            "id": "393206",
            "name": "The Urban Dhaba",
            "cloudinaryImageId": "bl7jnqqltreqermbsih7",
            "locality": "Panchsheel Square Mall",
            "areaName": "Nai Basti Dundahera",
            "costForTwo": "₹150 for two",
            "cuisines": [
                "North Indian"
            ],
            "avgRating": 3.7,
            "veg": true,
            "feeDetails": {
                "restaurantId": "393206",
                "fees": [
                    {
                        "name": "BASE_TIME"
                    },
                    {
                        "name": "BASE_DISTANCE",
                        "fee": 7600
                    },
                    {
                        "name": "ANCILLARY_SURGE_FEE"
                    }
                ],
                "totalFee": 7600
            },
            "parentId": "8749",
            "avgRatingString": "3.7",
            "totalRatingsString": "100+",
            "promoted": true,
            "adTrackingId": "cid=7746286~p=9~eid=00000189-bd7e-d23f-0cfb-27930085091e~srvts=1691101352511~45826",
            "sla": {
                "deliveryTime": 38,
                "lastMileTravel": 6.6,
                "serviceability": "SERVICEABLE",
                "slaString": "38 mins",
                "lastMileTravelString": "6.6 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2023-08-04 23:59:00",
                "opened": true
            },
            "badges": {
                "textExtendedBadges": [
                    {
                        "iconId": "guiltfree/GF_Logo_android_3x",
                        "shortDescription": "options available",
                        "fontColor": "#7E808C"
                    }
                ]
            },
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "imageBased": {},
                    "textExtendedBadges": {
                        "badgeObject": [
                            {
                                "attributes": {
                                    "iconId": "guiltfree/GF_Logo_android_3x",
                                    "description": "",
                                    "shortDescription": "options available",
                                    "fontColor": "#7E808C"
                                }
                            }
                        ]
                    },
                    "textBased": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "₹125 OFF",
                "subHeader": "ABOVE ₹249",
                "headerTypeV2": "HEADER_TYPE_V2_TOP_UP",
                "secondaryDiscountCallout": "+ EXTRA ₹75 OFF"
            },
            "loyaltyDiscoverPresentationInfo": {
                "logoCtx": {
                    "text": "BENEFITS",
                    "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                },
                "freedelMessage": "FREE DELIVERY"
            },
            "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {}
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "swiggy://menu?restaurant_id=393206",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
        }
    },
    {
        "info": {
            "id": "346573",
            "name": "Apni Veg Rasoi",
            "cloudinaryImageId": "oimdnn8q65veuj9d3vx6",
            "locality": "RDC\xa0Concrete (India) Pvt Ltd",
            "areaName": "Raj Nagar",
            "costForTwo": "₹150 for two",
            "cuisines": [
                "North Indian",
                "Chinese"
            ],
            "avgRating": 3.8,
            "veg": true,
            "feeDetails": {
                "restaurantId": "346573",
                "fees": [
                    {
                        "name": "BASE_DISTANCE",
                        "fee": 5600
                    },
                    {
                        "name": "BASE_TIME"
                    },
                    {
                        "name": "ANCILLARY_SURGE_FEE"
                    }
                ],
                "totalFee": 5600
            },
            "parentId": "22092",
            "avgRatingString": "3.8",
            "totalRatingsString": "500+",
            "sla": {
                "deliveryTime": 30,
                "lastMileTravel": 4.7,
                "serviceability": "SERVICEABLE",
                "slaString": "30 mins",
                "lastMileTravelString": "4.7 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2023-08-04 06:59:00",
                "opened": true
            },
            "badges": {
                "textExtendedBadges": [
                    {
                        "iconId": "guiltfree/GF_Logo_android_3x",
                        "shortDescription": "options available",
                        "fontColor": "#7E808C"
                    }
                ]
            },
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "textBased": {},
                    "imageBased": {},
                    "textExtendedBadges": {
                        "badgeObject": [
                            {
                                "attributes": {
                                    "shortDescription": "options available",
                                    "fontColor": "#7E808C",
                                    "iconId": "guiltfree/GF_Logo_android_3x",
                                    "description": ""
                                }
                            }
                        ]
                    }
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "₹125 OFF",
                "subHeader": "ABOVE ₹249",
                "headerTypeV2": "HEADER_TYPE_V2_TOP_UP",
                "secondaryDiscountCallout": "+ EXTRA ₹75 OFF"
            },
            "loyaltyDiscoverPresentationInfo": {
                "logoCtx": {
                    "text": "BENEFITS",
                    "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                },
                "freedelMessage": "FREE DELIVERY"
            },
            "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {}
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "swiggy://menu?restaurant_id=346573",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
        }
    },
    {
        "info": {
            "id": "62686",
            "name": "The Pizza Cafe",
            "cloudinaryImageId": "i5oohkmwdu81k45yqz89",
            "locality": "Crossing Republik",
            "areaName": "Shastri Nagar",
            "costForTwo": "₹250 for two",
            "cuisines": [
                "Continental",
                "Italian"
            ],
            "avgRating": 3.5,
            "veg": true,
            "feeDetails": {
                "restaurantId": "62686",
                "fees": [
                    {
                        "name": "BASE_DISTANCE",
                        "fee": 4800
                    },
                    {
                        "name": "BASE_TIME"
                    },
                    {
                        "name": "ANCILLARY_SURGE_FEE"
                    }
                ],
                "totalFee": 4800
            },
            "parentId": "15353",
            "avgRatingString": "3.5",
            "totalRatingsString": "5K+",
            "sla": {
                "deliveryTime": 25,
                "lastMileTravel": 3.5,
                "serviceability": "SERVICEABLE",
                "slaString": "25 mins",
                "lastMileTravelString": "3.5 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2023-08-04 04:00:00",
                "opened": true
            },
            "badges": {},
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "textExtendedBadges": {},
                    "textBased": {},
                    "imageBased": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "₹125 OFF",
                "subHeader": "ABOVE ₹249",
                "headerTypeV2": "HEADER_TYPE_V2_TOP_UP",
                "secondaryDiscountCallout": "+ EXTRA ₹75 OFF"
            },
            "loyaltyDiscoverPresentationInfo": {
                "logoCtx": {
                    "text": "BENEFITS",
                    "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                },
                "freedelMessage": "FREE DELIVERY"
            },
            "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {}
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "swiggy://menu?restaurant_id=62686",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
        }
    },
    {
        "info": {
            "id": "231462",
            "name": "Mr. Hungry",
            "cloudinaryImageId": "cnt2wxgqixgze1zu3u6s",
            "locality": "sector 10",
            "areaName": "Raj Nagar",
            "costForTwo": "₹150 for two",
            "cuisines": [
                "North Indian",
                "Indian",
                "Asian",
                "Chinese",
                "Snacks",
                "Thalis"
            ],
            "avgRating": 3.6,
            "veg": true,
            "feeDetails": {
                "restaurantId": "231462",
                "fees": [
                    {
                        "name": "BASE_TIME"
                    },
                    {
                        "name": "BASE_DISTANCE",
                        "fee": 5600
                    },
                    {
                        "name": "ANCILLARY_SURGE_FEE"
                    }
                ],
                "totalFee": 5600
            },
            "parentId": "387768",
            "avgRatingString": "3.6",
            "totalRatingsString": "1K+",
            "promoted": true,
            "adTrackingId": "cid=7746291~p=10~eid=00000189-bd7e-d23f-0cfb-279400850a08~srvts=1691101352511~45826",
            "sla": {
                "deliveryTime": 32,
                "lastMileTravel": 4.7,
                "serviceability": "SERVICEABLE",
                "slaString": "32 mins",
                "lastMileTravelString": "4.7 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2023-08-04 06:59:00",
                "opened": true
            },
            "badges": {},
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "textBased": {},
                    "imageBased": {},
                    "textExtendedBadges": {}
                }
            },
            "aggregatedDiscountInfoV3": {},
            "loyaltyDiscoverPresentationInfo": {
                "logoCtx": {
                    "text": "BENEFITS",
                    "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                },
                "freedelMessage": "FREE DELIVERY"
            },
            "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {}
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "swiggy://menu?restaurant_id=231462",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
        }
    },
    {
        "info": {
            "id": "333500",
            "name": "Pizzalicious",
            "cloudinaryImageId": "cl4nbhtzavj6nw8s3i1d",
            "locality": "A Block",
            "areaName": "Shastri Nagar",
            "costForTwo": "₹250 for two",
            "cuisines": [
                "Continental",
                "Italian"
            ],
            "avgRating": 3.4,
            "veg": true,
            "feeDetails": {
                "restaurantId": "333500",
                "fees": [
                    {
                        "name": "BASE_DISTANCE",
                        "fee": 4800
                    },
                    {
                        "name": "BASE_TIME"
                    },
                    {
                        "name": "ANCILLARY_SURGE_FEE"
                    }
                ],
                "totalFee": 4800
            },
            "parentId": "4204",
            "avgRatingString": "3.4",
            "totalRatingsString": "100+",
            "sla": {
                "deliveryTime": 27,
                "lastMileTravel": 3.5,
                "serviceability": "SERVICEABLE",
                "slaString": "27 mins",
                "lastMileTravelString": "3.5 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2023-08-04 04:00:00",
                "opened": true
            },
            "badges": {},
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "textBased": {},
                    "imageBased": {},
                    "textExtendedBadges": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "50% OFF",
                "subHeader": "UPTO ₹100"
            },
            "loyaltyDiscoverPresentationInfo": {
                "logoCtx": {
                    "text": "BENEFITS",
                    "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                },
                "freedelMessage": "FREE DELIVERY"
            },
            "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {}
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "swiggy://menu?restaurant_id=333500",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
        }
    },
    {
        "info": {
            "id": "333498",
            "name": "Pizza Plus",
            "cloudinaryImageId": "tlth5ulwbhyfhegkeba0",
            "locality": "A Block",
            "areaName": "Raj Nagar",
            "costForTwo": "₹250 for two",
            "cuisines": [
                "Continental",
                "Italian"
            ],
            "avgRating": 3.2,
            "feeDetails": {
                "restaurantId": "333498",
                "fees": [
                    {
                        "name": "BASE_DISTANCE",
                        "fee": 4800
                    },
                    {
                        "name": "BASE_TIME"
                    },
                    {
                        "name": "ANCILLARY_SURGE_FEE"
                    }
                ],
                "totalFee": 4800
            },
            "parentId": "14111",
            "avgRatingString": "3.2",
            "totalRatingsString": "100+",
            "sla": {
                "deliveryTime": 26,
                "lastMileTravel": 3.5,
                "serviceability": "SERVICEABLE",
                "slaString": "26 mins",
                "lastMileTravelString": "3.5 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2023-08-04 04:00:00",
                "opened": true
            },
            "badges": {},
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "textBased": {},
                    "imageBased": {},
                    "textExtendedBadges": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "₹125 OFF",
                "subHeader": "ABOVE ₹249",
                "headerTypeV2": "HEADER_TYPE_V2_TOP_UP",
                "secondaryDiscountCallout": "+ EXTRA ₹75 OFF"
            },
            "loyaltyDiscoverPresentationInfo": {
                "logoCtx": {
                    "text": "BENEFITS",
                    "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                },
                "freedelMessage": "FREE DELIVERY"
            },
            "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {}
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "swiggy://menu?restaurant_id=333498",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
        }
    },
    {
        "info": {
            "id": "393210",
            "name": "Second Wife Restaurant",
            "cloudinaryImageId": "ptj4nzbtupyzljeil8tu",
            "locality": "Panchsheel Square Mall",
            "areaName": "crossing republic",
            "costForTwo": "₹150 for two",
            "cuisines": [
                "North Indian"
            ],
            "avgRating": 3.8,
            "veg": true,
            "feeDetails": {
                "restaurantId": "393210",
                "fees": [
                    {
                        "name": "BASE_TIME"
                    },
                    {
                        "name": "BASE_DISTANCE",
                        "fee": 7600
                    },
                    {
                        "name": "ANCILLARY_SURGE_FEE"
                    }
                ],
                "totalFee": 7600
            },
            "parentId": "13721",
            "avgRatingString": "3.8",
            "totalRatingsString": "100+",
            "promoted": true,
            "adTrackingId": "cid=7746298~p=11~eid=00000189-bd7e-d23f-0cfb-279500850b40~srvts=1691101352511~45826",
            "sla": {
                "deliveryTime": 36,
                "lastMileTravel": 6.6,
                "serviceability": "SERVICEABLE",
                "slaString": "36 mins",
                "lastMileTravelString": "6.6 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2023-08-04 23:59:00",
                "opened": true
            },
            "badges": {},
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "textBased": {},
                    "imageBased": {},
                    "textExtendedBadges": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "₹125 OFF",
                "subHeader": "ABOVE ₹249",
                "headerTypeV2": "HEADER_TYPE_V2_TOP_UP",
                "secondaryDiscountCallout": "+ EXTRA ₹75 OFF"
            },
            "loyaltyDiscoverPresentationInfo": {
                "logoCtx": {
                    "text": "BENEFITS",
                    "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                },
                "freedelMessage": "FREE DELIVERY"
            },
            "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {}
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "swiggy://menu?restaurant_id=393210",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
        }
    },
    {
        "info": {
            "id": "333510",
            "name": "Pizza Studio",
            "cloudinaryImageId": "v1yqxlovkmz0v4kjodoh",
            "locality": "A Block",
            "areaName": "Shastri Nagar",
            "costForTwo": "₹250 for two",
            "cuisines": [
                "Continental",
                "Italian"
            ],
            "avgRating": 3.1,
            "feeDetails": {
                "restaurantId": "333510",
                "fees": [
                    {
                        "name": "BASE_TIME"
                    },
                    {
                        "name": "BASE_DISTANCE",
                        "fee": 4800
                    },
                    {
                        "name": "ANCILLARY_SURGE_FEE"
                    }
                ],
                "totalFee": 4800
            },
            "parentId": "8628",
            "avgRatingString": "3.1",
            "totalRatingsString": "100+",
            "sla": {
                "deliveryTime": 29,
                "lastMileTravel": 3.5,
                "serviceability": "SERVICEABLE",
                "slaString": "29 mins",
                "lastMileTravelString": "3.5 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2023-08-04 04:00:00",
                "opened": true
            },
            "badges": {},
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "textExtendedBadges": {},
                    "textBased": {},
                    "imageBased": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "60% OFF",
                "subHeader": "UPTO ₹120"
            },
            "loyaltyDiscoverPresentationInfo": {
                "logoCtx": {
                    "text": "BENEFITS",
                    "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                },
                "freedelMessage": "FREE DELIVERY"
            },
            "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {}
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "swiggy://menu?restaurant_id=333510",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
        }
    },
    {
        "info": {
            "id": "75230",
            "name": "Chawla's Tandoori Junction",
            "cloudinaryImageId": "vdgdk2ploooihjebtcxs",
            "locality": "RDC\xa0Concrete (India) Pvt Ltd",
            "areaName": "Raj Nagar",
            "costForTwo": "₹500 for two",
            "cuisines": [
                "Chinese",
                "North Indian"
            ],
            "avgRating": 3.9,
            "feeDetails": {
                "restaurantId": "75230",
                "fees": [
                    {
                        "name": "BASE_DISTANCE",
                        "fee": 6600
                    },
                    {
                        "name": "BASE_TIME"
                    },
                    {
                        "name": "ANCILLARY_SURGE_FEE"
                    }
                ],
                "totalFee": 6600
            },
            "parentId": "58971",
            "avgRatingString": "3.9",
            "totalRatingsString": "1K+",
            "sla": {
                "deliveryTime": 36,
                "lastMileTravel": 5,
                "serviceability": "SERVICEABLE",
                "slaString": "36 mins",
                "lastMileTravelString": "5.0 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2023-08-04 04:00:00",
                "opened": true
            },
            "badges": {},
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "textBased": {},
                    "imageBased": {},
                    "textExtendedBadges": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "30% OFF",
                "subHeader": "UPTO ₹75"
            },
            "loyaltyDiscoverPresentationInfo": {
                "logoCtx": {
                    "text": "BENEFITS",
                    "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                },
                "freedelMessage": "FREE DELIVERY"
            },
            "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {}
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "swiggy://menu?restaurant_id=75230",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
        }
    },
    {
        "info": {
            "id": "464100",
            "name": "Glocal Bhoj",
            "cloudinaryImageId": "lwocw3p3m31lcjprwges",
            "locality": "Panchsheel Square Mall\n",
            "areaName": "crossing republic",
            "costForTwo": "₹150 for two",
            "cuisines": [
                "Indian"
            ],
            "avgRating": 3.7,
            "veg": true,
            "feeDetails": {
                "restaurantId": "464100",
                "fees": [
                    {
                        "name": "BASE_DISTANCE",
                        "fee": 7600
                    },
                    {
                        "name": "BASE_TIME"
                    },
                    {
                        "name": "ANCILLARY_SURGE_FEE"
                    }
                ],
                "totalFee": 7600
            },
            "parentId": "11987",
            "avgRatingString": "3.7",
            "totalRatingsString": "100+",
            "promoted": true,
            "adTrackingId": "cid=7746273~p=12~eid=00000189-bd7e-d23f-0cfb-279600850c5e~srvts=1691101352511~45826",
            "sla": {
                "deliveryTime": 37,
                "lastMileTravel": 6.7,
                "serviceability": "SERVICEABLE",
                "slaString": "37 mins",
                "lastMileTravelString": "6.7 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2023-08-04 23:59:00",
                "opened": true
            },
            "badges": {},
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "textExtendedBadges": {},
                    "textBased": {},
                    "imageBased": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "₹125 OFF",
                "subHeader": "ABOVE ₹249",
                "headerTypeV2": "HEADER_TYPE_V2_TOP_UP",
                "secondaryDiscountCallout": "+ EXTRA ₹75 OFF"
            },
            "loyaltyDiscoverPresentationInfo": {
                "logoCtx": {
                    "text": "BENEFITS",
                    "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                },
                "freedelMessage": "FREE DELIVERY"
            },
            "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {}
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "swiggy://menu?restaurant_id=464100",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
        }
    },
    {
        "info": {
            "id": "736179",
            "name": "Olio - The Wood Fired Pizzeria",
            "cloudinaryImageId": "4b44c7921b1b6073a4ffa58b38f8def1",
            "locality": "Gautam Buddha Nagar",
            "areaName": "Shahberi",
            "costForTwo": "₹300 for two",
            "cuisines": [
                "Pizzas",
                "Pastas",
                "Fast Food",
                "Snacks",
                "Beverages"
            ],
            "avgRating": 4.4,
            "feeDetails": {
                "restaurantId": "736179",
                "fees": [
                    {
                        "name": "BASE_DISTANCE",
                        "fee": 7600
                    },
                    {
                        "name": "BASE_TIME"
                    },
                    {
                        "name": "ANCILLARY_SURGE_FEE"
                    }
                ],
                "totalFee": 7600
            },
            "parentId": "11633",
            "avgRatingString": "4.4",
            "totalRatingsString": "20+",
            "sla": {
                "deliveryTime": 35,
                "lastMileTravel": 6.9,
                "serviceability": "SERVICEABLE",
                "slaString": "35 mins",
                "lastMileTravelString": "6.9 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2023-08-04 05:00:00",
                "opened": true
            },
            "badges": {
                "imageBadges": [
                    {
                        "imageId": "newg.png",
                        "description": "Gourmet"
                    }
                ]
            },
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "textBased": {},
                    "imageBased": {
                        "badgeObject": [
                            {
                                "attributes": {
                                    "imageId": "newg.png",
                                    "description": "Gourmet"
                                }
                            }
                        ]
                    },
                    "textExtendedBadges": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "₹125 OFF",
                "subHeader": "ABOVE ₹249",
                "discountTag": "FLAT DEAL"
            },
            "loyaltyDiscoverPresentationInfo": {
                "logoCtx": {
                    "text": "BENEFITS",
                    "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                },
                "freedelMessage": "FREE DELIVERY"
            },
            "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {}
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "isNewlyOnboarded": true,
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "swiggy://menu?restaurant_id=736179",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
        }
    },
    {
        "info": {
            "id": "376533",
            "name": "Veg Potli",
            "cloudinaryImageId": "nu921709bssfqaolhing",
            "locality": "RDC\xa0Concrete (India) Pvt Ltd",
            "areaName": "Raj Nagar",
            "costForTwo": "₹150 for two",
            "cuisines": [
                "Indian"
            ],
            "avgRating": 3.8,
            "veg": true,
            "feeDetails": {
                "restaurantId": "376533",
                "fees": [
                    {
                        "name": "BASE_DISTANCE",
                        "fee": 5600
                    },
                    {
                        "name": "BASE_TIME"
                    },
                    {
                        "name": "ANCILLARY_SURGE_FEE"
                    }
                ],
                "totalFee": 5600
            },
            "parentId": "21992",
            "avgRatingString": "3.8",
            "totalRatingsString": "100+",
            "promoted": true,
            "adTrackingId": "cid=7746303~p=13~eid=00000189-bd7e-d23f-0cfb-279700850d03~srvts=1691101352511~45826",
            "sla": {
                "deliveryTime": 32,
                "lastMileTravel": 4.7,
                "serviceability": "SERVICEABLE",
                "slaString": "32 mins",
                "lastMileTravelString": "4.7 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2023-08-04 06:59:00",
                "opened": true
            },
            "badges": {},
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "textBased": {},
                    "imageBased": {},
                    "textExtendedBadges": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "₹125 OFF",
                "subHeader": "ABOVE ₹249",
                "headerTypeV2": "HEADER_TYPE_V2_TOP_UP",
                "secondaryDiscountCallout": "+ EXTRA ₹75 OFF"
            },
            "loyaltyDiscoverPresentationInfo": {
                "logoCtx": {
                    "text": "BENEFITS",
                    "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                },
                "freedelMessage": "FREE DELIVERY"
            },
            "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {}
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "swiggy://menu?restaurant_id=376533",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
        }
    },
    {
        "info": {
            "id": "553993",
            "name": "The Brooklyn Creamery - Healthy Ice Cream",
            "cloudinaryImageId": "b1b35780a9b1dfeb26d680506d494eaa",
            "locality": "Panchsheel Square Mall",
            "areaName": "crossing republic",
            "costForTwo": "₹200 for two",
            "cuisines": [
                "Desserts",
                "Ice Cream",
                "Healthy Food"
            ],
            "avgRating": 4,
            "feeDetails": {
                "restaurantId": "553993",
                "fees": [
                    {
                        "name": "BASE_DISTANCE",
                        "fee": 7600
                    },
                    {
                        "name": "BASE_TIME"
                    },
                    {
                        "name": "ANCILLARY_SURGE_FEE"
                    }
                ],
                "totalFee": 7600
            },
            "parentId": "236673",
            "avgRatingString": "4.0",
            "totalRatingsString": "20+",
            "sla": {
                "deliveryTime": 33,
                "lastMileTravel": 6.6,
                "serviceability": "SERVICEABLE",
                "slaString": "33 mins",
                "lastMileTravelString": "6.6 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2023-08-11 00:00:00",
                "opened": true
            },
            "badges": {
                "textExtendedBadges": [
                    {
                        "iconId": "guiltfree/GF_Logo_android_3x",
                        "shortDescription": "brand",
                        "fontColor": "#7E808C"
                    }
                ]
            },
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "textBased": {},
                    "imageBased": {},
                    "textExtendedBadges": {
                        "badgeObject": [
                            {
                                "attributes": {
                                    "shortDescription": "brand",
                                    "fontColor": "#7E808C",
                                    "iconId": "guiltfree/GF_Logo_android_3x",
                                    "description": ""
                                }
                            }
                        ]
                    }
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "60% OFF",
                "subHeader": "UPTO ₹120"
            },
            "loyaltyDiscoverPresentationInfo": {
                "logoCtx": {
                    "text": "BENEFITS",
                    "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                },
                "freedelMessage": "FREE DELIVERY"
            },
            "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {}
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "swiggy://menu?restaurant_id=553993",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
        }
    },
    {
        "info": {
            "id": "200747",
            "name": "Veer Ji Malai Chaap Wale",
            "cloudinaryImageId": "ot55vxhy3ng0eocbwlqb",
            "locality": "Panchsheel Square Mall",
            "areaName": "crossing republic",
            "costForTwo": "₹200 for two",
            "cuisines": [
                "North Indian"
            ],
            "avgRating": 3.6,
            "feeDetails": {
                "restaurantId": "200747",
                "fees": [
                    {
                        "name": "BASE_DISTANCE",
                        "fee": 7600
                    },
                    {
                        "name": "BASE_TIME"
                    },
                    {
                        "name": "ANCILLARY_SURGE_FEE"
                    }
                ],
                "totalFee": 7600
            },
            "parentId": "12056",
            "avgRatingString": "3.6",
            "totalRatingsString": "1K+",
            "sla": {
                "deliveryTime": 31,
                "lastMileTravel": 6.7,
                "serviceability": "SERVICEABLE",
                "slaString": "31 mins",
                "lastMileTravelString": "6.7 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2023-08-04 04:00:00",
                "opened": true
            },
            "badges": {},
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "textBased": {},
                    "imageBased": {},
                    "textExtendedBadges": {}
                }
            },
            "loyaltyDiscoverPresentationInfo": {
                "logoCtx": {
                    "text": "BENEFITS",
                    "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                },
                "freedelMessage": "FREE DELIVERY"
            },
            "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {}
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "swiggy://menu?restaurant_id=200747",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
        }
    },
    {
        "info": {
            "id": "736180",
            "name": "Crusto's - Cheese Burst Pizza",
            "cloudinaryImageId": "2e7493543bd1785e8196144625a5b20b",
            "locality": "Gautam Buddha Nagar",
            "areaName": "Shahberi",
            "costForTwo": "₹300 for two",
            "cuisines": [
                "Pizzas",
                "Pastas",
                "Fast Food",
                "Snacks",
                "Beverages"
            ],
            "avgRating": 5,
            "feeDetails": {
                "restaurantId": "736180",
                "fees": [
                    {
                        "name": "BASE_DISTANCE",
                        "fee": 7600
                    },
                    {
                        "name": "BASE_TIME"
                    },
                    {
                        "name": "ANCILLARY_SURGE_FEE"
                    }
                ],
                "totalFee": 7600
            },
            "parentId": "268955",
            "avgRatingString": "5.0",
            "totalRatingsString": "20+",
            "sla": {
                "deliveryTime": 32,
                "lastMileTravel": 6.9,
                "serviceability": "SERVICEABLE",
                "slaString": "32 mins",
                "lastMileTravelString": "6.9 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2023-08-04 05:00:00",
                "opened": true
            },
            "badges": {},
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "textBased": {},
                    "imageBased": {},
                    "textExtendedBadges": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "₹125 OFF",
                "subHeader": "ABOVE ₹249",
                "discountTag": "FLAT DEAL"
            },
            "loyaltyDiscoverPresentationInfo": {
                "logoCtx": {
                    "text": "BENEFITS",
                    "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                },
                "freedelMessage": "FREE DELIVERY"
            },
            "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {}
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "isNewlyOnboarded": true,
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "swiggy://menu?restaurant_id=736180",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
        }
    },
    {
        "info": {
            "id": "516337",
            "name": "Samosa Party",
            "cloudinaryImageId": "eywohwrrwky4rqmeyc3f",
            "locality": "High Street",
            "areaName": "crossing republic",
            "costForTwo": "₹150 for two",
            "cuisines": [
                "Fast Food",
                "Snacks",
                "Beverages",
                "Chaat",
                "North Indian",
                "Street Food",
                "Sweets",
                "Desserts",
                "Punjabi",
                "Bakery"
            ],
            "avgRating": 4.1,
            "feeDetails": {
                "restaurantId": "516337",
                "fees": [
                    {
                        "name": "BASE_TIME"
                    },
                    {
                        "name": "BASE_DISTANCE",
                        "fee": 7600
                    },
                    {
                        "name": "ANCILLARY_SURGE_FEE"
                    }
                ],
                "totalFee": 7600
            },
            "parentId": "6364",
            "avgRatingString": "4.1",
            "totalRatingsString": "1K+",
            "sla": {
                "deliveryTime": 26,
                "lastMileTravel": 6.6,
                "serviceability": "SERVICEABLE",
                "slaString": "26 mins",
                "lastMileTravelString": "6.6 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2023-08-04 05:59:00",
                "opened": true
            },
            "badges": {
                "textExtendedBadges": [
                    {
                        "iconId": "guiltfree/GF_Logo_android_3x",
                        "shortDescription": "options available",
                        "fontColor": "#7E808C"
                    }
                ]
            },
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "textExtendedBadges": {
                        "badgeObject": [
                            {
                                "attributes": {
                                    "shortDescription": "options available",
                                    "fontColor": "#7E808C",
                                    "iconId": "guiltfree/GF_Logo_android_3x",
                                    "description": ""
                                }
                            }
                        ]
                    },
                    "textBased": {},
                    "imageBased": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "10% OFF",
                "subHeader": "UPTO ₹40"
            },
            "loyaltyDiscoverPresentationInfo": {
                "logoCtx": {
                    "text": "BENEFITS",
                    "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                },
                "freedelMessage": "FREE DELIVERY"
            },
            "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {}
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "swiggy://menu?restaurant_id=516337",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
        }
    }
];
var $df5baff8fd88aa24$export$2e2bcd8739ae039 = $df5baff8fd88aa24$var$resList;




var $a45998a327f72e36$var$RestrauntCard = function(param) {
    var cloudinaryImageId = param.cloudinaryImageId, name = param.name, cuisines = param.cuisines, costForTwo = param.costForTwo, avgRatingString = param.avgRatingString;
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        className: "res-card",
        style: {
            backgroundColor: "#f0f0f0"
        },
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("img", {
                className: "res-img",
                src: (0, $1ad00fd5a6f8ced9$export$3c67ec6258c4a827) + cloudinaryImageId
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("h3", {
                children: name
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("h4", {
                children: cuisines.join(",")
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("h4", {
                children: [
                    " ",
                    avgRatingString,
                    " star ⭐"
                ]
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("h4", {
                children: [
                    costForTwo,
                    " \uD83D\uDCB8\uD83D\uDCB8"
                ]
            })
        ]
    });
};
var $a45998a327f72e36$export$2e2bcd8739ae039 = $a45998a327f72e36$var$RestrauntCard;




var $6d7015cc26664087$var$Shimmer = function() {
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        className: "shimmer-container",
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "shimmer-card"
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "shimmer-card"
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "shimmer-card"
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "shimmer-card"
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "shimmer-card"
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "shimmer-card"
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "shimmer-card"
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "shimmer-card"
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "shimmer-card"
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "shimmer-card"
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "shimmer-card"
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "shimmer-card"
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "shimmer-card"
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "shimmer-card"
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "shimmer-card"
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "shimmer-card"
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "shimmer-card"
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "shimmer-card"
            })
        ]
    });
};
var $6d7015cc26664087$export$2e2bcd8739ae039 = $6d7015cc26664087$var$Shimmer;



var $2329a7d01fd643e5$var$Body = function() {
    var _useState = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)((0, $dQFEZ.useState)([]), 2), listOfRestraunt = _useState[0], setlistOfRestraunt = _useState[1];
    var _useState1 = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)((0, $dQFEZ.useState)((0, $df5baff8fd88aa24$export$2e2bcd8739ae039)), 2), filteredRestraunts = _useState1[0], setfilteredRestraunts = _useState1[1];
    var _useState2 = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)((0, $dQFEZ.useState)(""), 2), searchText = _useState2[0], setsearchText = _useState2[1];
    (0, $dQFEZ.useEffect)(function() {
        fetchData();
    }, []);
    var fetchData = function() {
        var _ref = (0, $baf9b2a64fedef68$export$7c398597f8905a1)(function() {
            var data, json, resData;
            function checkJsonData(jsonData) {
                return _checkJsonData.apply(this, arguments);
            }
            function _checkJsonData() {
                _checkJsonData = (0, $baf9b2a64fedef68$export$7c398597f8905a1)(function(jsonData) {
                    var _jsonData_data, i, _json_data_cards_i, _json_data, _json_data_cards_i_card, _json_data_cards_i_card_card, _json_data_cards_i_card_card_gridElements, _json_data_cards_i_card_card_gridElements_infoWithStyle, checkData;
                    return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                        for(i = 0; i < (jsonData === null || jsonData === void 0 ? void 0 : (_jsonData_data = jsonData.data) === null || _jsonData_data === void 0 ? void 0 : _jsonData_data.cards.length); i++){
                            ;
                            checkData = (_json_data_cards_i = json === null || json === void 0 ? void 0 : (_json_data = json.data) === null || _json_data === void 0 ? void 0 : _json_data.cards[i]) === null || _json_data_cards_i === void 0 ? void 0 : (_json_data_cards_i_card = _json_data_cards_i.card) === null || _json_data_cards_i_card === void 0 ? void 0 : (_json_data_cards_i_card_card = _json_data_cards_i_card.card) === null || _json_data_cards_i_card_card === void 0 ? void 0 : (_json_data_cards_i_card_card_gridElements = _json_data_cards_i_card_card.gridElements) === null || _json_data_cards_i_card_card_gridElements === void 0 ? void 0 : (_json_data_cards_i_card_card_gridElements_infoWithStyle = _json_data_cards_i_card_card_gridElements.infoWithStyle) === null || _json_data_cards_i_card_card_gridElements_infoWithStyle === void 0 ? void 0 : _json_data_cards_i_card_card_gridElements_infoWithStyle.restaurants;
                            // if checkData is not undefined then return it
                            if (checkData !== undefined) return [
                                2,
                                checkData
                            ];
                        }
                        return [
                            2
                        ];
                    });
                });
                return _checkJsonData.apply(this, arguments);
            }
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch((0, $1ad00fd5a6f8ced9$export$28758bffe9e46c7e))
                        ];
                    case 1:
                        data = _state.sent();
                        return [
                            4,
                            data.json()
                        ];
                    case 2:
                        json = _state.sent();
                        return [
                            4,
                            checkJsonData(json)
                        ];
                    case 3:
                        resData = _state.sent();
                        setfilteredRestraunts(resData);
                        setlistOfRestraunt(resData);
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchData() {
            return _ref.apply(this, arguments);
        };
    }();
    var updateResList = function(i, card) {
        var _card_card, _card_card_card, _card_card_card_gridElements, _card_card_card_gridElements_infoWithStyle, _card_card1, _card_card_card1, _card_card_card_gridElements1, _card_card_card_gridElements_infoWithStyle1;
        setlistOfRestraunt((_card_card = card.card) === null || _card_card === void 0 ? void 0 : (_card_card_card = _card_card.card) === null || _card_card_card === void 0 ? void 0 : (_card_card_card_gridElements = _card_card_card.gridElements) === null || _card_card_card_gridElements === void 0 ? void 0 : (_card_card_card_gridElements_infoWithStyle = _card_card_card_gridElements.infoWithStyle) === null || _card_card_card_gridElements_infoWithStyle === void 0 ? void 0 : _card_card_card_gridElements_infoWithStyle.restaurants);
        setfilteredRestraunts((_card_card1 = card.card) === null || _card_card1 === void 0 ? void 0 : (_card_card_card1 = _card_card1.card) === null || _card_card_card1 === void 0 ? void 0 : (_card_card_card_gridElements1 = _card_card_card1.gridElements) === null || _card_card_card_gridElements1 === void 0 ? void 0 : (_card_card_card_gridElements_infoWithStyle1 = _card_card_card_gridElements1.infoWithStyle) === null || _card_card_card_gridElements_infoWithStyle1 === void 0 ? void 0 : _card_card_card_gridElements_infoWithStyle1.restaurants);
    };
    return (listOfRestraunt === null || listOfRestraunt === void 0 ? void 0 : listOfRestraunt.length) === 0 ? /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $6d7015cc26664087$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        className: "body",
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                className: "filter",
                children: [
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                        className: "search",
                        children: [
                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("input", {
                                type: "text",
                                className: "search-box",
                                value: searchText,
                                onChange: function(e) {
                                    setsearchText(e.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("button", {
                                className: "search-btn",
                                onClick: function() {
                                    var filteredRestraunts = listOfRestraunt.filter(function(res) {
                                        return res.info.name.toLowerCase().includes(searchText.toLowerCase());
                                    });
                                    setfilteredRestraunts(filteredRestraunts);
                                },
                                children: " Search"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("button", {
                        className: "filter-btn",
                        onClick: function() {
                            var filteredList = listOfRestraunt.filter(function(res) {
                                return res.info.avgRating > 4;
                            });
                            setfilteredRestraunts(filteredList);
                        },
                        children: "⭐⭐ TOP RATED ⭐⭐"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "res-container",
                children: filteredRestraunts.map(function(restraunt) {
                    var _restraunt_info, _restraunt_info1;
                    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $fc41d09ddc03e3ec$export$a6c7ac8248d6e38a), {
                        to: "/restraunt/" + (restraunt === null || restraunt === void 0 ? void 0 : (_restraunt_info = restraunt.info) === null || _restraunt_info === void 0 ? void 0 : _restraunt_info.id),
                        children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $a45998a327f72e36$export$2e2bcd8739ae039), (0, $e1f0c9b9d3f0410c$export$581ff339ea0ba762)({}, restraunt === null || restraunt === void 0 ? void 0 : restraunt.info))
                    }, restraunt === null || restraunt === void 0 ? void 0 : (_restraunt_info1 = restraunt.info) === null || _restraunt_info1 === void 0 ? void 0 : _restraunt_info1.id);
                })
            })
        ]
    });
};
var $2329a7d01fd643e5$export$2e2bcd8739ae039 = $2329a7d01fd643e5$var$Body;





var $d0dd0abe4eb5c299$var$About = function() {
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        className: "about-container",
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                className: "about-left",
                children: [
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("h1", {
                        children: [
                            "Welcome to ",
                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("br", {}),
                            " The world of ",
                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("br", {}),
                            " ",
                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("span", {
                                children: "Tasty & Fresh Food"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("h4", {
                        children: [
                            '"Better you will feel if you eat a Food from \xa0',
                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("span", {
                                children: "Foodie"
                            }),
                            ' menu"'
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "about-right",
                children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("img", {
                    src: (0, $1ad00fd5a6f8ced9$export$8878ead86ed0da0b),
                    alt: "Food Image"
                })
            })
        ]
    });
};
var $d0dd0abe4eb5c299$export$2e2bcd8739ae039 = $d0dd0abe4eb5c299$var$About;





var $dQFEZ = parcelRequire("dQFEZ");

var $5bfacf24163884ca$var$ContactUs = function() {
    var _useState = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)((0, $dQFEZ.useState)(false), 2), message = _useState[0], setMessage = _useState[1];
    var handleSubmit = function(e) {
        e.preventDefault();
        setMessage(true);
    };
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        className: "contact-container",
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "contact-left",
                children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("img", {
                    src: (0, $1ad00fd5a6f8ced9$export$d5ef6164957048b8),
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                className: "contact-right",
                children: [
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("h1", {
                        children: "Contact us"
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("form", {
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("input", {
                                type: "text",
                                placeholder: "Name",
                                required: true
                            }),
                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("input", {
                                type: "email",
                                placeholder: "Email",
                                required: true
                            }),
                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("textarea", {
                                placeholder: "Type your Message here...",
                                required: true
                            }),
                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("button", {
                                type: "submit",
                                children: "Submit"
                            }),
                            message && /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("span", {
                                children: "Thanks for contacting FoodFire, We will reply ASAP."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $5bfacf24163884ca$export$2e2bcd8739ae039 = $5bfacf24163884ca$var$ContactUs;




var $40abe9f2ee6f03b3$var$Error = function() {
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("h1", {
                children: "Oooops!!! Something is wrong"
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("img", {
                className: "err-img",
                src: (0, $1ad00fd5a6f8ced9$export$db8df6be5e4ba8bc)
            })
        ]
    });
};
var $40abe9f2ee6f03b3$export$2e2bcd8739ae039 = $40abe9f2ee6f03b3$var$Error;







var $dQFEZ = parcelRequire("dQFEZ");



var $79275a82abf189f4$var$RestrauntMenu = function() {
    var _resInfo_cuisines, _resInfo_sla;
    var resId = (0, $8c3ad80f8a436e0f$export$99eaa27ddbbb95ef)().resId; // call useParams and get value of restaurant id using object destructuring
    var _useState = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)((0, $dQFEZ.useState)(null), 2), resInfo = _useState[0], setResInfo = _useState[1]; // call useState to store the api data in res
    var _useState1 = (0, $1bb6f341c8f857d6$export$fdf2a89c76341bbf)((0, $dQFEZ.useState)([]), 2), menuItems = _useState1[0], setMenuItems = _useState1[1];
    (0, $dQFEZ.useEffect)(function() {
        fetchMenu();
    }, []);
    var fetchMenu = function() {
        var _ref = (0, $baf9b2a64fedef68$export$7c398597f8905a1)(function() {
            var _json_data_cards_map_find, _json_data_cards_map, _json_data, _json_data_cards, _json_data_cards_map_find_card, _json_data_cards_find_groupedCard_cardGroupMap_REGULAR_cards_map_filter, _json_data_cards_find_groupedCard_cardGroupMap_REGULAR_cards_map, _json_data_cards_find, _json_data1, _json_data_cards_find_groupedCard, _json_data_cards_find_groupedCard_cardGroupMap, _json_data_cards_find_groupedCard_cardGroupMap_REGULAR, _json_data_cards_find_groupedCard_cardGroupMap_REGULAR_cards, response, json, restrauantData, menuItemsData, uniqueMenuItems;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch((0, $1ad00fd5a6f8ced9$export$f9288df19face69b) + resId)
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        json = _state.sent();
                        console.log(json);
                        restrauantData = ((_json_data_cards_map_find = (_json_data_cards_map = json === null || json === void 0 ? void 0 : (_json_data = json.data) === null || _json_data === void 0 ? void 0 : (_json_data_cards = _json_data.cards) === null || _json_data_cards === void 0 ? void 0 : _json_data_cards.map(function(x) {
                            return x.card;
                        })) === null || _json_data_cards_map === void 0 ? void 0 : _json_data_cards_map.find(function(x) {
                            return x && x.card["@type"] === (0, $1ad00fd5a6f8ced9$export$4a3a00b9ff5cf3da);
                        })) === null || _json_data_cards_map_find === void 0 ? void 0 : (_json_data_cards_map_find_card = _json_data_cards_map_find.card) === null || _json_data_cards_map_find_card === void 0 ? void 0 : _json_data_cards_map_find_card.info) || null;
                        setResInfo(restrauantData);
                        menuItemsData = ((_json_data_cards_find_groupedCard_cardGroupMap_REGULAR_cards_map_filter = (_json_data_cards_find_groupedCard_cardGroupMap_REGULAR_cards_map = (_json_data_cards_find = json === null || json === void 0 ? void 0 : (_json_data1 = json.data) === null || _json_data1 === void 0 ? void 0 : _json_data1.cards.find(function(x) {
                            return x.groupedCard;
                        })) === null || _json_data_cards_find === void 0 ? void 0 : (_json_data_cards_find_groupedCard = _json_data_cards_find.groupedCard) === null || _json_data_cards_find_groupedCard === void 0 ? void 0 : (_json_data_cards_find_groupedCard_cardGroupMap = _json_data_cards_find_groupedCard.cardGroupMap) === null || _json_data_cards_find_groupedCard_cardGroupMap === void 0 ? void 0 : (_json_data_cards_find_groupedCard_cardGroupMap_REGULAR = _json_data_cards_find_groupedCard_cardGroupMap.REGULAR) === null || _json_data_cards_find_groupedCard_cardGroupMap_REGULAR === void 0 ? void 0 : (_json_data_cards_find_groupedCard_cardGroupMap_REGULAR_cards = _json_data_cards_find_groupedCard_cardGroupMap_REGULAR.cards) === null || _json_data_cards_find_groupedCard_cardGroupMap_REGULAR_cards === void 0 ? void 0 : _json_data_cards_find_groupedCard_cardGroupMap_REGULAR_cards.map(function(x) {
                            var _x_card;
                            return (_x_card = x.card) === null || _x_card === void 0 ? void 0 : _x_card.card;
                        })) === null || _json_data_cards_find_groupedCard_cardGroupMap_REGULAR_cards_map === void 0 ? void 0 : _json_data_cards_find_groupedCard_cardGroupMap_REGULAR_cards_map.filter(function(x) {
                            return x["@type"] == (0, $1ad00fd5a6f8ced9$export$138fdc351675302c);
                        })) === null || _json_data_cards_find_groupedCard_cardGroupMap_REGULAR_cards_map_filter === void 0 ? void 0 : _json_data_cards_find_groupedCard_cardGroupMap_REGULAR_cards_map_filter.map(function(x) {
                            return x.itemCards;
                        }).flat().map(function(x) {
                            var _x_card;
                            return (_x_card = x.card) === null || _x_card === void 0 ? void 0 : _x_card.info;
                        })) || [];
                        uniqueMenuItems = [];
                        menuItemsData.forEach(function(item) {
                            if (!uniqueMenuItems.find(function(x) {
                                return x.id === item.id;
                            })) uniqueMenuItems.push(item);
                        });
                        setMenuItems(uniqueMenuItems);
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchMenu() {
            return _ref.apply(this, arguments);
        };
    }();
    return resInfo === null ? /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $6d7015cc26664087$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        className: "restaurant-menu",
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                className: "restaurant-summary",
                children: [
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("img", {
                        className: "restaurant-img",
                        src: (0, $1ad00fd5a6f8ced9$export$3c67ec6258c4a827) + (resInfo === null || resInfo === void 0 ? void 0 : resInfo.cloudinaryImageId),
                        alt: resInfo === null || resInfo === void 0 ? void 0 : resInfo.name
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                        className: "restaurant-summary-details",
                        children: [
                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("h2", {
                                className: "restaurant-title",
                                children: resInfo === null || resInfo === void 0 ? void 0 : resInfo.name
                            }),
                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("p", {
                                className: "restaurant-tags",
                                children: resInfo === null || resInfo === void 0 ? void 0 : (_resInfo_cuisines = resInfo.cuisines) === null || _resInfo_cuisines === void 0 ? void 0 : _resInfo_cuisines.join(", ")
                            }),
                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                                className: "restaurant-details",
                                children: [
                                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                                        className: "restaurant-rating",
                                        style: (resInfo === null || resInfo === void 0 ? void 0 : resInfo.avgRating) < 4 ? {
                                            backgroundColor: "var(--light-red)"
                                        } : (resInfo === null || resInfo === void 0 ? void 0 : resInfo.avgRating) === "--" ? {
                                            backgroundColor: "white",
                                            color: "black"
                                        } : {
                                            color: "white"
                                        },
                                        children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("span", {
                                            children: [
                                                resInfo === null || resInfo === void 0 ? void 0 : resInfo.avgRating,
                                                " \xa0⭐"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                                        className: "restaurant-rating-slash",
                                        children: "|"
                                    }),
                                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                                        children: resInfo === null || resInfo === void 0 ? void 0 : (_resInfo_sla = resInfo.sla) === null || _resInfo_sla === void 0 ? void 0 : _resInfo_sla.slaString
                                    }),
                                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                                        className: "restaurant-rating-slash",
                                        children: "|"
                                    }),
                                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                                        children: [
                                            resInfo === null || resInfo === void 0 ? void 0 : resInfo.costForTwoMessage,
                                            " \xa0\uD83D\uDCB8"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "restaurant-menu-content",
                children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                    className: "menu-items-container",
                    children: [
                        /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                            className: "menu-title-wrap",
                            children: [
                                /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("h3", {
                                    className: "menu-title",
                                    children: "Recommended"
                                }),
                                /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("p", {
                                    className: "menu-count",
                                    children: [
                                        menuItems.length,
                                        " ITEMS"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                            className: "menu-items-list",
                            children: menuItems.map(function(item) {
                                /*#__PURE__*/ return (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                                    className: "menu-item",
                                    children: [
                                        /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                                            className: "menu-item-details",
                                            children: [
                                                /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("h3", {
                                                    className: "item-title",
                                                    children: item === null || item === void 0 ? void 0 : item.name
                                                }),
                                                /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("p", {
                                                    className: "item-cost",
                                                    children: (item === null || item === void 0 ? void 0 : item.price) > 0 ? new Intl.NumberFormat("en-IN", {
                                                        style: "currency",
                                                        currency: "INR"
                                                    }).format((item === null || item === void 0 ? void 0 : item.price) / 100) : " "
                                                }),
                                                /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("p", {
                                                    className: "item-desc",
                                                    children: item === null || item === void 0 ? void 0 : item.description
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                                            className: "menu-img-wrapper",
                                            children: [
                                                (item === null || item === void 0 ? void 0 : item.imageId) && /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("img", {
                                                    className: "menu-item-img",
                                                    src: (0, $1ad00fd5a6f8ced9$export$3c5a5d8e1e203ce0) + (item === null || item === void 0 ? void 0 : item.imageId),
                                                    alt: item === null || item === void 0 ? void 0 : item.name
                                                }),
                                                /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("button", {
                                                    className: "add-btn",
                                                    children: " ADD +"
                                                })
                                            ]
                                        })
                                    ]
                                }, item === null || item === void 0 ? void 0 : item.id);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $79275a82abf189f4$export$2e2bcd8739ae039 = $79275a82abf189f4$var$RestrauntMenu;



var $79e06ce5914f528c$var$Footer = function() {
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        className: "footer",
        children: [
            "Created with ❤️ by \xa0",
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("a", {
                href: "https://www.linkedin.com/in/ashutosh-shukla-451183199/",
                target: "_blank",
                title: "Ashutosh's Linkedin Profile",
                children: "Ashutosh shukla \uD83D\uDE80\uD83D\uDE80"
            })
        ]
    });
};
var $79e06ce5914f528c$export$2e2bcd8739ae039 = $79e06ce5914f528c$var$Footer;


//component composition!
var $ed4c08b9c8362271$var$AppLayout = function() {
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        className: "app",
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $7fd29bc6f1b71fd8$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $8c3ad80f8a436e0f$export$910ae8079b2c2852), {}),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $79e06ce5914f528c$export$2e2bcd8739ae039), {})
        ]
    });
};
var $ed4c08b9c8362271$var$appRouter = (0, $fc41d09ddc03e3ec$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)($ed4c08b9c8362271$var$AppLayout, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $2329a7d01fd643e5$export$2e2bcd8739ae039), {})
            },
            {
                path: "/about",
                element: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $d0dd0abe4eb5c299$export$2e2bcd8739ae039), {})
            },
            {
                path: "/contact",
                element: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $5bfacf24163884ca$export$2e2bcd8739ae039), {})
            },
            {
                path: "/restraunt/:resId",
                element: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $79275a82abf189f4$export$2e2bcd8739ae039), {})
            }
        ],
        errorElement: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $40abe9f2ee6f03b3$export$2e2bcd8739ae039), {})
    }
]);
var $ed4c08b9c8362271$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($8dbfa3fee6dc40a7$exports))).createRoot(document.getElementById("root"));
$ed4c08b9c8362271$var$root.render(/*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $8c3ad80f8a436e0f$export$323e4fc2fa4753fb), {
    router: $ed4c08b9c8362271$var$appRouter
}));

})();
//# sourceMappingURL=index.8658fafa.js.map
